import React, { useState, useEffect } from 'react';
import api, { atelierAPI, API_URL, getServerUrl } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import {
  Wrench, Plus, X, Save, Eye, Check, Package,
  Calendar, Clock, User, AlertCircle, FileText, Trash2, Edit,
  CheckCircle, DollarSign, BarChart3, Play, TrendingDown,
  Search, RefreshCw, Printer, ChevronDown, ChevronUp, Gem, Flame, Scale, LayoutGrid, Coins
} from 'lucide-react';
// import ControleQualite from './ControleQualite';
// import ConsommationMatieres from './ConsommationMatieres';
// import TempsTravail from './TempsTravail';
// import RapportProduction from './RapportProduction';
// §95 cleanup : GestionEquipe + GestionOuvriers + SuiviOuvriersProduction + CoffresOuvriers
// retires - doublons UI avec /ouvriers (composant OuvriersComplet.js)
import AtelierKanban from './AtelierKanban';
import ParcoursOF from './ParcoursOF';
import CompteMetal from './CompteMetal';
import AchatsOr from './AchatsOr';
import CommandeProductionClient from './CommandeProductionClient';
import SuiviFicheChef from './SuiviFicheChef';
import Barcode from '../Common/Barcode';
import ControleFinalModal from './ControleFinalModal';
import FicheFabrication from './FicheFabrication';
import FicheFabricationV2 from './FicheFabricationV2';
import FicheBijouTermine from './FicheBijouTermine';
import EditOrdreModal from './EditOrdreModal';

function Atelier() {
  const { isAdmin, isAtelier, user } = useAuth();
  // Compte Métal : visible {admin, chef_atelier} seulement (gate serveur couts_required)
  const canMetal = user?.role === 'admin' || user?.role === 'chef_atelier';
  // Patch 48 / Mission A : modal etape ad-hoc
  const [showAdhocModal, setShowAdhocModal] = useState(false);
  const [adhocForm, setAdhocForm] = useState({ nom_etape: '', type_ressource: 'interne', duree_estimee_heures: 1 });
  const [adhocSaving, setAdhocSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('ordres');
  const [isFinJournee, setIsFinJournee] = useState(() => localStorage.getItem('atelier_fin_journee') === '1');
  const [ordres, setOrdres] = useState([]);
  const [composants, setComposants] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalDevis, setShowModalDevis] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedOrdre, setSelectedOrdre] = useState(null);
  // Hotfix controle-final UX : modal partage remplace prompt() + alert()
  const [showControleFinalModal, setShowControleFinalModal] = useState(false);
  const [controleFinalOfId, setControleFinalOfId] = useState(null);
  const [expandedOrdreId, setExpandedOrdreId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [showTerminerModal, setShowTerminerModal] = useState(false);
  const [etapeATerminer, setEtapeATerminer] = useState(null);
  const [matieres, setMatieres] = useState([]);
  const [stockOuvrier, setStockOuvrier] = useState([]);
  const [ouvriersDisponibles, setOuvriersDisponibles] = useState([]);
  const [ouvrierSelectionne, setOuvrierSelectionne] = useState('');
  const [matieresUtilisees, setMatieresUtilisees] = useState([{ matiere_id: '', quantite: '', notes: '' }]);
  const [tempsReel, setTempsReel] = useState('');       // minutes du compteur (auto)
  const [tempsCorrection, setTempsCorrection] = useState('0'); // minutes à ajouter manuellement
  const [poidsMetalReel, setPoidsMetalReel] = useState('');
  // §77 - Modal Terminer : poids bijou apres etape (or recu, pesee retour)
  const [poidsBijouApres, setPoidsBijouApres] = useState('');
  // §81 - poids total bijou (or + pierres + poincon) si etape avec_pierres
  const [poidsTotalBijou, setPoidsTotalBijou] = useState('');
  // §82 - Or donne editable modal (prefill cascade)
  const [orDonneModal, setOrDonneModal] = useState('');
  // "Proposer l'étape suivante" (18/06/2026) — modale non bloquante après Terminer
  const [showEnchainerModal, setShowEnchainerModal] = useState(false);
  const [etapeSuivante, setEtapeSuivante] = useState(null);
  const [enchainerOuvrierId, setEnchainerOuvrierId] = useState('');
  const [enchainerPoids, setEnchainerPoids] = useState('');
  const [enchainerOrdreId, setEnchainerOrdreId] = useState(null);
  const [enchainerBusy, setEnchainerBusy] = useState(false);
  const [showFicheFabrication, setShowFicheFabrication] = useState(false);
  const [showFicheBijouTermine, setShowFicheBijouTermine] = useState(false);
  const [imagePrincipale, setImagePrincipale] = useState(null);
  const [bijouLie, setBijouLie] = useState(null);
  const [modeCreation, setModeCreation] = useState('devis'); // 'devis' ou 'bijou'
  const [bijouxExistants, setBijouxExistants] = useState([]);
  const [bijouSelectionne, setBijouSelectionne] = useState(null);
  const [matieresSelectionnees, setMatieresSelectionnees] = useState([]);
  const [pierresSelectionnees, setPierresSelectionnees] = useState([]);
  // §88 - pierre manuelle ajout modal Terminer
  const [pierreManuelle, setPierreManuelle] = useState({ type_pierre: '', quantite: 1, poids_unitaire_carats: 0 });
  
  // Fonte / Pierres / Checklist
  const [fonte, setFonte] = useState({});
  const [pierresOF, setPierresOF] = useState([]);
  const [checklist, setChecklist] = useState([]);
  const [nouvellePierre, setNouvellePierre] = useState({ reference_pierre: '', type_pierre: '', quantite: 1, poids_carats: '', prix_achat_carat: '', sertisseur: '', observation: '', stock_id: null, stock_disponible: null, designation: '' });
  const [ajoutPierreOpen, setAjoutPierreOpen] = useState(false);
  const [pierreSuggestions, setPierreSuggestions] = useState([]);
  const [showPierreSuggestions, setShowPierreSuggestions] = useState(false);
  const [savingFonte, setSavingFonte] = useState(false);
  const [editingNotes, setEditingNotes] = useState(false);
  const [notesValue, setNotesValue] = useState('');

  // Edit ordre avant lancement
  const [editOrdre, setEditOrdre] = useState(null);

  // Pièces individuelles dans un OF
  const [piecesOf, setPiecesOf] = useState({}); // { ordre_id: [...pieces] }
  const [loadingPieces, setLoadingPieces] = useState(null);

  // V2.Z 13/05/2026 : Suivi or par etape + perte cumulee
  const [pertesOr, setPertesOr] = useState({}); // { of_id: { perte_totale_g, etapes, ... } }
  // V2.Z 13/05/2026 : Reassignation ouvrier - track etape en mode reassign
  const [reassigningEtapeId, setReassigningEtapeId] = useState(null);

  // §74 13/05/2026 : Or donne par etape (edit local + save sur blur)
  const [poidsOrDonneLocal, setPoidsOrDonneLocal] = useState({});

  // §84 14/05/2026 : Pierres v2 - editor inline par etape
  const [pierresDevisOF, setPierresDevisOF] = useState([]); // pierres devis OF courant
  const [pierresLocalState, setPierresLocalState] = useState({}); // {etapeId: [pierres array]}
  // §104 20/05/2026 : UX pierres enrichie - prevues OF + picker stock
  const [stockPickerEtapeId, setStockPickerEtapeId] = useState(null); // etape qui ouvre modal picker stock
  const [stockPierresList, setStockPierresList] = useState([]); // cache stock categorie=PIERRE
  const [stockPickerSearch, setStockPickerSearch] = useState('');
  const [stockPickerLoading, setStockPickerLoading] = useState(false);

  // §104 - charger stock pierres au besoin
  const loadStockPierres = async () => {
    if (stockPierresList.length > 0) return; // cache hit
    setStockPickerLoading(true);
    try {
      const res = await fetch(`${API_URL}/stock-matieres/stock?categorie=PIERRE`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (res.ok) {
        const data = await res.json();
        const filtered = (data || []).filter(s => parseFloat(s.quantite_disponible || 0) > 0);
        setStockPierresList(filtered);
        console.log('§104 stock pierres charge', { count: filtered.length });
      } else {
        console.error('§104 stock pierres load failed', res.status);
      }
    } catch (e) {
      console.error('§104 stock pierres reseau error', e);
    } finally {
      setStockPickerLoading(false);
    }
  };

  // §104 - ouvrir modal picker stock pour une etape
  const ouvrirStockPicker = async (etapeId) => {
    await loadStockPierres();
    setStockPickerSearch('');
    setStockPickerEtapeId(etapeId);
  };

  // §104 - ajouter pierre stock selectionnee a etape
  const ajouterPierreStock = (etapeId, stockItem) => {
    setPierresLocalState(prev => {
      const list = [...(prev[etapeId] || []), {
        source: 'stock',
        stock_id: stockItem.id,
        reference: stockItem.reference,
        type_pierre: stockItem.designation || stockItem.type_matiere || 'PIERRE',
        taille_qualite: stockItem.taille_qualite,
        certificat: stockItem.numero_certificat,
        quantite: 1,
        qte_remise: 1,
        poids_carats: stockItem.taille_qualite ? null : null, // user saisit
        prix_achat_carat: stockItem.prix_achat_carat,
        selected: true
      }];
      return { ...prev, [etapeId]: list };
    });
    setStockPickerEtapeId(null);
  };

  const loadPierresDevisOF = async (ordreId) => {
    try {
      const res = await fetch(`${API_URL}/atelier/of/${ordreId}/pierres-disponibles`);
      if (res.ok) {
        const data = await res.json();
        setPierresDevisOF(data.pierres_devis || []);
      }
    } catch (e) { console.error('load pierres devis', e); }
  };

  const initPierresEtape = (etape) => {
    // Init local state pour l'etape depuis pierres_remises_json ou devis pre-cochees
    // §106 20/05/2026 - fix race : ne retourner cache que s'il contient quelque chose
    // (sinon premier render avec pierresDevisOF=[] cacherait [] et bloquerait re-init).
    if (pierresLocalState[etape.id]?.length) return pierresLocalState[etape.id];
    let pierres = [];
    if (etape.pierres_remises_json) {
      try {
        pierres = typeof etape.pierres_remises_json === 'string'
          ? JSON.parse(etape.pierres_remises_json)
          : etape.pierres_remises_json;
      } catch { pierres = []; }
    }
    if (!pierres.length && pierresDevisOF.length) {
      // Pre-cocher pierres devis par defaut
      // §104 : ajout qte_prevue (readonly) + qte_remise (editable, default = prevue)
      pierres = pierresDevisOF.map(p => {
        const qte_prevue = p.nb_pierres || 1;
        const poids_total = p.poids_total_carats != null ? parseFloat(p.poids_total_carats) : null;
        // poids unitaire = total / nb_pierres
        const poids_unitaire = (poids_total != null && qte_prevue > 0) ? +(poids_total / qte_prevue).toFixed(4) : null;
        return {
          source: 'devis',
          dms_id: p.dms_id,
          stock_matiere_id: p.stock_matiere_id,
          type_pierre: p.designation || p.type_matiere || '',
          reference: p.reference,
          taille_qualite: p.taille_qualite,
          certificat: p.numero_certificat,
          qte_prevue,
          quantite: qte_prevue,    // qte remise default = prevue
          qte_remise: qte_prevue,  // alias explicite (compatibility downstream)
          poids_carats: poids_unitaire, // unitaire pour edition
          poids_total_prevu: poids_total,
          prix_achat_carat: p.prix_achat_carat,
          selected: true
        };
      });
    }
    // §106 - ne pas ecrire cache vide (sinon bloque re-init quand pierresDevisOF arrive plus tard)
    if (pierres.length) {
      setPierresLocalState(prev => ({ ...prev, [etape.id]: pierres }));
    }
    return pierres;
  };

  const updatePierreEtape = (etapeId, idx, field, val) => {
    setPierresLocalState(prev => {
      const list = (prev[etapeId] || []).map((p, j) => j === idx ? { ...p, [field]: val } : p);
      return { ...prev, [etapeId]: list };
    });
  };

  const togglePierreEtape = (etapeId, idx, checked) => {
    setPierresLocalState(prev => {
      const list = (prev[etapeId] || []).map((p, j) => j === idx ? { ...p, selected: checked } : p);
      return { ...prev, [etapeId]: list };
    });
  };

  const ajouterPierreManuelleEtape = (etapeId) => {
    setPierresLocalState(prev => {
      const list = [...(prev[etapeId] || []), {
        source: 'manuel', type_pierre: '', quantite: 1, qte_remise: 1,
        poids_carats: null, selected: true
      }];
      return { ...prev, [etapeId]: list };
    });
  };

  const removePierreEtape = (etapeId, idx) => {
    setPierresLocalState(prev => {
      const list = (prev[etapeId] || []).filter((_, j) => j !== idx);
      return { ...prev, [etapeId]: list };
    });
  };

  // §103 20/05/2026 - Resoudre etape_production.id correct depuis etape_devis.
  // Root cause BE : routes/atelier.py prod_par_nom dict-by-name peut ne pas matcher
  // (whitespace/casing/accent) -> etape_devis.id reste = dcf.id qui peut coincider
  // avec un autre etapes_production.id different. PUT cible mauvaise etape.
  // Fix FE : cross-reference selectedOrdre.etapes (etapes_production brut) par nom_etape.
  const resolveEtapeProductionId = (etapeDevis) => {
    if (!etapeDevis) return null;
    const etapesProd = selectedOrdre?.etapes || [];
    const norm = s => (s || '').trim().toLowerCase();
    // 1. Direct match : etape.id existe dans etapes_production -> OK
    const directMatch = etapesProd.find(e => e.id === etapeDevis.id);
    if (directMatch && norm(directMatch.nom_etape) === norm(etapeDevis.nom_etape)) {
      return etapeDevis.id;
    }
    // 2. Fallback par nom_etape (cas bug BE prod_par_nom)
    const byName = etapesProd.find(e => norm(e.nom_etape) === norm(etapeDevis.nom_etape));
    if (byName) {
      if (byName.id !== etapeDevis.id) {
        console.warn('§103 etape.id mismatch corrige via nom_etape', {
          devis_id: etapeDevis.id,
          prod_id: byName.id,
          nom_etape: etapeDevis.nom_etape
        });
      }
      return byName.id;
    }
    // 3. Aucun match : log + fallback original
    console.error('§103 etape introuvable dans etapes_production', {
      etapeDevis,
      etapesProdCount: etapesProd.length
    });
    return etapeDevis.id;
  };

  // §102 20/05/2026 - Reprise pattern §87 sur savePierresEtape (optimistic + await reload)
  // §103 20/05/2026 - Resoudre etape_production.id correct avant PUT
  // §104 20/05/2026 - Format JSON unifie : devis/manuel/stock + qte_prevue/qte_remise
  const savePierresEtape = async (etape) => {
    const targetEtapeId = resolveEtapeProductionId(etape);
    const list = pierresLocalState[etape.id] || [];
    // §104 - normaliser format avant envoi : conserver source + ids + qte_prevue/qte_remise
    const filtered = list
      .filter(p => p.selected !== false && (p.type_pierre || '').trim())
      .map(p => {
        const qteRemise = p.qte_remise != null ? parseInt(p.qte_remise) : (parseInt(p.quantite) || 1);
        const base = {
          source: p.source || 'manuel',
          type_pierre: (p.type_pierre || '').trim(),
          quantite: qteRemise,     // legacy alias = qte_remise
          qte_remise: qteRemise,
          poids_carats: p.poids_carats != null ? parseFloat(p.poids_carats) : null,
          selected: true
        };
        if (p.source === 'devis') {
          base.dms_id = p.dms_id;
          base.stock_matiere_id = p.stock_matiere_id;
          base.reference = p.reference;
          base.taille_qualite = p.taille_qualite;
          base.certificat = p.certificat;
          base.qte_prevue = p.qte_prevue;
          base.poids_total_prevu = p.poids_total_prevu;
          base.prix_achat_carat = p.prix_achat_carat;
        } else if (p.source === 'stock') {
          base.stock_id = p.stock_id;
          base.reference = p.reference;
          base.taille_qualite = p.taille_qualite;
          base.certificat = p.certificat;
          base.prix_achat_carat = p.prix_achat_carat;
        }
        return base;
      });
    console.log('🎯 savePierresEtape §104', { displayEtapeId: etape.id, targetEtapeId, count: filtered.length, pierres: filtered });
    // Optimistic : mettre a jour selectedOrdre.etapes_devis + etapes avec pierres_remises_json
    setSelectedOrdre(prev => {
      if (!prev) return prev;
      const pierresJson = filtered.length ? JSON.stringify(filtered) : null;
      const updateEtape = e => (e.id === etape.id || e.id === targetEtapeId) ? { ...e, avec_pierres: true, pierres_remises_json: pierresJson } : e;
      return {
        ...prev,
        etapes: Array.isArray(prev.etapes) ? prev.etapes.map(updateEtape) : prev.etapes,
        etapes_devis: Array.isArray(prev.etapes_devis) ? prev.etapes_devis.map(updateEtape) : prev.etapes_devis
      };
    });
    try {
      const res = await fetch(`${API_URL}/atelier/etapes/${targetEtapeId}/avec-pierres`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({
          avec_pierres: true,
          pierres_remises: filtered,
          propagate: true
        })
      });
      const data = await res.json();
      if (!res.ok) {
        console.error('❌ savePierresEtape failed', res.status, data);
        alert('Erreur: ' + (data.error || 'inconnu'));
        // Restore state via reload
        const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
        if (ordreId) await loadOrdreDetails(ordreId);
        return;
      }
      console.log('✓ PUT 200 savePierresEtape', data);
      alert(`Pierres sauvegardees. ${data.propagated || 0} etape(s) suivante(s) heritees.`);
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) {
        await loadOrdreDetails(ordreId);
        console.log('✓ OF refreshed apres savePierresEtape');
      }
    } catch (e) {
      console.error('❌ Erreur reseau savePierresEtape', e);
      alert('Erreur reseau: ' + e.message);
    }
  };
  // §87 14/05/2026 - Toggle avec_pierres + save pierres_remises avec optimistic update + reload OF
  const saveEtapeAvecPierres = async (etapeId, avecPierres, pierresRemises) => {
    console.log('🎯 saveEtapeAvecPierres', { etapeId, avecPierres, pierresRemises });
    // Optimistic update local selectedOrdre.etapes pour reflechir immediatement
    setSelectedOrdre(prev => {
      if (!prev) return prev;
      const updateEtape = e => e.id === etapeId ? {
        ...e,
        ...(avecPierres !== undefined ? { avec_pierres: avecPierres } : {}),
        ...(pierresRemises !== undefined ? { pierres_remises_json: pierresRemises ? JSON.stringify(pierresRemises) : null } : {})
      } : e;
      return {
        ...prev,
        etapes: Array.isArray(prev.etapes) ? prev.etapes.map(updateEtape) : prev.etapes,
        etapes_devis: Array.isArray(prev.etapes_devis) ? prev.etapes_devis.map(updateEtape) : prev.etapes_devis
      };
    });

    try {
      const body = {};
      if (avecPierres !== undefined) body.avec_pierres = avecPierres;
      if (pierresRemises !== undefined) body.pierres_remises = pierresRemises;
      const res = await fetch(`${API_URL}/atelier/etapes/${etapeId}/avec-pierres`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        console.error('❌ saveEtapeAvecPierres failed', res.status, errData);
        alert(`Erreur save avec_pierres: ${errData.error || res.status}`);
        // Restore state via reload
        const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
        if (ordreId) loadOrdreDetails(ordreId);
        return;
      }
      const data = await res.json();
      console.log('✓ PUT 200 saveEtapeAvecPierres', data);
      // Reload OF complet pour confirmer + propagated count
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) {
        await loadOrdreDetails(ordreId);
        console.log('✓ OF refreshed apres avec-pierres');
      }
    } catch (e) {
      console.error('❌ Erreur reseau save avec_pierres', e);
      alert('Erreur reseau: ' + e.message);
    }
  };

  const savePoidsOrEtape = async (etapeId, field, value) => {
    if (value === '' || value == null) return;
    try {
      await api.put(`${API_URL}/atelier/etapes/${etapeId}/poids-or`, {
        [field]: parseFloat(value)
      });
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) loadOrdreDetails(ordreId);
    } catch (err) {
      console.error('Erreur save poids or', err);
    }
  };
  const suggestOrDonne = (etape, allEtapes, of) => {
    // §75 cascade : valeur existante > etape precedente > devis OF > bijou > null
    if (etape.poids_or_donne != null) return parseFloat(etape.poids_or_donne);
    // Etape precedente : sort par numero_etape desc < courant
    const prevCandidates = (allEtapes || [])
      .filter(e => (e.numero_etape || 0) < (etape.numero_etape || 1))
      .sort((a, b) => (b.numero_etape || 0) - (a.numero_etape || 0));
    for (const p of prevCandidates) {
      if (p.poids_or_recu != null) return parseFloat(p.poids_or_recu);
      if (p.poids_bijou_etape != null) return parseFloat(p.poids_bijou_etape);
    }
    // Premiere etape : fallback OF/bijou
    if (of) {
      if (of.poids_or_initial != null) return parseFloat(of.poids_or_initial);
      if (of.poids_or_estime != null) return parseFloat(of.poids_or_estime);
      if (of.poids_metal != null) return parseFloat(of.poids_metal);
      if (of.poids_metal_net != null) return parseFloat(of.poids_metal_net);
      if (of.bijou_poids != null) return parseFloat(of.bijou_poids);
      if (of.bijou?.poids != null) return parseFloat(of.bijou.poids);
    }
    return null;
  };
  const loadPerteOr = async (ofId) => {
    try {
      const res = await fetch(`${API_URL}/atelier/of/${ofId}/perte-or`);
      if (res.ok) {
        const data = await res.json();
        setPertesOr(prev => ({ ...prev, [ofId]: data }));
      }
    } catch (e) { /* silent */ }
  };
  const [editingPiece, setEditingPiece] = useState(null); // { id, couleur_or, artisan_id, statut }
  const [ouvriersForPieces, setOuvriersForPieces] = useState([]);

  // États pour les filtres et recherche
  const [filtreStatut, setFiltreStatut] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [masquerTermines, setMasquerTermines] = useState(true);
  const [afficherNonRequis, setAfficherNonRequis] = useState(false);
  // Externe : { etapeId: nomPrestataire } pour saisie inline
  const [saisieExterne, setSaisieExterne] = useState({});

  const [formData, setFormData] = useState({
    reference_bijou: '',
    type_bijou: 'bague',
    description: '',
    client_nom: '',
    date_livraison_prevue: '',
    prix_estime: '',
    notes: '',
    composants: []
  });

  const [nouveauComposant, setNouveauComposant] = useState({
    composant_id: '',
    quantite_estimee: '',
    unite: 'g'
  });

  const typesBijoux = [
    'bague', 'collier', 'bracelet', 'boucles_oreilles', 
    'pendentif', 'broche', 'alliance', 'chevaliere'
  ];

  const unites = ['g', 'ct', 'pcs'];

  useEffect(() => {
    loadData();
    loadOuvriers();
    loadMatieres();
  }, []);

  // §105 20/05/2026 - Fix Phase A §104 : charger pierres devis au mount du modal detail OF.
  // Avant §105 : loadPierresDevisOF appele uniquement dans onClick expand row inline.
  // Consequence : pierresDevisOF vide quand modal ouvert sans expand prealable
  // -> initPierresEtape ne peut pas pre-cocher les pierres devis -> section "Aucune pierre".
  useEffect(() => {
    const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
    if (ordreId) {
      loadPierresDevisOF(ordreId);
    }
  }, [selectedOrdre?.ordre?.id, selectedOrdre?.id]);

  // §106 20/05/2026 - Defense en profondeur : quand pierresDevisOF arrive (async apres mount),
  // re-init pierresLocalState pour les etapes avec_pierres qui n'ont PAS encore de cache valide.
  // Garantit que pierres devis pre-cochees apparaissent meme si initPierresEtape s'est execute
  // avec pierresDevisOF vide au 1er render.
  useEffect(() => {
    if (!pierresDevisOF.length) return;
    const etapesList = selectedOrdre?.etapes_devis || selectedOrdre?.etapes || [];
    if (!etapesList.length) return;
    const mapped = pierresDevisOF.map(p => {
      const qte_prevue = p.nb_pierres || 1;
      const poids_total = p.poids_total_carats != null ? parseFloat(p.poids_total_carats) : null;
      const poids_unitaire = (poids_total != null && qte_prevue > 0) ? +(poids_total / qte_prevue).toFixed(4) : null;
      return {
        source: 'devis',
        dms_id: p.dms_id,
        stock_matiere_id: p.stock_matiere_id,
        type_pierre: p.designation || p.type_matiere || '',
        reference: p.reference,
        taille_qualite: p.taille_qualite,
        certificat: p.numero_certificat,
        qte_prevue,
        quantite: qte_prevue,
        qte_remise: qte_prevue,
        poids_carats: poids_unitaire,
        poids_total_prevu: poids_total,
        prix_achat_carat: p.prix_achat_carat,
        selected: true
      };
    });
    setPierresLocalState(prev => {
      const next = { ...prev };
      let updated = 0;
      etapesList.forEach(e => {
        if (e?.avec_pierres && !(next[e.id] && next[e.id].length)) {
          // Pas de cache OU cache vide -> hydrater avec mapping devis
          next[e.id] = mapped;
          updated += 1;
        }
      });
      if (updated > 0) {
        console.log(`§106 re-init pierresLocalState : ${updated} etape(s) hydratee(s) depuis pierresDevisOF`);
      }
      return next;
    });
  }, [pierresDevisOF, selectedOrdre?.etapes_devis, selectedOrdre?.etapes]);

  const loadData = async () => {
    try {
      const [ordresRes, composantsRes] = await Promise.all([
        atelierAPI.getFabrication().catch(() => ({ data: [] })),
        atelierAPI.getComposants().catch(() => ({ data: [] }))
      ]);
      setOrdres(ordresRes.data || []);
      setComposants(composantsRes.data || []);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const loadOuvriers = async () => {
    try {
      const response = await api.get(`${API_URL}/atelier/ouvriers`);
      setOuvriersDisponibles(response.data || []);
      setOuvriersForPieces(response.data || []);
    } catch (error) {
      console.error('Erreur chargement ouvriers:', error);
    }
  };

  const loadPiecesOf = async (ordreId) => {
    setLoadingPieces(ordreId);
    try {
      const res = await api.get(`${API_URL}/atelier/ordres-fabrication/${ordreId}/enfants`);
      const enfants = res.data?.enfants || [];
      // Normaliser les champs pour compatibilité avec l'affichage
      const mapped = enfants.map(e => ({
        ...e,
        reference_piece: e.numero_ordre,
        numero_piece: e.piece_index || 1,
        ouvrier_nom: e.artisan_nom || e.ouvrier_nom || null,
        nb_etapes: parseInt(e.nb_etapes || 0),
        etapes_terminees: parseInt(e.etapes_terminees || 0),
      }));
      setPiecesOf(prev => ({ ...prev, [ordreId]: mapped }));
    } catch (e) {
      console.error('Erreur chargement pièces:', e);
    } finally {
      setLoadingPieces(null);
    }
  };

  const updatePiece = async (pieceId, changes) => {
    try {
      const res = await api.put(`${API_URL}/atelier/ordres-fabrication/${pieceId}/update-enfant`, changes);
      const updated = res.data?.enfant;
      if (updated) {
        const normalized = {
          ...updated,
          reference_piece: updated.numero_ordre,
          numero_piece: updated.piece_index || 1,
          ouvrier_nom: updated.artisan_nom || null,
          nb_etapes: parseInt(updated.nb_etapes || 0),
          etapes_terminees: parseInt(updated.etapes_terminees || 0),
        };
        setPiecesOf(prev => {
          const newState = { ...prev };
          for (const ordreId of Object.keys(newState)) {
            newState[ordreId] = newState[ordreId].map(p => p.id === pieceId ? { ...p, ...normalized } : p);
          }
          return newState;
        });
      }
      setEditingPiece(null);
    } catch (e) {
      console.error('Erreur mise à jour pièce:', e);
    }
  };

  const loadMatieres = async () => {
    try {
      const response = await api.get(`${API_URL}/atelier/matieres`);
      setMatieres(response.data || []);
    } catch (error) {
      console.error('Erreur chargement matières:', error);
    }
  };

  const loadStockOuvrier = async (ouvrierId) => {
    if (!ouvrierId) {
      setStockOuvrier([]);
      return;
    }
    try {
      const response = await api.get(`${API_URL}/atelier/ouvriers/${ouvrierId}/stock`);
      setStockOuvrier(response.data || []);
    } catch (error) {
      console.error('Erreur chargement stock ouvrier:', error);
      setStockOuvrier([]);
    }
  };

  // Inline edit temps réel par étape
  const [editingTempsEtapeId, setEditingTempsEtapeId] = useState(null);
  const [editingTempsValue, setEditingTempsValue] = useState('');

  const saveTempsEtape = async (etapeId) => {
    const mins = parseInt(editingTempsValue, 10);
    if (isNaN(mins) || mins < 0) { alert('Valeur invalide (minutes entières)'); return; }
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/atelier/etapes/${etapeId}/update-temps`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ temps_minutes: mins }),
      });
      if (res.ok) {
        setEditingTempsEtapeId(null);
        const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
        if (ordreId) await loadOrdreDetails(ordreId);
      } else {
        const err = await res.json();
        alert('Erreur: ' + (err.error || 'inconnue'));
      }
    } catch (e) {
      alert('Erreur réseau');
    }
  };

  // Timer live — base serveur (elapsed_seconds) + incrément client (évite décalage timezone)
  const [tickSec, setTickSec] = useState(0);
  const loadTimeRef = React.useRef(Date.now());
  useEffect(() => {
    loadTimeRef.current = Date.now();
    setTickSec(0);
    const t = setInterval(() => setTickSec(s => s + 1), 1000);
    return () => clearInterval(t);
  }, [selectedOrdre]); // reset quand on recharge les données

  const computeTemps = (etape) => {
    if (etape.statut !== 'en_cours' && etape.statut !== 'pause') return null;
    const base = etape.elapsed_seconds != null ? parseInt(etape.elapsed_seconds) : null;
    if (base === null) return null;
    // Pour pause : figé (base ne change pas)
    // Pour en_cours : base + secondes écoulées côté client depuis le dernier chargement
    const totalSec = etape.statut === 'pause' ? base : base + tickSec;
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    return `${h > 0 ? h + 'h ' : ''}${String(m).padStart(2,'0')}min ${String(s).padStart(2,'0')}s`;
  };

  const tempsEcoules = {}; // compatibilité

  const demarrerEtape = async (etapeId) => {
    try {
      await api.post(`${API_URL}/atelier/etapes/${etapeId}/demarrer`, {}, {
        headers: { 'Content-Type': 'application/json' }
      });
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) await loadOrdreDetails(ordreId);
      await loadData();
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors du démarrage de l\'étape');
    }
  };

  const pauserEtape = async (etapeId) => {
    try {
      await api.post(`${API_URL}/atelier/etapes/${etapeId}/pause`, {}, { headers: { 'Content-Type': 'application/json' } });
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) await loadOrdreDetails(ordreId);
    } catch (error) {
      alert('Erreur lors de la mise en pause');
    }
  };

  const reprendreEtape = async (etapeId) => {
    try {
      await api.post(`${API_URL}/atelier/etapes/${etapeId}/reprendre`, {}, { headers: { 'Content-Type': 'application/json' } });
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) await loadOrdreDetails(ordreId);
    } catch (error) {
      alert('Erreur lors de la reprise');
    }
  };

  const envoyerExterne = async (etapeId) => {
    const nomPrestataire = saisieExterne[etapeId] || '';
    try {
      await api.post(`${API_URL}/atelier/etapes/${etapeId}/envoyer-externe`,
        { prestataire_nom: nomPrestataire },
        { headers: { 'Content-Type': 'application/json' } }
      );
      setSaisieExterne(prev => { const s = {...prev}; delete s[etapeId]; return s; });
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) await loadOrdreDetails(ordreId);
      await loadData();
    } catch (error) {
      alert('Erreur envoi externe');
    }
  };

  const [showModalReception, setShowModalReception] = useState(false);
  const [etapeReception, setEtapeReception] = useState(null);
  const [formReception, setFormReception] = useState({ prix_reel_externe: '', poids_or_recu_externe: '' });

  const ouvrirModalReception = (etape) => {
    setEtapeReception(etape);
    setFormReception({ prix_reel_externe: etape.prix_unitaire || '', poids_or_recu_externe: '' });
    setShowModalReception(true);
  };

  const validerReception = async () => {
    if (!etapeReception) return;
    try {
      await api.post(`${API_URL}/atelier/etapes/${etapeReception.id}/receptionner-externe`, {
        prix_reel_externe: formReception.prix_reel_externe ? parseFloat(formReception.prix_reel_externe) : null,
        poids_or_recu_externe: formReception.poids_or_recu_externe ? parseFloat(formReception.poids_or_recu_externe) : null,
      }, { headers: { 'Content-Type': 'application/json' } });
      setShowModalReception(false);
      setEtapeReception(null);
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) await loadOrdreDetails(ordreId);
      await loadData();
    } catch (error) {
      alert('Erreur lors de la réception');
    }
  };

  const finJournee = async () => {
    if (!window.confirm('⏸ Fin de journée — mettre en pause toutes les tâches en cours pour tous les ouvriers ?')) return;
    try {
      const res = await api.post(`${API_URL}/atelier/fin-journee`, {}, { headers: { 'Content-Type': 'application/json' } });
      const data = res.data || {};
      setIsFinJournee(true);
      localStorage.setItem('atelier_fin_journee', '1');
      alert(`🌙 ${data.message || 'Fin de journée enregistrée'}`);
      await loadData();
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) await loadOrdreDetails(ordreId);
    } catch (error) {
      alert('Erreur fin de journée');
    }
  };

  const debutJournee = async () => {
    if (!window.confirm('▶ Début de journée — relancer toutes les tâches en pause pour tous les ouvriers ?')) return;
    try {
      const res = await api.post(`${API_URL}/atelier/debut-journee`, {}, { headers: { 'Content-Type': 'application/json' } });
      const data = res.data || {};
      setIsFinJournee(false);
      localStorage.removeItem('atelier_fin_journee');
      alert(`☀️ ${data.message || 'Production relancée'}`);
      await loadData();
      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
      if (ordreId) await loadOrdreDetails(ordreId);
    } catch (error) {
      alert('Erreur début de journée');
    }
  };

  const minutesToHHMM = (minutes) => {
    if (!minutes || isNaN(minutes)) return '';
    const m = Math.round(parseFloat(minutes));
    const h = Math.floor(m / 60);
    const min = m % 60;
    return h > 0 ? `${h}h ${String(min).padStart(2,'0')}min` : `${min}min`;
  };

  const ouvrirModalTerminer = (etape) => {
    setEtapeATerminer(etape);
    // Pré-remplir avec le timer réel (elapsed_seconds → minutes), sinon temps estimé × 60
    const elapsedMin = etape.elapsed_seconds != null
      ? Math.round(parseInt(etape.elapsed_seconds) / 60)
      : etape.duree_estimee_heures ? Math.round(parseFloat(etape.duree_estimee_heures) * 60) : '';
    setTempsReel(elapsedMin !== '' ? String(elapsedMin) : '');
    setTempsCorrection('0');
    setPoidsMetalReel('');
    // §77 cascade prefill or + bijou apres
    const allEtapes = selectedOrdre?.etapes || [];
    const ordreObj = selectedOrdre?.ordre || selectedOrdre || {};
    const orSuggested = suggestOrDonne(etape, allEtapes, ordreObj);
    setPoidsBijouApres(''); // chef saisit a la pesee
    // §82 - prefill Or donne avec cascade (poids_or_donne existant > suggested > '')
    const orDonneInit = etape.poids_or_donne ?? orSuggested ?? '';
    setOrDonneModal(orDonneInit !== '' ? String(parseFloat(orDonneInit).toFixed(3)) : '');
    setPoidsTotalBijou(etape.poids_total_bijou != null ? String(etape.poids_total_bijou) : '');
    const isMatiereOr = (m) => {
      const ref = (m.reference || '').toUpperCase();
      const type = (m.type_matiere || m.type || '').toUpperCase();
      // §77 - exclure fournisseur 'JPB-' (doublon)
      return (ref.includes('OR') || type === 'OR' || type.includes('OR')) && !ref.startsWith('JPB-');
    };
    const isFournisseurLot = (m) => {
      const ref = (m.reference || '').toUpperCase();
      // Pattern fournisseur 'JPB-001-OR' OR 'XXX-NNN-MATIERE'
      return ref.startsWith('JPB-') || /^[A-Z]{2,4}-\d+-/.test(ref);
    };
    // Pré-sélectionner matières SANS doublons fournisseur
    if (selectedOrdre?.matieres) {
      const matieresFiltered = selectedOrdre.matieres.filter(m => !isFournisseurLot(m));
      setMatieresSelectionnees(matieresFiltered.map(m => {
        const isOr = isMatiereOr(m);
        const qty = isOr && orSuggested != null && parseFloat(orSuggested) > 0
          ? parseFloat(orSuggested).toFixed(3)
          : (m.quantite_prevue || 0);
        return {
          matiere_id: m.matiere_id || m.id,
          reference: m.reference,
          quantite: qty,
          selected: true,
          _is_or: isOr
        };
      }));
    }
    // §88 - enrich pierres mapping avec label + nb + ct/pce
    if (selectedOrdre?.pierres) {
      setPierresSelectionnees(selectedOrdre.pierres.map(p => {
        const nb = p.nb_pierres || 1;
        const ctUnit = p.poids_unitaire_carats
          ? parseFloat(p.poids_unitaire_carats)
          : (p.poids_total_carats ? parseFloat(p.poids_total_carats) / nb : 0);
        const total = p.poids_total_carats != null
          ? parseFloat(p.poids_total_carats)
          : ctUnit * nb;
        return {
          pierre_id: p.pierre_id || p.id || p.dms_id,
          reference: p.reference,
          type_pierre: p.designation || p.type_matiere || p.reference || 'Pierre',
          taille_qualite: p.taille_qualite || null,
          nb_pierres: nb,
          poids_unitaire_carats: ctUnit,
          quantite: total, // poids total ct (compat ancien payload)
          selected: true,
          manuelle: false
        };
      }));
    } else {
      setPierresSelectionnees([]);
    }
    setPierreManuelle({ type_pierre: '', quantite: 1, poids_unitaire_carats: 0 });
    setShowTerminerModal(true);
  };

  const ajouterMatiere = () => {
    setMatieresUtilisees([...matieresUtilisees, { matiere_id: '', quantite: '', notes: '' }]);
  };

  const retirerMatiere = (index) => {
    setMatieresUtilisees(matieresUtilisees.filter((_, i) => i !== index));
  };

  const handleTerminerEtape = async (e) => {
    e.preventDefault();
    
    const compteurMin = parseFloat(tempsReel) || 0;
    const overrideMin = parseFloat(tempsCorrection) || 0;
    // Si un temps réel est saisi manuellement, il remplace le compteur.
    // Sinon on garde le compteur tel quel.
    const totalMin = overrideMin > 0 ? overrideMin : compteurMin;

    if (totalMin <= 0) {
      alert('Le temps total doit être supérieur à 0. Vérifiez le compteur ou ajoutez du temps manuellement.');
      return;
    }

    try {
      const matieresSent = matieresSelectionnees
        .filter(m => m.selected)
        .map(m => ({
          matiere_id: m.matiere_id,
          reference: m.reference,
          quantite: parseFloat(m.quantite)
        }));

      // §77 - extraire quantite OR pour poids_or_donne
      // §82 - Or donne depuis input modal (vs matiere OR). Sync matiere OR quantite pour cohesion stock.
      const orDonne = orDonneModal ? parseFloat(orDonneModal) : null;
      const bijouApres = poidsBijouApres ? parseFloat(poidsBijouApres) : null;
      // Sync matiere OR quantite avec orDonne (cohesion decompte stock)
      if (orDonne != null && !isNaN(orDonne)) {
        matieresSelectionnees.forEach(m => { if (m._is_or && m.selected) m.quantite = orDonne; });
      }
      const poidsTotal = poidsTotalBijou ? parseFloat(poidsTotalBijou) : null;

      const payload = {
        duree_reelle_heures: totalMin / 60,
        matieres_utilisees: matieresSent,
        pierres_utilisees: pierresSelectionnees
          .filter(p => p.selected)
          .map(p => ({
            pierre_id: p.pierre_id,
            reference: p.reference,
            type_pierre: p.type_pierre,
            nb_pierres: parseInt(p.nb_pierres) || 1,
            poids_unitaire_carats: parseFloat(p.poids_unitaire_carats) || 0,
            poids_total_carats: (parseFloat(p.poids_unitaire_carats) || 0) * (parseInt(p.nb_pierres) || 1),
            quantite: parseFloat(p.quantite) || ((parseFloat(p.poids_unitaire_carats) || 0) * (parseInt(p.nb_pierres) || 1)),
            manuelle: !!p.manuelle
          }))
      };

      // §77 - tracking or
      if (orDonne != null && !isNaN(orDonne) && orDonne >= 0) {
        payload.poids_or_donne = orDonne;
      }
      if (bijouApres != null && !isNaN(bijouApres) && bijouApres > 0) {
        payload.poids_or_recu = bijouApres;
        payload.poids_bijou_etape = bijouApres;
      }
      // §81 - poids total bijou (or+pierres) si etape avec_pierres
      if (poidsTotal != null && !isNaN(poidsTotal) && poidsTotal > 0) {
        payload.poids_total_bijou = poidsTotal;
      }

      // Ajouter le poids métal réel si saisi
      if (poidsMetalReel && parseFloat(poidsMetalReel) > 0) {
        payload.poids_metal_reel = parseFloat(poidsMetalReel);
      }

      await api.post(`${API_URL}/atelier/etapes/${etapeATerminer.id}/terminer`, payload);

      // Snapshots AVANT reset/reload : etapeATerminer va être remis à null et
      // selectedOrdre rafraîchi de façon asynchrone — on fige ce dont a besoin
      // la proposition "étape suivante".
      const etapeTerminee = etapeATerminer;
      const ordreSnapshot = selectedOrdre;

      alert('Étape terminée avec succès ! Stock mis à jour.');
      setShowTerminerModal(false);
      setEtapeATerminer(null);
      setTempsReel('');
      setTempsCorrection('0');
      setPoidsMetalReel('');
      setPoidsBijouApres('');
      setPoidsTotalBijou('');
      setOrDonneModal('');
      setMatieresSelectionnees([]);
      setPierresSelectionnees([]);

      // Recharger les détails ET la liste des ordres
      let ordreIdReload = null;
      if (selectedOrdre) {
        const ordreId = selectedOrdre.ordre?.id || selectedOrdre.id;
        ordreIdReload = ordreId;
        console.log('Rechargement ordre après terminaison - selectedOrdre:', selectedOrdre, 'ordreId:', ordreId);
        if (ordreId && ordreId !== undefined && ordreId !== null) {
          await loadOrdreDetails(ordreId);
        } else {
          console.warn('Impossible de recharger les détails: ordreId invalide');
        }
      }
      await loadData(); // Recharger la liste complète

      // Proposer l'étape suivante (non bloquant) — calcul côté front depuis le snapshot
      proposerEtapeSuivante(etapeTerminee, ordreSnapshot, ordreIdReload);
    } catch (error) {
      console.error('Erreur:', error);
      alert(error.response?.data?.error || 'Erreur lors de la finalisation de l\'étape');
    }
  };

  // ── "Proposer l'étape suivante" ──────────────────────────────────────────
  // Calcule la prochaine VRAIE étape en_attente du parcours, en réutilisant le
  // MÊME filtre pseudo-étapes-ouvrier que le Kanban (fix #1, 12/06) : on exclut
  // les étapes nommées d'après un ouvrier (import legacy script 07).
  const trouverEtapeSuivante = (etapeTerminee, ordreSnapshot) => {
    if (!etapeTerminee || !ordreSnapshot) return null;
    const etapes = ordreSnapshot.etapes || [];
    const numCourant = parseInt(etapeTerminee.numero_etape) || 0;
    // Set des noms d'ouvriers (nom / prenom / "prenom nom"), trim+lowercase — filtre Kanban
    const nomsOuvriers = new Set((ouvriersDisponibles || []).flatMap(o =>
      [o.nom, o.prenom, `${o.prenom || ''} ${o.nom || ''}`]
        .filter(Boolean).map(s => s.trim().toLowerCase()).filter(s => s)));
    const estPseudo = (e) => nomsOuvriers.has((e.nom_etape || '').trim().toLowerCase());
    const estCatalogue = (e) => e.statut === 'non_requis' || e.du_catalogue === true;
    const candidates = etapes
      .filter(e => e.statut === 'en_attente'
        && (parseInt(e.numero_etape) || 0) > numCourant
        && !estPseudo(e) && !estCatalogue(e))
      .sort((a, b) => (parseInt(a.numero_etape) || 0) - (parseInt(b.numero_etape) || 0));
    return candidates.length ? candidates[0] : null;
  };

  const proposerEtapeSuivante = (etapeTerminee, ordreSnapshot, ordreId) => {
    const next = trouverEtapeSuivante(etapeTerminee, ordreSnapshot);
    if (!next) return; // fin de parcours (ou OF terminé par la cascade BE) → pas de modale
    const ordreObj = ordreSnapshot?.ordre || ordreSnapshot || {};
    const sugg = suggestOrDonne(next, ordreSnapshot?.etapes || [], ordreObj);
    setEtapeSuivante(next);
    // Défaut = ouvrier qui vient de finir l'étape, modifiable
    setEnchainerOuvrierId(etapeTerminee.ouvrier_affecte_id ? String(etapeTerminee.ouvrier_affecte_id) : '');
    setEnchainerPoids(sugg != null && !isNaN(sugg) ? String(parseFloat(sugg).toFixed(3)) : '');
    setEnchainerOrdreId(ordreId || null);
    setShowEnchainerModal(true);
  };

  const fermerEnchainer = () => {
    setShowEnchainerModal(false);
    setEtapeSuivante(null);
    setEnchainerOuvrierId('');
    setEnchainerPoids('');
    setEnchainerBusy(false);
  };

  const lancerEtapeSuivante = async () => {
    if (!etapeSuivante) return;
    if (!enchainerOuvrierId) { alert('Choisir un ouvrier pour lancer l\'étape.'); return; }
    setEnchainerBusy(true);
    try {
      await api.post(`${API_URL}/atelier/etapes/${etapeSuivante.id}/affecter`,
        { ouvrier_id: parseInt(enchainerOuvrierId) });
      // Poids or début optionnel
      const poids = parseFloat(enchainerPoids);
      if (enchainerPoids !== '' && !isNaN(poids) && poids > 0) {
        try {
          await api.put(`${API_URL}/atelier/etapes/${etapeSuivante.id}/poids-or`,
            { poids_or_donne: poids });
        } catch (e) { /* poids non bloquant */ }
      }
      if (window.toast) window.toast.success(`Étape lancée : ${etapeSuivante.nom_etape}`);
      const ordreId = enchainerOrdreId;
      fermerEnchainer();
      if (ordreId) await loadOrdreDetails(ordreId);
      await loadData();
    } catch (err) {
      const code = err?.response?.status;
      const data = err?.response?.data || {};
      let msg = data.error || data.message || 'Erreur au lancement de l\'étape';
      if (code === 409) msg = data.message || 'Étape déjà prise par un autre ouvrier.';
      else if (code === 404) msg = 'Étape introuvable.';
      else if (code === 422) msg = "Cet OF n'a pas d'étapes définies.";
      if (window.toast) window.toast.error(msg); else alert(msg);
      fermerEnchainer();
    }
  };

  const loadOrdreDetails = async (id) => {
    try {
      const response = await atelierAPI.getOneFabrication(id);
      const data = response.data;
      // §103 20/05/2026 - Fix BE bug : etapes_devis.id peut etre = dcf.id (devis_couts_fabrication)
      // au lieu de etapes_production.id si BE prod_par_nom dict-by-name n'a pas matche.
      // Reconcilier ici : pour chaque etape_devis, si nom_etape match dans data.etapes (production
      // brut), overwrite id + champs avec_pierres/pierres_remises_json. Garantit que les actions
      // (PUT, optimistic, find by id) ciblent la BONNE etapes_production row.
      if (Array.isArray(data?.etapes_devis) && Array.isArray(data?.etapes) && data.etapes.length > 0) {
        const norm = s => (s || '').trim().toLowerCase();
        const prodByName = {};
        data.etapes.forEach(ep => { prodByName[norm(ep.nom_etape)] = ep; });
        let nbCorrected = 0;
        data.etapes_devis = data.etapes_devis.map(ed => {
          const prod = prodByName[norm(ed.nom_etape)];
          if (prod && prod.id !== ed.id) {
            nbCorrected += 1;
            return {
              ...ed,
              id: prod.id,
              avec_pierres: prod.avec_pierres,
              pierres_remises_json: prod.pierres_remises_json,
              poids_or_donne: prod.poids_or_donne,
              poids_or_recu: prod.poids_or_recu,
              poids_total_bijou: prod.poids_total_bijou
            };
          }
          // Meme si id match, sync avec_pierres/pierres_remises_json depuis prod (source de verite)
          if (prod) {
            return {
              ...ed,
              avec_pierres: prod.avec_pierres,
              pierres_remises_json: prod.pierres_remises_json
            };
          }
          return ed;
        });
        if (nbCorrected > 0) {
          console.warn(`§103 reconcile etapes_devis : ${nbCorrected} id(s) corrige(s) via nom_etape`);
        }
      }
      setSelectedOrdre(data);
      setShowDetailModal(true);
      setImagePrincipale(null); // reset

      // Charger fonte, pierres, checklist + image bijou en parallèle
      const h = { 'Authorization': `Bearer ${localStorage.getItem('token')}` };
      const refArticle = data?.ordre?.ref_article || data?.ordre?.reference_article || '';

      const [rFonte, rPierres, rCheck] = await Promise.all([
        fetch(`${API_URL}/atelier/fiche-fabrication/${id}/fonte`, { headers: h }),
        fetch(`${API_URL}/atelier/fiche-fabrication/${id}/pierres`, { headers: h }),
        fetch(`${API_URL}/atelier/fiche-fabrication/${id}/checklist`, { headers: h }),
      ]);
      if (rFonte.ok) setFonte(await rFonte.json());
      if (rPierres.ok) setPierresOF(await rPierres.json());
      if (rCheck.ok) setChecklist(await rCheck.json());

      // Charger le bijou lié à cet OF (pour id_produit, poids_metal réel)
      setBijouLie(null);
      try {
        const rBijou = await fetch(`${API_URL}/bijoux?ordre_fabrication_id=${id}`, { headers: h });
        if (rBijou.ok) {
          const bijoux = await rBijou.json();
          const list = Array.isArray(bijoux) ? bijoux : (bijoux.bijoux || []);
          const b = list.find(x => String(x.ordre_fabrication_id) === String(id));
          if (b) setBijouLie(b);
        }
      } catch {}

      // Charger l'image principale du bijou (depuis bijoux ou bijoux_images)
      const imgFromOrdre = data?.ordre?.image_url;
      if (imgFromOrdre) {
        const srv = API_URL.replace('/api', '');
        setImagePrincipale(imgFromOrdre.startsWith('/') ? `${srv}${imgFromOrdre.replace(/\\/g, '/')}` : imgFromOrdre);
      } else if (refArticle) {
        // Chercher via l'API catalogue
        try {
          const rImg = await fetch(`${API_URL}/bijoux/catalogue/modeles?search=${encodeURIComponent(refArticle)}`, { headers: h });
          if (rImg.ok) {
            const modeles = await rImg.json();
            const img = modeles?.[0]?.image_url;
            if (img) {
              const srv = API_URL.replace('/api', '');
              setImagePrincipale(img.startsWith('/') ? `${srv}${img.replace(/\\/g, '/')}` : img);
            }
          }
        } catch {}
      }
    } catch (error) {
      console.error('Erreur loadOrdreDetails:', error);
      alert('Erreur lors du chargement des détails: ' + (error.response?.data?.error || error.message));
    }
  };

  const saveFonte = async () => {
    const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
    if (!ordreId) return;
    setSavingFonte(true);
    try {
      await fetch(`${API_URL}/atelier/fiche-fabrication/${ordreId}/fonte`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(fonte)
      });
    } finally { setSavingFonte(false); }
  };

  const searchPierresStock = async (query) => {
    if (!query || query.length < 1) { setPierreSuggestions([]); setShowPierreSuggestions(false); return; }
    try {
      const response = await fetch(`${API_URL}/stock-matieres/search-pierres?q=${encodeURIComponent(query)}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
      });
      if (response.ok) {
        const data = await response.json();
        setPierreSuggestions(data);
        setShowPierreSuggestions(true);
      }
    } catch (err) { console.error('Erreur recherche pierres:', err); }
  };

  const selectPierreFromStock = (pierre) => {
    const prixCarat = pierre.prix_achat_carat || pierre.prix_achat_unitaire || 0;
    const stockDispo = parseFloat(pierre.quantite_disponible || 0);
    // Extraire le poids par pierre depuis la désignation (ex: "0.50ct", "0.75 ct")
    const desig = (pierre.designation || '') + ' ' + (pierre.reference || '');
    const match = desig.match(/(\d+[.,]\d+)\s*ct/i);
    const poidsParPierre = match ? parseFloat(match[1].replace(',', '.')) : 0;
    const nbPierresDispo = poidsParPierre > 0 ? Math.floor(stockDispo / poidsParPierre) : 0;
    setNouvellePierre(p => ({
      ...p,
      reference_pierre: pierre.reference,
      type_pierre: pierre.type_matiere || pierre.designation,
      prix_achat_carat: prixCarat,
      poids_carats: poidsParPierre || '',
      stock_id: pierre.id,
      stock_disponible: stockDispo,
      nb_pierres_dispo: nbPierresDispo,
      designation: pierre.designation || ''
    }));
    setPierreSuggestions([]);
    setShowPierreSuggestions(false);
  };

  const addPierre = async () => {
    const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
    if (!ordreId || !nouvellePierre.type_pierre) return;
    const res = await fetch(`${API_URL}/atelier/fiche-fabrication/${ordreId}/pierres`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(nouvellePierre)
    });
    if (res.ok) {
      const rPierres = await fetch(`${API_URL}/atelier/fiche-fabrication/${ordreId}/pierres`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      if (rPierres.ok) setPierresOF(await rPierres.json());
      setNouvellePierre({ reference_pierre: '', type_pierre: '', quantite: 1, poids_carats: '', prix_achat_carat: '', sertisseur: '', observation: '', stock_id: null, stock_disponible: null, designation: '' });
      setAjoutPierreOpen(false);
    }
  };

  const deletePierre = async (pierreId) => {
    const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
    await fetch(`${API_URL}/atelier/fiche-fabrication/${ordreId}/pierres/${pierreId}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    setPierresOF(prev => prev.filter(p => p.id !== pierreId));
  };

  const toggleChecklist = async (numEtape, currentVal) => {
    const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
    const newVal = !currentVal;
    // Optimistic update
    setChecklist(prev => prev.map(item =>
      item.numero_etape === numEtape ? { ...item, checked: newVal ? 1 : 0 } : item
    ));
    await fetch(`${API_URL}/atelier/fiche-fabrication/${ordreId}/checklist/${numEtape}`, {
      method: 'PUT',
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ checked: newVal })
    });
  };

  const ajouterComposant = () => {
    const qte = parseFloat(nouveauComposant.quantite_estimee);
    
    if (!nouveauComposant.composant_id || isNaN(qte) || qte <= 0) {
      alert('Veuillez remplir tous les champs correctement');
      return;
    }

    const composant = composants.find(c => c.id === parseInt(nouveauComposant.composant_id));
    
    setFormData({
      ...formData,
      composants: [...formData.composants, {
        composant_id: parseInt(nouveauComposant.composant_id),
        composant_nom: composant?.nom || '',
        quantite_estimee: qte,
        unite: nouveauComposant.unite
      }]
    });

    setNouveauComposant({
      composant_id: '',
      quantite_estimee: '',
      unite: 'g'
    });
  };

  const supprimerComposant = (index) => {
    setFormData({
      ...formData,
      composants: formData.composants.filter((_, i) => i !== index)
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.composants.length === 0) {
      alert('Veuillez ajouter au moins un composant');
      return;
    }

    setSaving(true);
    try {
      await atelierAPI.createFabrication(formData);
      setShowModal(false);
      resetForm();
      await loadData();
    } catch (error) {
      console.error('Erreur:', error);
      alert(error.response?.data?.error || 'Erreur lors de la création');
    } finally {
      setSaving(false);
    }
  };

  const resetForm = () => {
    setFormData({
      reference_bijou: '',
      type_bijou: 'bague',
      description: '',
      client_nom: '',
      date_livraison_prevue: '',
      prix_estime: '',
      notes: '',
      composants: []
    });
    setNouveauComposant({
      composant_id: '',
      quantite_estimee: '',
      unite: 'g'
    });
  };

  const getStatutBadge = (statut) => {
    const badges = {
      'en_attente': 'bg-yellow-100 text-yellow-800',
      'en_cours': 'bg-blue-100 text-blue-800',
      'terminee': 'bg-green-100 text-green-800',
      'livre': 'bg-purple-100 text-purple-800',
      'annule': 'bg-red-100 text-red-800'
    };
    return badges[statut] || 'bg-gray-100 text-gray-800';
  };

  const getStatutLabel = (statut) => {
    const labels = {
      'en_attente': 'En attente',
      'en_cours': 'En cours',
      'terminee': 'Terminé',
      'livre': 'Livré',
      'annule': 'Annulé'
    };
    return labels[statut] || statut;
  };

  // Badge d'activité RÉELLE (12/06/2026) : le statut brut "en cours" est l'étiquette
  // d'import qui ment (95/97 OF n'ont aucune activité). On dérive de l'avancement
  // sans modifier la base : ≥1 étape terminée = en production, sinon importé/dormant.
  const badgeActivite = (ordre) => {
    if (!ordre || ['termine', 'terminee', 'livre', 'annule'].includes(ordre.statut)) return null;
    const term = parseInt(ordre.etapes_terminees || 0);
    return term > 0
      ? { label: '▶ en production', cls: 'bg-emerald-100 text-emerald-700' }
      : { label: '📦 importé, jamais lancé', cls: 'bg-gray-100 text-gray-500' };
  };

  const getDelaiInfo = (ordre) => {
    if (!ordre.date_livraison_prevue) return null;
    const today = new Date(); today.setHours(0,0,0,0);
    const livraison = new Date(ordre.date_livraison_prevue); livraison.setHours(0,0,0,0);
    const diffJours = Math.round((livraison - today) / (1000 * 60 * 60 * 24));
    if (diffJours < 0) return { label: `En retard (${Math.abs(diffJours)}j)`, classe: 'bg-red-100 text-red-700 border border-red-300', icone: '🔴' };
    if (diffJours === 0) return { label: 'Livraison aujourd\'hui !', classe: 'bg-red-100 text-red-700 border border-red-300', icone: '🔴' };
    if (diffJours <= 2) return { label: `J-${diffJours}`, classe: 'bg-orange-100 text-orange-700 border border-orange-300', icone: '🟠' };
    if (diffJours <= 7) return { label: `J-${diffJours}`, classe: 'bg-yellow-100 text-yellow-700 border border-yellow-300', icone: '🟡' };
    return { label: `${diffJours}j`, classe: 'bg-gray-100 text-gray-500 border border-gray-200', icone: '📅' };
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 flex items-center space-x-3">
          <Wrench className="h-7 w-7 sm:h-8 sm:w-8 text-orange-600" />
          <span>Atelier de Production</span>
        </h2>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          {isFinJournee ? (
            <button
              onClick={debutJournee}
              className="bg-gradient-to-r from-green-600 to-emerald-700 text-white px-4 py-3 rounded-lg hover:from-green-700 hover:to-emerald-800 transition-all flex items-center justify-center space-x-2 shadow-lg w-full sm:w-auto"
            >
              <span>☀️</span>
              <span className="font-semibold">Début de journée</span>
            </button>
          ) : (
            <button
              onClick={finJournee}
              className="bg-gradient-to-r from-gray-700 to-gray-900 text-white px-4 py-3 rounded-lg hover:from-gray-800 hover:to-black transition-all flex items-center justify-center space-x-2 shadow-lg w-full sm:w-auto"
            >
              <span>🌙</span>
              <span className="font-semibold">Fin de journée</span>
            </button>
          )}
          <button
            onClick={() => setShowModalDevis(true)}
            className="bg-gradient-to-r from-orange-600 to-red-600 text-white px-5 py-3 rounded-lg hover:from-orange-700 hover:to-red-700 transition-all flex items-center justify-center space-x-2 shadow-lg w-full sm:w-auto"
          >
            <Plus className="h-5 w-5" />
            <span>Nouvel ordre de fabrication</span>
          </button>
        </div>
      </div>

      {/* Onglets */}
      <div className="bg-white rounded-lg shadow-md p-1 overflow-x-auto">
        <div className="flex gap-1 min-w-max sm:min-w-0">
        <button
          onClick={() => setActiveTab('ordres')}
          className={`flex-shrink-0 sm:flex-1 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5 text-sm ${
            activeTab === 'ordres'
              ? 'bg-gradient-to-r from-orange-600 to-red-600 text-white shadow-md'
              : 'text-gray-600 hover:bg-gray-100'
          }`}
        >
          <Wrench className="h-4 w-4 flex-shrink-0" />
          <span className="whitespace-nowrap"><span className="hidden sm:inline">Ordres de </span>Fabrication</span>
        </button>
        {/* §95 onglet "Ouvriers" supprime - doublon avec /ouvriers "Suivi Production" */}
        <button
          onClick={() => setActiveTab('suivi-fiche')}
          className={`flex-shrink-0 sm:flex-1 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5 text-sm ${
            activeTab === 'suivi-fiche'
              ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-md'
              : 'text-gray-600 hover:bg-gray-100'
          }`}
        >
          <Eye className="h-4 w-4 flex-shrink-0" />
          <span className="whitespace-nowrap">Suivi Fiche</span>
        </button>
        {/* §95 onglet "Equipe" supprime - doublon avec /ouvriers "Liste des Ouvriers" */}
        {/* Onglet "Stock" remplace par "Atelier" (Kanban) le 12/06/2026 - StockMatieres reste
            accessible depuis la page Stocks generale. Visible atelier/chef/admin (pas vendeuse). */}
        <button
          onClick={() => setActiveTab('kanban')}
          className={`flex-shrink-0 sm:flex-1 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5 text-sm ${
            activeTab === 'kanban'
              ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-md'
              : 'text-gray-600 hover:bg-gray-100'
          }`}
        >
          <LayoutGrid className="h-4 w-4 flex-shrink-0" />
          <span className="whitespace-nowrap">Atelier</span>
        </button>
        {/* LOT 5 (12/06/2026) : onglet Parcours OF — visualisation seule, isolee */}
        <button
          onClick={() => setActiveTab('parcours')}
          className={`flex-shrink-0 sm:flex-1 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5 text-sm ${
            activeTab === 'parcours'
              ? 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white shadow-md'
              : 'text-gray-600 hover:bg-gray-100'
          }`}
        >
          <Gem className="h-4 w-4 flex-shrink-0" />
          <span className="whitespace-nowrap">Parcours OF</span>
        </button>
        {/* Compte Métal (18/06/2026) — visible {admin, chef_atelier} seulement */}
        {canMetal && (
          <button
            onClick={() => setActiveTab('metal')}
            className={`flex-shrink-0 sm:flex-1 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5 text-sm ${
              activeTab === 'metal'
                ? 'bg-gradient-to-r from-yellow-600 to-amber-600 text-white shadow-md'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <Scale className="h-4 w-4 flex-shrink-0" />
            <span className="whitespace-nowrap">Compte Métal</span>
          </button>
        )}
        {/* Stock Or / Achats Or (25/06/2026) — visible {admin, chef_atelier} */}
        {canMetal && (
          <button
            onClick={() => setActiveTab('achats-or')}
            className={`flex-shrink-0 sm:flex-1 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg font-semibold transition-all flex items-center justify-center gap-1.5 text-sm ${
              activeTab === 'achats-or'
                ? 'bg-gradient-to-r from-yellow-700 to-yellow-500 text-white shadow-md'
                : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <Coins className="h-4 w-4 flex-shrink-0" />
            <span className="whitespace-nowrap">Stock Or</span>
          </button>
        )}
        {/* §95 onglet "Coffres" supprime - doublon avec /ouvriers "Coffres & Stock" */}
        </div>
      </div>

      {/* Contenu selon l'onglet */}
      {activeTab === 'kanban' && <AtelierKanban onOuvrirOF={loadOrdreDetails} />}
      {activeTab === 'parcours' && <ParcoursOF />}
      {activeTab === 'metal' && canMetal && <CompteMetal />}
      {activeTab === 'achats-or' && canMetal && <AchatsOr />}
      {activeTab === 'ordres' && (
        <>
      {/* Filtres et Recherche */}
      <div className="bg-white rounded-lg shadow p-3 sm:p-4">
        <div className="flex flex-col gap-3">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Rechercher référence, client..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
            />
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide flex-shrink-0">Filtrer par :</span>
            <button
              onClick={() => setFiltreStatut('all')}
              className={`flex-shrink-0 px-3 py-1.5 rounded-lg font-medium transition-colors text-sm ${
                filtreStatut === 'all' ? 'bg-orange-600 text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              Tous
            </button>
            <button
              onClick={() => setFiltreStatut('en_attente')}
              className={`flex-shrink-0 px-3 py-1.5 rounded-lg font-medium transition-colors flex items-center gap-1.5 text-sm ${
                filtreStatut === 'en_attente' ? 'bg-gray-600 text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              <Clock size={14} />
              Attente
            </button>
            <button
              onClick={() => setFiltreStatut('en_cours')}
              className={`flex-shrink-0 px-3 py-1.5 rounded-lg font-medium transition-colors flex items-center gap-1.5 text-sm ${
                filtreStatut === 'en_cours' ? 'bg-orange-600 text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              <Play size={14} />
              En Cours
            </button>
            <button
              onClick={() => setFiltreStatut('termine')}
              className={`flex-shrink-0 px-3 py-1.5 rounded-lg font-medium transition-colors flex items-center gap-1.5 text-sm ${
                filtreStatut === 'termine' ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700'
              }`}
            >
              <CheckCircle size={14} />
              Terminés
            </button>
            <div className="flex-shrink-0 w-px h-5 bg-gray-200 mx-1" />
            <label className="flex-shrink-0 flex items-center gap-2 cursor-pointer select-none">
              <input
                type="checkbox"
                checked={masquerTermines}
                onChange={e => {
                  setMasquerTermines(e.target.checked);
                  if (e.target.checked && filtreStatut === 'termine') setFiltreStatut('all');
                }}
                className="w-4 h-4 rounded accent-orange-600 cursor-pointer"
              />
              <span className="text-sm text-gray-600 font-medium">Masquer terminés</span>
            </label>
            <button
              onClick={loadData}
              className="flex-shrink-0 ml-auto px-3 py-1.5 rounded-lg font-medium bg-gray-100 text-gray-700 transition-colors flex items-center gap-1.5 text-sm"
            >
              <RefreshCw size={14} />
              <span className="hidden sm:inline">Actualiser</span>
            </button>
          </div>
        </div>
      </div>

      {/* Liste des ordres — Vue mobile (cartes) + Vue desktop (tableau) */}
      {(() => {
        const ordresFiltres = ordres
          .filter(ordre => {
            if (filtreStatut !== 'all' && ordre.statut !== filtreStatut) return false;
            if (masquerTermines && filtreStatut === 'all' && (ordre.statut === 'termine' || ordre.statut === 'terminee' || ordre.statut === 'livre' || ordre.statut === 'annule')) return false;
            if (searchTerm) {
              const term = searchTerm.toLowerCase();
              return (
                (ordre.ref_article || '').toLowerCase().includes(term) ||
                (ordre.reference_bijou || '').toLowerCase().includes(term) ||
                (ordre.numero_ordre || '').toString().toLowerCase().includes(term) ||
                (ordre.client_nom || '').toLowerCase().includes(term) ||
                (ordre.type_bijou || '').toLowerCase().includes(term) ||
                (ordre.description || '').toLowerCase().includes(term) ||
                (ordre.collection_nom || '').toLowerCase().includes(term)
              );
            }
            return true;
          })
          .sort((a, b) => b.id - a.id);

        return (<>
        {/* === VUE MOBILE (cartes) — visible uniquement sur petit écran === */}
        <div className="md:hidden space-y-3">
          {ordresFiltres.length === 0 && (
            <div className="text-center py-12 bg-white rounded-lg shadow">
              <Wrench className="h-12 w-12 mx-auto mb-3 text-gray-400" />
              <p className="text-gray-500">{searchTerm ? 'Aucun résultat trouvé' : 'Aucun ordre de fabrication'}</p>
            </div>
          )}
          {ordresFiltres.map(ordre => {
            const pct = ordre.etapes_total > 0 ? Math.round((ordre.etapes_terminees / ordre.etapes_total) * 100) : 0;
            const prix = parseFloat(ordre.prix_devis || ordre.prix_estime || ordre.prix_final) || 0;
            const delai = getDelaiInfo(ordre);
            return (
              <div key={ordre.id} className={`bg-white rounded-lg shadow p-4 border-l-4 ${delai && delai.icone === '🔴' ? 'border-red-500' : 'border-orange-400'}`}>
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <div className="font-bold text-gray-900 font-mono text-base flex items-center gap-2">
                      {ordre.ref_article || ordre.reference_bijou || `#${ordre.numero_ordre}`}
                      {(ordre.is_sav || (ordre.type_bijou || '').startsWith('SAV-')) && (
                        <span className="px-2 py-0.5 rounded-full text-xs font-bold bg-blue-500 text-white">SAV</span>
                      )}
                    </div>
                    <div className="text-xs text-gray-500">OF #{ordre.numero_ordre} · {ordre.type_bijou?.replace('_', ' ')}</div>
                    {ordre.client_nom && (
                      <div className="text-xs text-gray-600 flex items-center gap-1 mt-0.5"><User size={11} />{ordre.client_nom}</div>
                    )}
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    {(() => { const a = badgeActivite(ordre); return a
                      ? <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${a.cls}`}>{a.label}</span>
                      : <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getStatutBadge(ordre.statut)}`}>{getStatutLabel(ordre.statut)}</span>; })()}
                    {delai && (
                      <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${delai.classe}`}>
                        {delai.icone} {delai.label}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex-1 bg-gray-200 rounded-full h-2">
                    <div className={`h-2 rounded-full transition-all ${pct === 100 ? 'bg-green-500' : pct > 0 ? 'bg-orange-500' : 'bg-gray-300'}`}
                      style={{ width: `${pct}%` }}></div>
                  </div>
                  <div className="text-xs font-bold text-gray-700 min-w-[32px]">{pct}%</div>
                  {prix > 0 && <div className="text-sm font-bold text-orange-600">{prix.toLocaleString()} DH</div>}
                </div>
                <div className="flex gap-2">
                  {ordre.statut === 'en_attente' && (
                    <button
                      onClick={() => setEditOrdre(ordre)}
                      className="flex-none py-2.5 px-3 bg-gray-100 text-gray-700 rounded-lg text-sm font-semibold flex items-center justify-center gap-1.5 hover:bg-gray-200 active:bg-gray-300 transition"
                    >
                      <Edit size={15} />
                      Modifier
                    </button>
                  )}
                  <button
                    onClick={() => loadOrdreDetails(ordre.id)}
                    className="flex-1 py-2.5 bg-orange-600 text-white rounded-lg text-sm font-semibold flex items-center justify-center gap-2 active:bg-orange-700"
                  >
                    <Eye size={16} />
                    Voir détails & Lancer production
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* === VUE DESKTOP (tableau) — visible uniquement sur md+ === */}
        <div className="hidden md:block bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gradient-to-r from-orange-50 to-red-50">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">Ordre</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">Type / Client</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">Avancement</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">Statut</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">Livraison</th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-700 uppercase tracking-wider">Affectation</th>
                <th className="px-6 py-4 text-right text-xs font-bold text-gray-700 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {ordresFiltres
                .map((ordre) => {
                  const isExpanded = expandedOrdreId === ordre.id;
                  const pct = ordre.etapes_total > 0 ? Math.round((ordre.etapes_terminees / ordre.etapes_total) * 100) : 0;
                  const prix = parseFloat(ordre.prix_devis || ordre.prix_estime || ordre.prix_final) || 0;
                  return (
                  <React.Fragment key={ordre.id}>
                  <tr
                    className="hover:bg-orange-50 transition-colors cursor-pointer"
                    onClick={() => {
                      const newId = isExpanded ? null : ordre.id;
                      setExpandedOrdreId(newId);
                      if (newId && !piecesOf[newId] && parseInt(ordre.quantite_pieces || 1) > 1) loadPiecesOf(newId);
                      if (newId && !pertesOr[newId]) loadPerteOr(newId);
                      if (newId) loadPierresDevisOF(newId);
                    }}
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        {isExpanded ? <ChevronUp size={14} className="text-orange-500" /> : <ChevronDown size={14} className="text-gray-400" />}
                        <div>
                          <div className="text-sm font-bold text-gray-900 font-mono flex items-center gap-1.5">
                            {ordre.ref_article || ordre.reference_bijou || `#${ordre.numero_ordre}`}
                            {(ordre.is_sav || (ordre.type_bijou || '').startsWith('SAV-')) && (
                              <span className="px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-blue-500 text-white">SAV</span>
                            )}
                          </div>
                          <div className="text-xs text-gray-500">OF #{ordre.numero_ordre}</div>
                        </div>
                      </div>
                    </td>

                    <td className="px-6 py-4">
                      <div className="text-sm font-medium text-gray-900 capitalize">{ordre.type_bijou?.replace('_', ' ')}</div>
                      {ordre.client_nom && (
                        <div className="text-xs text-gray-500 flex items-center gap-1"><User size={12} />{ordre.client_nom}</div>
                      )}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <div className="flex-1 w-24">
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className={`h-2 rounded-full transition-all ${pct === 100 ? 'bg-green-500' : pct > 0 ? 'bg-orange-500' : 'bg-gray-300'}`}
                              style={{ width: `${pct}%` }}></div>
                          </div>
                        </div>
                        <div className="text-xs font-bold text-gray-700 min-w-[32px]">{pct}%</div>
                      </div>
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      {(() => { const a = badgeActivite(ordre); return a
                        ? <span className={`px-2 py-1 rounded-full text-xs font-semibold ${a.cls}`}>{a.label}</span>
                        : <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatutBadge(ordre.statut)}`}>{getStatutLabel(ordre.statut)}</span>; })()}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {ordre.date_livraison_prevue ? (() => {
                        const delai = getDelaiInfo(ordre);
                        return (
                          <div className="flex flex-col gap-1">
                            <div className="flex items-center gap-1 text-gray-500">
                              <Calendar size={13} />{new Date(ordre.date_livraison_prevue).toLocaleDateString('fr-FR')}
                            </div>
                            {delai && (
                              <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-bold ${delai.classe}`}>
                                {delai.icone} {delai.label}
                              </span>
                            )}
                          </div>
                        );
                      })() : <span className="text-gray-400">-</span>}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      {ordre.artisan_nom ? (
                        <div className="flex items-center gap-1.5">
                          <div className="w-6 h-6 rounded-full bg-orange-100 text-orange-700 flex items-center justify-center text-xs font-bold">
                            {ordre.artisan_nom.charAt(0)}
                          </div>
                          <span className="text-sm text-gray-700 font-medium">{ordre.artisan_nom.split(' ')[0]}</span>
                        </div>
                      ) : <span className="text-gray-400 text-xs">—</span>}
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" onClick={e => e.stopPropagation()}>
                      <div className="flex items-center justify-end gap-2">
                        {ordre.statut === 'en_attente' && (
                          <button
                            onClick={() => setEditOrdre(ordre)}
                            className="text-gray-600 hover:text-gray-900 inline-flex items-center gap-1 hover:bg-gray-100 px-3 py-1 rounded transition-colors"
                          >
                            <Edit size={15} />
                            Modifier
                          </button>
                        )}
                        <button
                          onClick={() => loadOrdreDetails(ordre.id)}
                          className="text-orange-600 hover:text-orange-900 inline-flex items-center gap-1 hover:bg-orange-50 px-3 py-1 rounded transition-colors"
                        >
                          <Eye size={16} />
                          Détails
                        </button>
                      </div>
                    </td>
                  </tr>

                  {/* Ligne expandée */}
                  {isExpanded && (
                    <tr className="bg-orange-50 border-l-4 border-orange-400">
                      <td colSpan={7} className="px-8 py-4">
                        {/* Infos générales */}
                        <div className="grid grid-cols-4 gap-6 text-sm mb-4">
                          <div>
                            <div className="text-xs text-gray-500 mb-1">Description</div>
                            <div className="font-medium text-gray-800">{ordre.description || '—'}</div>
                          </div>
                          <div>
                            <div className="text-xs text-gray-500 mb-1">Métal / Couleur</div>
                            <div className="font-medium text-gray-800">{ordre.metal || ordre.couleur_or || '—'}</div>
                          </div>
                          <div>
                            <div className="text-xs text-gray-500 mb-1">Avancement global</div>
                            <div className="font-medium text-gray-800">
                              {ordre.etapes_terminees || 0} / {ordre.etapes_total || 0} étapes
                            </div>
                          </div>
                          <div>
                            <div className="text-xs text-gray-500 mb-1">Prix devis</div>
                            <div className="font-bold text-orange-600">{prix ? `${parseFloat(prix).toLocaleString()} DH` : '—'}</div>
                          </div>
                        </div>

                        {/* §84 - §79 module supprime, pierres maintenant inline par etape (cf section avec_pierres) */}

                        {/* V2.Z §72 Suivi or par etape : Donne (AVANT) -> Recu (APRES) + perte cumulee */}
                        {pertesOr[ordre.id] && (pertesOr[ordre.id].poids_or_initial || pertesOr[ordre.id].etapes?.some(e => e.poids_or_donne != null || e.poids_or_recu != null || e.poids_bijou_etape != null)) && (
                          <div className="mb-4 p-3 bg-gradient-to-br from-amber-50 to-yellow-50 border-2 border-amber-300 rounded-lg shadow-sm">
                            <div className="flex items-center justify-between mb-3">
                              <div className="text-sm font-bold uppercase tracking-wide text-amber-900 flex items-center gap-2">
                                <Scale size={16} /> Suivi or par etape
                              </div>
                              {pertesOr[ordre.id].perte_totale_g != null && (
                                <div className="text-xs flex gap-3">
                                  <span>Or initial : <span className="font-mono font-bold">{pertesOr[ordre.id].poids_or_initial?.toFixed(3) || '-'}g</span></span>
                                  <span>Final : <span className="font-mono font-bold">{pertesOr[ordre.id].poids_final_bijou?.toFixed(3) || '-'}g</span></span>
                                  <span>Perte : <span className="font-mono font-bold text-red-600">
                                    {pertesOr[ordre.id].perte_totale_g?.toFixed(3)}g
                                    {pertesOr[ordre.id].perte_pourcentage != null && ` (${pertesOr[ordre.id].perte_pourcentage}%)`}
                                  </span></span>
                                </div>
                              )}
                            </div>
                            <table className="w-full text-xs">
                              <thead>
                                <tr className="text-amber-900 font-semibold">
                                  <th className="text-left px-2 py-1">Etape</th>
                                  <th className="text-left px-2 py-1">Nom</th>
                                  <th className="text-right px-2 py-1">Donne (g)</th>
                                  <th className="text-right px-2 py-1">Recu (g)</th>
                                  <th className="text-right px-2 py-1">Perte (g)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {pertesOr[ordre.id].etapes?.map(e => {
                                  const donne = e.poids_or_donne;
                                  const recu = e.poids_or_recu ?? e.poids_bijou_etape;
                                  const perte = (donne != null && recu != null) ? (donne - recu) : null;
                                  return (
                                    <tr key={e.id} className="bg-white border-b border-amber-100 hover:bg-amber-50">
                                      <td className="px-2 py-1 font-semibold">{e.numero_etape}</td>
                                      <td className="px-2 py-1 truncate max-w-[200px]">{e.nom_etape}</td>
                                      <td className="px-2 py-1 text-right font-mono">{donne != null ? donne.toFixed(3) : '-'}</td>
                                      <td className="px-2 py-1 text-right font-mono">{recu != null ? recu.toFixed(3) : '-'}</td>
                                      <td className="px-2 py-1 text-right font-mono">
                                        {perte != null ? (
                                          <span className={perte > 0 ? 'text-red-600 font-semibold' : perte < 0 ? 'text-green-600' : 'text-gray-500'}>
                                            {perte > 0 ? '-' : perte < 0 ? '+' : ''}{Math.abs(perte).toFixed(3)}
                                          </span>
                                        ) : '-'}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}

                        {/* Pièces individuelles — uniquement pour les OFs multi-pièces */}
                        {parseInt(ordre.quantite_pieces || 1) > 1 && (
                        <div className="mt-2">
                          <div className="flex items-center justify-between mb-2">
                            <div className="text-xs font-bold uppercase tracking-wide text-gray-500 flex items-center gap-1.5">
                              <Package size={13} /> Bijoux de cet ordre ({ordre.quantite_pieces})
                            </div>
                            {!piecesOf[ordre.id] && (
                              <button
                                onClick={() => loadPiecesOf(ordre.id)}
                                disabled={loadingPieces === ordre.id}
                                className="text-xs px-2.5 py-1 bg-orange-100 text-orange-700 rounded hover:bg-orange-200 transition"
                              >
                                {loadingPieces === ordre.id ? 'Chargement…' : '⬇ Charger les bijoux'}
                              </button>
                            )}
                          </div>

                          {piecesOf[ordre.id] ? (
                            <div className="overflow-x-auto">
                              <table className="w-full text-xs border-collapse">
                                <thead>
                                  <tr className="bg-gray-100">
                                    <th className="px-3 py-2 text-left font-semibold text-gray-600">Référence pièce</th>
                                    <th className="px-3 py-2 text-left font-semibold text-gray-600">Couleur / Métal</th>
                                    <th className="px-3 py-2 text-left font-semibold text-gray-600">Ouvrier</th>
                                    <th className="px-3 py-2 text-left font-semibold text-gray-600">Statut</th>
                                    <th className="px-3 py-2 text-left font-semibold text-gray-600">Avancement</th>
                                    <th className="px-3 py-2 text-right font-semibold text-gray-600">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {piecesOf[ordre.id].map(piece => {
                                    const isEditingThis = editingPiece?.id === piece.id;
                                    const statutColors = {
                                      en_attente: 'bg-gray-100 text-gray-600',
                                      assignee: 'bg-blue-100 text-blue-700',
                                      en_cours: 'bg-orange-100 text-orange-700',
                                      terminee: 'bg-green-100 text-green-700',
                                    };
                                    const nbEtapes = parseInt(piece.nb_etapes || 0);
                                    const nbTerminees = parseInt(piece.etapes_terminees || 0);
                                    const pctPiece = nbEtapes > 0 ? Math.round(nbTerminees / nbEtapes * 100) : 0;
                                    return (
                                      <tr key={piece.id} className="border-t border-gray-200 hover:bg-orange-50/50">
                                        <td className="px-3 py-2 font-mono font-bold text-gray-800">{piece.reference_piece}</td>
                                        <td className="px-3 py-2">
                                          {isEditingThis ? (
                                            <select
                                              value={editingPiece.couleur_or || piece.couleur_or}
                                              onChange={e => setEditingPiece(p => ({ ...p, couleur_or: e.target.value }))}
                                              className="border rounded px-1.5 py-0.5 text-xs"
                                            >
                                              {['JAUNE', 'BLANC', 'ROSE', 'GRIS', 'BICOLORE'].map(c => <option key={c} value={c}>{c}</option>)}
                                            </select>
                                          ) : (
                                            <span className="px-1.5 py-0.5 rounded bg-yellow-50 border border-yellow-200 font-medium">
                                              {piece.couleur_or || '—'}
                                            </span>
                                          )}
                                        </td>
                                        <td className="px-3 py-2">
                                          {isEditingThis ? (
                                            <select
                                              value={editingPiece.artisan_id || piece.artisan_id || ''}
                                              onChange={e => setEditingPiece(p => ({ ...p, artisan_id: e.target.value || null }))}
                                              className="border rounded px-1.5 py-0.5 text-xs"
                                            >
                                              <option value="">— Non assigné —</option>
                                              {ouvriersForPieces.map(o => <option key={o.id} value={o.id}>{o.nom_complet || o.nom || o.prenom}</option>)}
                                            </select>
                                          ) : (
                                            <span className={piece.ouvrier_nom ? 'text-gray-800' : 'text-gray-400 italic'}>
                                              {piece.ouvrier_nom || piece.artisan_nom || 'Non assigné'}
                                            </span>
                                          )}
                                        </td>
                                        <td className="px-3 py-2">
                                          {isEditingThis ? (
                                            <select
                                              value={editingPiece.statut || piece.statut}
                                              onChange={e => setEditingPiece(p => ({ ...p, statut: e.target.value }))}
                                              className="border rounded px-1.5 py-0.5 text-xs"
                                            >
                                              {['en_attente', 'assignee', 'en_cours', 'terminee'].map(s => <option key={s} value={s}>{s}</option>)}
                                            </select>
                                          ) : (
                                            <span className={`px-1.5 py-0.5 rounded-full font-medium ${statutColors[piece.statut] || 'bg-gray-100 text-gray-600'}`}>
                                              {piece.statut}
                                            </span>
                                          )}
                                        </td>
                                        <td className="px-3 py-2">
                                          {nbEtapes > 0 ? (
                                            <div className="flex items-center gap-1.5">
                                              <div className="w-16 bg-gray-200 rounded-full h-1.5">
                                                <div className={`h-1.5 rounded-full ${pctPiece === 100 ? 'bg-green-500' : 'bg-orange-400'}`} style={{ width: `${pctPiece}%` }} />
                                              </div>
                                              <span className="text-gray-600">{nbTerminees}/{nbEtapes}</span>
                                            </div>
                                          ) : (
                                            <span className="text-gray-400 italic">Pas d'étapes</span>
                                          )}
                                        </td>
                                        <td className="px-3 py-2 text-right">
                                          {isEditingThis ? (
                                            <div className="flex justify-end gap-1">
                                              <button
                                                onClick={() => updatePiece(piece.id, { couleur_or: editingPiece.couleur_or, artisan_id: editingPiece.artisan_id || null, statut: editingPiece.statut })}
                                                className="px-2 py-0.5 bg-green-500 text-white rounded text-xs hover:bg-green-600"
                                              >✓ OK</button>
                                              <button onClick={() => setEditingPiece(null)} className="px-2 py-0.5 bg-gray-300 text-gray-700 rounded text-xs hover:bg-gray-400">✕</button>
                                            </div>
                                          ) : (
                                            <div className="flex justify-end gap-1">
                                              <button
                                                onClick={() => setEditingPiece({ id: piece.id, couleur_or: piece.couleur_or, artisan_id: piece.artisan_id, statut: piece.statut })}
                                                className="px-2 py-0.5 bg-orange-100 text-orange-700 rounded text-xs hover:bg-orange-200 transition"
                                              >✏</button>
                                              <button
                                                title="Ouvrir la fiche de fabrication de ce bijou"
                                                onClick={async (e) => {
                                                  e.stopPropagation();
                                                  try {
                                                    // Charger les détails du child OF et ouvrir FicheFabricationV2
                                                    const response = await atelierAPI.getOneFabrication(piece.id);
                                                    const data = response.data;
                                                    setSelectedOrdre(data);
                                                    setShowFicheFabrication(true);
                                                    // Charger fonte, pierres, checklist
                                                    const h = { Authorization: `Bearer ${localStorage.getItem('token')}` };
                                                    const [rFonte, rPierres, rCheck] = await Promise.all([
                                                      fetch(`${API_URL}/atelier/fiche-fabrication/${piece.id}/fonte`, { headers: h }),
                                                      fetch(`${API_URL}/atelier/fiche-fabrication/${piece.id}/pierres`, { headers: h }),
                                                      fetch(`${API_URL}/atelier/fiche-fabrication/${piece.id}/checklist`, { headers: h }),
                                                    ]);
                                                    if (rFonte.ok) setFonte(await rFonte.json());
                                                    if (rPierres.ok) setPierresOF(await rPierres.json());
                                                    if (rCheck.ok) setChecklist(await rCheck.json());
                                                  } catch (err) {
                                                    alert('Erreur chargement fiche: ' + err.message);
                                                  }
                                                }}
                                                className="px-2 py-0.5 bg-gray-800 text-white rounded text-xs hover:bg-gray-900 transition flex items-center gap-0.5"
                                              ><Printer size={11} /> Fiche</button>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="text-xs text-gray-400 italic py-2">
                              Cliquer "Charger les bijoux" pour voir les {ordre.quantite_pieces} sous-ordres de fabrication
                            </div>
                          )}
                        </div>
                        )} {/* fin section multi-pièces */}

                        {/* Actions */}
                        <div className="mt-3 flex gap-2 flex-wrap">
                          <button
                            onClick={() => loadOrdreDetails(ordre.id)}
                            className="text-xs px-3 py-1.5 bg-orange-600 text-white rounded hover:bg-orange-700 flex items-center gap-1"
                          >
                            <Eye size={13} /> Voir détails complets
                          </button>

                          {/* Fiche générale — résumé tous bijoux */}
                          <button
                            onClick={async (e) => {
                              e.stopPropagation();
                              try {
                                // Charger les enfants si pas encore fait
                                let enfantsList = piecesOf[ordre.id] || [];
                                if (enfantsList.length === 0 && parseInt(ordre.quantite_pieces || 1) > 1) {
                                  const res = await api.get(`${API_URL}/atelier/ordres-fabrication/${ordre.id}/enfants`);
                                  enfantsList = (res.data?.enfants || []).map(e => ({
                                    ...e,
                                    reference_piece: e.numero_ordre,
                                    numero_piece: e.piece_index || 1,
                                    ouvrier_nom: e.artisan_nom || null,
                                    nb_etapes: parseInt(e.nb_etapes || 0),
                                    etapes_terminees: parseInt(e.etapes_terminees || 0),
                                  }));
                                }
                                // Charger les étapes du premier enfant (communes à tous)
                                let etapesCommunes = [];
                                if (enfantsList.length > 0) {
                                  try {
                                    const h = { Authorization: `Bearer ${localStorage.getItem('token')}` };
                                    const r = await fetch(`${API_URL}/atelier/fabrication/${enfantsList[0].id}`, { headers: h });
                                    if (r.ok) { const d = await r.json(); etapesCommunes = d.etapes || d.etapes_devis || []; }
                                  } catch {}
                                }
                                const { generateFicheGeneralePDF } = await import('../../utils/pdfGenerator');
                                generateFicheGeneralePDF(ordre, enfantsList, etapesCommunes);
                              } catch (err) {
                                alert('Erreur fiche générale: ' + err.message);
                              }
                            }}
                            className="text-xs px-3 py-1.5 bg-gray-800 text-white rounded hover:bg-gray-900 flex items-center gap-1"
                          >
                            <Printer size={11} /> Fiche Générale
                          </button>

                          {piecesOf[ordre.id] && (
                            <button
                              onClick={() => loadPiecesOf(ordre.id)}
                              className="text-xs px-3 py-1.5 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 flex items-center gap-1"
                            >
                              <RefreshCw size={11} /> Rafraîchir bijoux
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                  </React.Fragment>
                  );
                })}
            </tbody>
          </table>
        </div>

        {ordresFiltres.length === 0 && (
          <div className="text-center py-12">
            <Wrench className="h-16 w-16 mx-auto mb-4 text-gray-400" />
            <p className="text-xl text-gray-500">
              {searchTerm ? 'Aucun résultat trouvé' : 'Aucun ordre de fabrication'}
            </p>
          </div>
        )}
        </div>
        </>);
      })()}

      {/* Modal de création */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-orange-600 to-red-600 text-white px-6 py-4 flex justify-between items-center">
              <div className="flex items-center space-x-3">
                <Wrench className="h-6 w-6" />
                <h3 className="text-xl font-bold">Nouvel ordre de fabrication</h3>
              </div>
              <button
                onClick={() => setShowModal(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-6">
              {/* Sélection du mode de création */}
              <div className="bg-blue-50 p-4 rounded-lg border-2 border-blue-200">
                <h4 className="font-bold text-blue-900 mb-3">📋 Créer à partir de :</h4>
                <div className="flex space-x-4">
                  <button
                    type="button"
                    onClick={() => {
                      setModeCreation('devis');
                      setShowModalDevis(true);
                      setShowModal(false);
                    }}
                    className={`flex-1 px-6 py-4 rounded-lg border-2 transition-all ${
                      modeCreation === 'devis'
                        ? 'bg-blue-600 text-white border-blue-600 shadow-lg'
                        : 'bg-white text-gray-700 border-gray-300 hover:border-blue-400'
                    }`}
                  >
                    <FileText className="h-6 w-6 mx-auto mb-2" />
                    <div className="font-semibold">Rechercher un Devis</div>
                    <div className="text-xs mt-1 opacity-80">Lancer depuis un devis existant</div>
                  </button>
                  
                  <button
                    type="button"
                    onClick={() => setModeCreation('bijou')}
                    className={`flex-1 px-6 py-4 rounded-lg border-2 transition-all ${
                      modeCreation === 'bijou'
                        ? 'bg-purple-600 text-white border-purple-600 shadow-lg'
                        : 'bg-white text-gray-700 border-gray-300 hover:border-purple-400'
                    }`}
                  >
                    <Package className="h-6 w-6 mx-auto mb-2" />
                    <div className="font-semibold">Rechercher un Bijou</div>
                    <div className="text-xs mt-1 opacity-80">Reproduire une création précédente</div>
                  </button>
                </div>
              </div>

              {/* Recherche de bijou existant */}
              {modeCreation === 'bijou' && (
                <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                  <h4 className="font-bold text-purple-900 mb-3">🔍 Rechercher un bijou déjà créé</h4>
                  <input
                    type="text"
                    placeholder="Tapez une référence, nom, ou description..."
                    className="w-full px-4 py-3 border-2 border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 mb-3"
                    onChange={(e) => {
                      const term = e.target.value.toLowerCase();
                      if (term.length > 2) {
                        // Rechercher dans les ordres de fabrication terminés
                        const resultats = ordres.filter(ordre => 
                          ordre.statut === 'terminee' && (
                            ordre.numero_ordre?.toLowerCase().includes(term) ||
                            ordre.type_bijou?.toLowerCase().includes(term) ||
                            ordre.description?.toLowerCase().includes(term) ||
                            ordre.reference_produit?.toLowerCase().includes(term)
                          )
                        );
                        setBijouxExistants(resultats);
                      } else {
                        setBijouxExistants([]);
                      }
                    }}
                  />
                  
                  {bijouxExistants.length > 0 && (
                    <div className="space-y-2 max-h-60 overflow-y-auto">
                      {bijouxExistants.map((bijou) => (
                        <div
                          key={bijou.id}
                          onClick={() => {
                            setBijouSelectionne(bijou);
                            setFormData({
                              ...formData,
                              reference_bijou: `${bijou.numero_ordre}-COPY`,
                              type_bijou: bijou.type_bijou || 'bague',
                              description: bijou.description || '',
                            });
                          }}
                          className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                            bijouSelectionne?.id === bijou.id
                              ? 'bg-purple-100 border-purple-500'
                              : 'bg-white border-gray-300 hover:border-purple-400'
                          }`}
                        >
                          <div className="flex justify-between items-start">
                            <div>
                              <div className="font-bold text-purple-900">{bijou.numero_ordre}</div>
                              <div className="text-sm text-gray-700">{bijou.type_bijou} - {bijou.description}</div>
                              {bijou.reference_produit && (
                                <div className="text-xs text-gray-500 mt-1">Réf: {bijou.reference_produit}</div>
                              )}
                            </div>
                            {bijouSelectionne?.id === bijou.id && (
                              <Check className="h-5 w-5 text-purple-600" />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Informations générales */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Référence bijou *</label>
                  <input
                    type="text"
                    value={formData.reference_bijou}
                    onChange={(e) => setFormData({...formData, reference_bijou: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                    required
                    placeholder="Ex: BAG-001-UNIQUE"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Type de bijou *</label>
                  <select
                    value={formData.type_bijou}
                    onChange={(e) => setFormData({...formData, type_bijou: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                  >
                    {typesBijoux.map(type => (
                      <option key={type} value={type}>{type.replace('_', ' ').toUpperCase()}</option>
                    ))}
                  </select>
                </div>

                <div className="col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Description *</label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                    rows="2"
                    required
                    placeholder="Description détaillée du bijou à fabriquer"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Client</label>
                  <input
                    type="text"
                    value={formData.client_nom}
                    onChange={(e) => setFormData({...formData, client_nom: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                    placeholder="Nom du client (optionnel)"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date livraison prévue</label>
                  <input
                    type="date"
                    value={formData.date_livraison_prevue}
                    onChange={(e) => setFormData({...formData, date_livraison_prevue: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Prix estimé (DH)</label>
                  <input
                    type="text" inputMode="decimal" onFocus={e => e.target.select()}
                    step="0.01"
                    value={formData.prix_estime}
                    onChange={(e) => setFormData({...formData, prix_estime: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                    placeholder="0.00"
                  />
                </div>
              </div>

              {/* Ajouter des composants */}
              <div className="border-t pt-4">
                <h4 className="text-lg font-bold text-gray-800 mb-3">Composants nécessaires</h4>
                <div className="grid grid-cols-4 gap-3">
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Composant *</label>
                    <select
                      value={nouveauComposant.composant_id}
                      onChange={(e) => setNouveauComposant({...nouveauComposant, composant_id: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                    >
                      <option value="">Sélectionner un composant</option>
                      {composants.map(c => (
                        <option key={c.id} value={c.id}>
                          {c.reference || c.nom} - Stock: {parseFloat(c.quantite_stock || 0).toFixed(3)} {c.unite}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Quantité estimée *</label>
                    <input
                      type="text" inputMode="decimal" onFocus={e => e.target.select()}
                      step="0.001"
                      value={nouveauComposant.quantite_estimee}
                      onChange={(e) => setNouveauComposant({...nouveauComposant, quantite_estimee: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                      placeholder="0.000"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Unité</label>
                    <select
                      value={nouveauComposant.unite}
                      onChange={(e) => setNouveauComposant({...nouveauComposant, unite: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                    >
                      {unites.map(u => (
                        <option key={u} value={u}>{u}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={ajouterComposant}
                  className="mt-3 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors flex items-center space-x-2"
                >
                  <Plus className="h-4 w-4" />
                  <span>Ajouter le composant</span>
                </button>
              </div>

              {/* Liste des composants */}
              {formData.composants.length > 0 && (
                <div className="border-t pt-4">
                  <h4 className="text-lg font-bold text-gray-800 mb-3">Composants ajoutés</h4>
                  <div className="space-y-2">
                    {formData.composants.map((comp, index) => (
                      <div key={index} className="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
                        <div className="flex-1">
                          <div className="font-semibold text-gray-800">{comp.composant_nom}</div>
                          <div className="text-sm text-gray-600">
                            Quantité estimée: {comp.quantite_estimee} {comp.unite}
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => supprimerComposant(index)}
                          className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Notes */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
                <textarea
                  value={formData.notes}
                  onChange={(e) => setFormData({...formData, notes: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
                  rows="3"
                  placeholder="Notes supplémentaires..."
                />
              </div>

              <div className="flex justify-end space-x-3 pt-4 border-t">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={saving || formData.composants.length === 0}
                  className="px-6 py-2 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg hover:from-orange-700 hover:to-red-700 transition-all flex items-center space-x-2 disabled:opacity-50"
                >
                  <Save className="h-5 w-5" />
                  <span>{saving ? 'Création...' : 'Créer l\'ordre'}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de détails */}
      {showDetailModal && selectedOrdre && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end sm:items-center justify-center z-50 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-lg shadow-xl sm:max-w-4xl w-full max-h-[95vh] sm:max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-orange-600 to-red-600 text-white px-4 sm:px-6 py-3 sm:py-4 sticky top-0 z-10">
              <div className="flex justify-between items-center mb-2 sm:mb-0">
              <h3 className="text-lg sm:text-xl font-bold">OF #{selectedOrdre.ordre?.numero_ordre || selectedOrdre.ordre?.ref_article || ''}</h3>
              <button
                onClick={() => setShowDetailModal(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-1.5 transition-colors"
              >
                <X className="h-5 w-5" />
              </button>
              </div>
              <div className="flex flex-wrap gap-2 items-center">
                <button
                  onClick={() => setShowFicheFabrication(true)}
                  className="px-3 py-1.5 bg-white text-orange-600 rounded-lg hover:bg-orange-50 transition-colors flex items-center gap-1.5 text-sm font-semibold"
                >
                  <FileText className="h-4 w-4" />
                  <span>Fiche Fab.</span>
                </button>
                <button
                  onClick={async () => {
                    try {
                      const { generateFicheFabricationPDF } = await import('../../utils/pdfGenerator');
                      const o = selectedOrdre.ordre || selectedOrdre;
                      const res = await fetch(`${API_URL}/bijoux/ref/${o.ref_article || o.reference_article || 'X'}/fiche-complete`, {
                        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                      });
                      const fiche = res.ok ? await res.json() : {};
                      generateFicheFabricationPDF(
                        o,
                        fiche.bijou || {},
                        selectedOrdre.etapes || fiche.etapes_production || fiche.etapes_fabrication || [],
                        fiche.composants || [],
                        fiche.pierres_of || []
                      );
                    } catch (e) { alert('Erreur impression: ' + e.message); }
                  }}
                  className="px-2.5 py-1.5 bg-white text-gray-600 rounded-lg hover:bg-gray-100 transition-colors flex items-center"
                  title="Imprimer la fiche"
                >
                  <Printer className="h-4 w-4" />
                </button>
                {selectedOrdre.ordre?.statut !== 'termine' && selectedOrdre.ordre?.statut !== 'terminee' && (
                  <button
                    onClick={() => {
                      // Hotfix : modal partage remplace prompt() + alert()
                      const ordreId = selectedOrdre.ordre?.id || selectedOrdre.id;
                      setControleFinalOfId(ordreId);
                      setShowControleFinalModal(true);
                    }}
                    className="px-3 py-1.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center gap-1.5 text-sm font-semibold"
                  >
                    <CheckCircle className="h-4 w-4" />
                    <span>Réceptionner</span>
                  </button>
                )}
                {(selectedOrdre.ordre?.statut === 'terminee' || selectedOrdre.ordre?.statut === 'termine') && (
                  <button
                    onClick={() => { setShowDetailModal(false); setShowFicheBijouTermine(true); }}
                    className="px-3 py-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-1.5 text-sm font-semibold"
                  >
                    <Eye className="h-4 w-4" />
                    <span>Fiche Bijou</span>
                  </button>
                )}
                {/* Bouton valider fiche de production réelle */}
                {(selectedOrdre.ordre?.statut === 'termine' || selectedOrdre.ordre?.statut === 'terminee') &&
                 selectedOrdre.ordre?.ref_article && (
                  <button
                    onClick={() => {
                      const refArt = selectedOrdre.ordre?.ref_article;
                      const nbEtapes = (selectedOrdre.etapes || []).filter(e => e.statut === 'terminee' || e.statut === 'validee').length;
                      if (!window.confirm(
                        `Valider la fiche de production réelle pour "${refArt}" ?\n\n` +
                        `${nbEtapes} étape(s) réellement faites seront enregistrées comme nouveau modèle de production.\n\n` +
                        `Cette fiche remplacera le devis pour les prochaines productions de ce bijou.`
                      )) return;
                      const ofId = selectedOrdre.ordre?.id || selectedOrdre.id;
                      fetch(`${API_URL}/atelier/ordres-fabrication/${ofId}/valider-fiche`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                      }).then(r => r.json()).then(d => {
                        if (d.error) { alert('Erreur : ' + d.error); }
                        else { alert(`Fiche de production validée pour "${refArt}".\n${nbEtapes} étapes enregistrées comme référence.`); }
                      }).catch(e => alert('Erreur : ' + e.message));
                    }}
                    className="px-3 py-1.5 bg-emerald-50 text-emerald-700 border border-emerald-300 rounded-lg hover:bg-emerald-100 transition-colors flex items-center gap-1.5 text-sm font-medium"
                    title="Valider les étapes réelles comme fiche de production de référence"
                  >
                    <CheckCircle className="h-4 w-4" />
                    <span>Valider fiche prod</span>
                  </button>
                )}

                {selectedOrdre.ordre?.statut !== 'termine' && selectedOrdre.ordre?.statut !== 'terminee' && selectedOrdre.ordre?.statut !== 'annule' && (
                  <button
                    onClick={() => {
                      const motif = prompt('Motif d\'annulation (optionnel) :');
                      if (motif === null) return; // annulé par l'utilisateur
                      if (!window.confirm(`Annuler l'OF ${selectedOrdre.ordre?.numero_ordre} ?\n\nL'OF sera conservé dans l'historique mais marqué comme annulé.`)) return;
                      fetch(`${API_URL}/atelier/ordres-fabrication/${selectedOrdre.ordre?.id || selectedOrdre.id}/annuler`, {
                        method: 'PATCH',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
                        body: JSON.stringify({ motif: motif || '' })
                      }).then(r => r.json()).then(d => {
                        if (d.error) { alert('Erreur: ' + d.error); }
                        else { alert(`${d.message}`); setShowDetailModal(false); loadData(); }
                      }).catch(e => alert('Erreur: ' + e.message));
                    }}
                    className="px-3 py-1.5 bg-red-50 text-red-600 border border-red-200 rounded-lg hover:bg-red-100 transition-colors flex items-center gap-1.5 text-sm font-medium"
                    title="Annuler cet ordre de fabrication (conservé dans l'historique)"
                  >
                    <span>✕ Annuler OF</span>
                  </button>
                )}
              </div>
            </div>

            <div className="p-3 sm:p-6 space-y-4 sm:space-y-6">
              {/* Informations générales */}
              <div className="bg-gradient-to-r from-orange-50 to-red-50 p-3 sm:p-4 rounded-lg">
                <h4 className="text-base sm:text-lg font-bold text-gray-800 mb-3 sm:mb-4 flex items-center">
                  <FileText className="h-5 w-5 mr-2 text-orange-600" />
                  Informations générales
                </h4>
                {/* Référence unique + OF + Image */}
                <div className="flex items-center gap-3 mb-3 p-3 bg-white rounded-lg border border-orange-200">
                  {imagePrincipale && (
                    <img src={imagePrincipale} alt=""
                      className="w-20 h-20 object-cover rounded-xl border-2 border-orange-200 shadow flex-shrink-0"
                      onError={e => { e.target.style.display='none'; }} />
                  )}
                  {/* Image bijou */}
                  {(() => {
                    const imgUrl = selectedOrdre.ordre?.image_url || (selectedOrdre.bijoux && selectedOrdre.bijoux[0]?.image_url);
                    return imgUrl ? (
                      <img src={imgUrl.startsWith('/') ? `${API_URL.replace("/api","")}${imgUrl}` : imgUrl}
                        alt="" className="w-16 h-16 object-cover rounded-lg border" onError={e => { e.target.style.display='none'; }} />
                    ) : null;
                  })()}
                  <div className="flex-1">
                    <div className="text-xs text-gray-500 uppercase tracking-wider">Référence bijou</div>
                    <div className="font-bold text-orange-700 text-xl font-mono tracking-wider">
                      {selectedOrdre.ordre?.ref_article || selectedOrdre.ordre?.numero_ordre || 'N/A'}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-xs text-gray-500">Ordre de fabrication</div>
                    <div className="text-sm font-semibold text-gray-700">{selectedOrdre.ordre?.numero_ordre}</div>
                    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold mt-1 ${getStatutBadge(selectedOrdre.ordre?.statut)}`}>
                      {getStatutLabel(selectedOrdre.ordre?.statut)}
                    </span>
                  </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-2 gap-3">
                  <div>
                    <div className="text-sm text-gray-600">Type de bijou</div>
                    <div className="font-semibold text-gray-800 capitalize">{selectedOrdre.ordre?.type_bijou ? selectedOrdre.ordre.type_bijou.replace('_', ' ') : 'Non spécifié'}</div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600">Couleur or</div>
                    <div className="font-semibold text-gray-800">{selectedOrdre.ordre?.couleur_or || '—'}</div>
                  </div>
                  {selectedOrdre.ordre?.client_nom && (
                    <div>
                      <div className="text-sm text-gray-600">Client</div>
                      <div className="font-semibold text-gray-800">{selectedOrdre.ordre.client_nom}</div>
                    </div>
                  )}
                  {selectedOrdre.ordre?.collection_nom && (
                    <div>
                      <div className="text-sm text-gray-600">Collection</div>
                      <div className="font-semibold text-gray-800">{selectedOrdre.ordre.collection_nom}</div>
                    </div>
                  )}
                  {selectedOrdre.ordre?.artisan_nom && (
                    <div>
                      <div className="text-sm text-gray-600 flex items-center">
                        <User className="h-4 w-4 mr-1" />
                        Ouvrier assigné
                      </div>
                      <div className="font-semibold text-blue-600">{selectedOrdre.ordre.artisan_nom}</div>
                    </div>
                  )}
                  <div className="col-span-2">
                    <div className="text-sm text-gray-600">Description</div>
                    <div className="text-gray-800 mt-1">{selectedOrdre.ordre?.description || 'Aucune description'}</div>
                  </div>
                  <div className="col-span-2">
                    {editingNotes ? (
                      <div className="bg-red-50 border-2 border-red-400 rounded-lg p-3">
                        <div className="text-xs font-bold text-red-700 uppercase tracking-wider mb-2 flex items-center gap-1">
                          ⚠️ Note importante — visible en rouge sur la fiche
                        </div>
                        <textarea
                          autoFocus
                          value={notesValue}
                          onChange={e => setNotesValue(e.target.value)}
                          className="w-full px-3 py-2 border-2 border-red-300 rounded-lg bg-white text-red-900 font-medium text-sm focus:ring-2 focus:ring-red-400"
                          rows="3"
                          placeholder="Ex: Taille 54, gravure intérieure, attention rhodiage renforcé..."
                        />
                        <div className="flex gap-2 mt-2">
                          <button
                            onClick={async () => {
                              const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
                              await api.put(`${API_URL}/atelier/fabrication/${ordreId}`, {
                                statut: selectedOrdre.ordre.statut,
                                notes: notesValue || null,
                              });
                              selectedOrdre.ordre.notes = notesValue || null;
                              setEditingNotes(false);
                              loadOrdreDetails(ordreId);
                            }}
                            className="px-4 py-1.5 bg-red-600 text-white rounded-lg text-sm font-semibold hover:bg-red-700"
                          >Enregistrer</button>
                          <button
                            onClick={() => setEditingNotes(false)}
                            className="px-4 py-1.5 bg-gray-200 text-gray-700 rounded-lg text-sm hover:bg-gray-300"
                          >Annuler</button>
                        </div>
                      </div>
                    ) : (selectedOrdre.ordre?.notes || selectedOrdre.ordre?.observations) ? (
                      <div
                        className="bg-red-50 border-2 border-red-400 rounded-lg p-3 flex items-start gap-2 cursor-pointer hover:bg-red-100 transition-colors"
                        onClick={() => { setNotesValue(selectedOrdre.ordre.notes || selectedOrdre.ordre.observations || ''); setEditingNotes(true); }}
                        title="Cliquer pour modifier"
                      >
                        <span className="text-red-500 text-lg flex-shrink-0">⚠️</span>
                        <div className="flex-1">
                          <div className="text-xs font-bold text-red-700 uppercase tracking-wider mb-0.5">Note importante</div>
                          <div className="text-red-800 font-medium text-sm">{selectedOrdre.ordre.notes || selectedOrdre.ordre.observations}</div>
                        </div>
                        <span className="text-red-400 text-xs">✏️</span>
                      </div>
                    ) : (
                      <button
                        onClick={() => { setNotesValue(''); setEditingNotes(true); }}
                        className="w-full text-left px-3 py-2 border-2 border-dashed border-red-300 rounded-lg text-red-400 text-sm hover:border-red-500 hover:text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2"
                      >
                        <span>⚠️</span>
                        <span>+ Ajouter une note importante (visible en rouge sur la fiche)</span>
                      </button>
                    )}
                  </div>
                  {selectedOrdre.ordre?.barcode && (
                    <div className="col-span-2">
                      <div className="text-sm text-gray-600 mb-2">Code-barre</div>
                      <div className="bg-white p-3 rounded-lg border-2 border-orange-200 inline-block">
                        <Barcode value={selectedOrdre.ordre.barcode} height={50} width={2} displayValue={true} />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Poids produit fini - style fiche physique */}
              {(() => {
                const poidsOr = parseFloat(selectedOrdre.ordre?.poids_metal || selectedOrdre.poids_or || 0);
                const poidsPierresG = (selectedOrdre.pierres || []).reduce(
                  (s, p) => s + parseFloat(p.poids_total_carats || 0) * 0.2, 0
                );
                const poidsInc = poidsOr + poidsPierresG;
                if (poidsOr === 0 && poidsPierresG === 0) return null;
                return (
                  <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                    <h4 className="text-sm font-bold text-gray-700 mb-3 uppercase tracking-wider">
                      Poids unitaire produit fini
                    </h4>
                    <table className="w-full text-sm border-collapse">
                      <thead>
                        <tr className="bg-gray-200 text-gray-700 text-xs font-semibold">
                          <th className="text-left px-3 py-2"></th>
                          <th className="text-right px-3 py-2">NU (métal seul)</th>
                          <th className="text-right px-3 py-2">PIER. INC</th>
                          <th className="text-right px-3 py-2">Pierres seules (g)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="bg-white">
                          <td className="px-3 py-2 text-gray-500 text-xs">Poids (g)</td>
                          <td className="px-3 py-2 text-right font-bold text-gray-800">{poidsOr.toFixed(3)}</td>
                          <td className="px-3 py-2 text-right font-bold text-orange-700">{poidsInc.toFixed(3)}</td>
                          <td className="px-3 py-2 text-right font-bold text-blue-700">{poidsPierresG.toFixed(3)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                );
              })()}

              {/* Fonte */}
              {fonte && (fonte.numero_fonte || fonte.poids_avant || fonte.poids_apres) && (
                <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
                  <h4 className="text-sm font-bold text-gray-700 mb-3 uppercase tracking-wider flex items-center gap-2">
                    <Flame className="h-4 w-4 text-amber-600" />
                    Fonte
                  </h4>
                  <div className="grid grid-cols-3 gap-4 text-sm">
                    {fonte.numero_fonte && (
                      <div>
                        <div className="text-xs text-gray-500">N° Fonte / Moule</div>
                        <div className="font-bold text-amber-800 font-mono text-lg">{fonte.numero_fonte}</div>
                      </div>
                    )}
                    {(fonte.poids_avant || fonte.poids_apres) && (
                      <div>
                        <div className="text-xs text-gray-500">Poids (avant / après)</div>
                        <div className="font-semibold text-gray-800">
                          {fonte.poids_avant ? `${parseFloat(fonte.poids_avant).toFixed(3)} g` : '—'}
                          {' / '}
                          {fonte.poids_apres ? `${parseFloat(fonte.poids_apres).toFixed(3)} g` : '—'}
                        </div>
                      </div>
                    )}
                    {fonte.operateur && (
                      <div>
                        <div className="text-xs text-gray-500">Opérateur</div>
                        <div className="font-semibold text-gray-800">{fonte.operateur}</div>
                      </div>
                    )}
                    {fonte.date_fonte && (
                      <div>
                        <div className="text-xs text-gray-500">Date</div>
                        <div className="font-semibold text-gray-800">{new Date(fonte.date_fonte).toLocaleDateString('fr-FR')}</div>
                      </div>
                    )}
                    {fonte.notes && (
                      <div className="col-span-3">
                        <div className="text-xs text-gray-500">Notes</div>
                        <div className="text-gray-700 italic">{fonte.notes}</div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Dates et délais */}
              <div className="bg-blue-50 p-4 rounded-lg">
                <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                  <Calendar className="h-5 w-5 mr-2 text-blue-600" />
                  Dates et délais
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <div className="text-sm text-gray-600">Date de commande</div>
                    <div className="font-semibold text-gray-800">{selectedOrdre.ordre?.date_commande ? new Date(selectedOrdre.ordre.date_commande).toLocaleDateString('fr-FR') : 'N/A'}</div>
                  </div>
                  <div>
                    <div className="text-sm text-gray-600">Livraison prévue</div>
                    <div className="font-semibold text-gray-800">{selectedOrdre.ordre?.date_livraison_prevue ? new Date(selectedOrdre.ordre.date_livraison_prevue).toLocaleDateString('fr-FR') : 'Non définie'}</div>
                  </div>
                  {selectedOrdre.ordre?.date_livraison_reelle && (
                    <div>
                      <div className="text-sm text-gray-600">Livraison réelle</div>
                      <div className="font-semibold text-green-600">
                        {new Date(selectedOrdre.ordre.date_livraison_reelle).toLocaleDateString('fr-FR')}
                        {new Date(selectedOrdre.date_livraison_reelle).toLocaleDateString('fr-FR')}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Informations financières — admin seulement */}
              {isAdmin() && (
              <div className="bg-green-50 p-4 rounded-lg">
                <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                  <DollarSign className="h-5 w-5 mr-2 text-green-600" />
                  Informations financières
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  {selectedOrdre.ordre?.prix_devis && (
                    <div>
                      <div className="text-sm text-gray-600">Prix devis</div>
                      <div className="font-bold text-green-600 text-lg">{parseFloat(selectedOrdre.ordre.prix_devis).toLocaleString()} DH</div>
                    </div>
                  )}
                  {selectedOrdre.ordre?.prix_final && (
                    <div>
                      <div className="text-sm text-gray-600">Prix final</div>
                      <div className="font-bold text-green-600 text-lg">{parseFloat(selectedOrdre.ordre.prix_final).toLocaleString()} DH</div>
                    </div>
                  )}
                  {selectedOrdre.ordre?.acompte > 0 && (
                    <div>
                      <div className="text-sm text-gray-600">Acompte versé</div>
                      <div className="font-semibold text-gray-800">{parseFloat(selectedOrdre.ordre.acompte).toLocaleString()} DH</div>
                    </div>
                  )}
                </div>
              </div>
              )}

              {/* ─── BILAN OR & MATIÈRES ─── */}
              {selectedOrdre.bilan_matieres && selectedOrdre.bilan_matieres.lignes && selectedOrdre.bilan_matieres.lignes.length > 0 && (() => {
                const bm = selectedOrdre.bilan_matieres;
                const tot = bm.totaux || {};
                const coffres = bm.coffres_ouvriers || [];
                const nonRetrouve = tot.or_non_retrouve != null ? parseFloat(tot.or_non_retrouve) : null;
                return (
                  <div className="bg-amber-50 border-2 border-amber-300 rounded-xl p-4 mb-4">
                    <h4 className="text-base font-bold text-amber-800 mb-3 flex items-center gap-2">
                      🥇 Bilan Or — Suivi gramme par gramme
                    </h4>

                    {/* Tableau étape par étape */}
                    <div className="overflow-x-auto mb-3">
                      <table className="w-full text-xs">
                        <thead>
                          <tr className="bg-amber-100 text-amber-900">
                            <th className="px-2 py-1.5 text-left rounded-tl">Étape</th>
                            <th className="px-2 py-1.5 text-left">Ouvrier</th>
                            <th className="px-2 py-1.5 text-right">Or donné</th>
                            <th className="px-2 py-1.5 text-right">Poids avant</th>
                            <th className="px-2 py-1.5 text-right">Poids après</th>
                            <th className="px-2 py-1.5 text-right">Or retour</th>
                            <th className="px-2 py-1.5 text-center rounded-tr">Statut</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bm.lignes.map((l, i) => {
                            const diff = l.poids_bijou_apres != null && l.poids_bijou_avant != null
                              ? (parseFloat(l.poids_bijou_apres) - parseFloat(l.poids_bijou_avant)).toFixed(3)
                              : null;
                            return (
                              <tr key={i} className={`border-b border-amber-100 ${l.statut === 'en_cours' ? 'bg-orange-50' : 'bg-white'}`}>
                                <td className="px-2 py-1.5 font-medium text-gray-700">{l.nom_etape}</td>
                                <td className="px-2 py-1.5 text-gray-500">{l.ouvrier || '—'}</td>
                                <td className="px-2 py-1.5 text-right font-mono">
                                  {l.or_donne ? <span className="text-orange-700 font-bold">+{parseFloat(l.or_donne).toFixed(3)}g</span> : <span className="text-gray-300">—</span>}
                                </td>
                                <td className="px-2 py-1.5 text-right font-mono text-gray-500">
                                  {l.poids_bijou_avant != null ? `${parseFloat(l.poids_bijou_avant).toFixed(3)}g` : '—'}
                                </td>
                                <td className="px-2 py-1.5 text-right font-mono">
                                  {l.poids_bijou_apres != null ? (
                                    <span className="font-bold text-amber-800">{parseFloat(l.poids_bijou_apres).toFixed(3)}g
                                      {diff && <span className={`ml-1 text-xs ${parseFloat(diff) < 0 ? 'text-red-500' : parseFloat(diff) > 0 ? 'text-green-600' : 'text-gray-400'}`}>({parseFloat(diff) >= 0 ? '+' : ''}{diff})</span>}
                                    </span>
                                  ) : <span className="text-gray-300">—</span>}
                                </td>
                                <td className="px-2 py-1.5 text-right font-mono">
                                  {l.or_retourne != null ? <span className="text-green-700">↩ {parseFloat(l.or_retourne).toFixed(3)}g</span>
                                   : l.or_en_cours ? <span className="text-orange-500 font-semibold">En coffre</span>
                                   : <span className="text-gray-300">—</span>}
                                </td>
                                <td className="px-2 py-1.5 text-center">
                                  {l.statut === 'termine' ? <span className="bg-green-100 text-green-700 px-1.5 py-0.5 rounded text-xs">✓</span>
                                   : l.statut === 'en_cours' ? <span className="bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded text-xs animate-pulse">⟳</span>
                                   : <span className="text-gray-300">—</span>}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {/* Totaux */}
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3">
                      <div className="bg-white rounded-lg p-2 border border-amber-200 text-center">
                        <div className="text-xs text-gray-500">Or sorti stock</div>
                        <div className="font-bold text-orange-700">{parseFloat(tot.or_sorti_stock || 0).toFixed(3)}g</div>
                      </div>
                      <div className="bg-white rounded-lg p-2 border border-amber-200 text-center">
                        <div className="text-xs text-gray-500">Poids bijou final</div>
                        <div className="font-bold text-amber-800">{parseFloat(tot.poids_bijou_final || 0).toFixed(3)}g</div>
                      </div>
                      <div className="bg-white rounded-lg p-2 border border-amber-200 text-center">
                        <div className="text-xs text-gray-500">Or retourné</div>
                        <div className="font-bold text-green-700">↩ {parseFloat(tot.or_retourne_stock || 0).toFixed(3)}g</div>
                      </div>
                      <div className={`rounded-lg p-2 border text-center ${nonRetrouve != null && nonRetrouve > 0.05 ? 'bg-red-50 border-red-300' : 'bg-green-50 border-green-200'}`}>
                        <div className="text-xs text-gray-500">Solde / Perte</div>
                        <div className={`font-bold ${nonRetrouve != null && nonRetrouve > 0.05 ? 'text-red-600' : 'text-green-600'}`}>
                          {nonRetrouve != null ? `${nonRetrouve > 0 ? '+' : ''}${parseFloat(nonRetrouve).toFixed(3)}g` : '—'}
                        </div>
                      </div>
                    </div>

                    {/* Coffres ouvriers en cours */}
                    {coffres.length > 0 && (
                      <div className="bg-orange-100 border border-orange-300 rounded-lg p-2">
                        <div className="text-xs font-bold text-orange-800 mb-1.5">⚠️ Or encore dans coffres ouvriers (à récupérer)</div>
                        <div className="flex flex-wrap gap-2">
                          {coffres.map((c, i) => (
                            <div key={i} className="bg-white border border-orange-200 rounded px-2 py-1 text-xs">
                              <span className="font-semibold text-orange-700">{c.nom}</span>
                              {c.or_g > 0 && <span className="ml-1 text-orange-600">Or: {parseFloat(c.or_g).toFixed(3)}g</span>}
                              {c.diamant_ct > 0 && <span className="ml-1 text-purple-600">💎 {parseFloat(c.diamant_ct).toFixed(2)}ct</span>}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* Analyse des coûts - Théorique vs Réel — admin seulement */}
              {isAdmin() && selectedOrdre.analyse_couts && (selectedOrdre.analyse_couts.temps_reel_total > 0 || selectedOrdre.analyse_couts.temps_estime_total > 0) && (
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border-2 border-blue-200">
                  <h4 className="text-lg font-bold text-blue-800 mb-4 flex items-center">
                    📊 Analyse Théorique vs Réel
                  </h4>
                  
                  {/* Temps */}
                  <div className="mb-4 p-3 bg-white rounded-lg">
                    <div className="text-sm font-semibold text-gray-700 mb-2">⏱️ Temps de fabrication</div>
                    <div className="grid grid-cols-3 gap-4 text-sm">
                      <div>
                        <div className="text-xs text-gray-600">Théorique</div>
                        <div className="font-bold text-blue-600">{Number(selectedOrdre.analyse_couts.temps_estime_total || 0).toFixed(1)}h</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-600">Réel</div>
                        <div className="font-bold text-purple-600">{Number(selectedOrdre.analyse_couts.temps_reel_total || 0).toFixed(1)}h</div>
                      </div>
                      <div>
                        <div className="text-xs text-gray-600">Écart</div>
                        <div className={`font-bold ${selectedOrdre.analyse_couts.ecart_temps > 0 ? 'text-red-600' : 'text-green-600'}`}>
                          {selectedOrdre.analyse_couts.ecart_temps > 0 ? '+' : ''}{Number(selectedOrdre.analyse_couts.ecart_temps || 0).toFixed(1)}h
                          ({selectedOrdre.analyse_couts.pourcentage_ecart_temps > 0 ? '+' : ''}{selectedOrdre.analyse_couts.pourcentage_ecart_temps || 0}%)
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Coûts */}
                  {selectedOrdre.analyse_couts.cout_reel_total > 0 && (
                    <div className="p-3 bg-white rounded-lg">
                      <div className="text-sm font-semibold text-gray-700 mb-2">💰 Coût main d'œuvre</div>
                      <div className="grid grid-cols-3 gap-4 text-sm">
                        <div>
                          <div className="text-xs text-gray-600">Théorique</div>
                          <div className="font-bold text-blue-600">{selectedOrdre.analyse_couts.cout_theorique.toLocaleString()} DH</div>
                        </div>
                        <div>
                          <div className="text-xs text-gray-600">Réel</div>
                          <div className="font-bold text-purple-600">{selectedOrdre.analyse_couts.cout_reel_total.toLocaleString()} DH</div>
                        </div>
                        <div>
                          <div className="text-xs text-gray-600">Écart</div>
                          <div className={`font-bold ${selectedOrdre.analyse_couts.ecart_cout > 0 ? 'text-red-600' : 'text-green-600'}`}>
                            {selectedOrdre.analyse_couts.ecart_cout > 0 ? '+' : ''}{selectedOrdre.analyse_couts.ecart_cout.toLocaleString()} DH
                            ({selectedOrdre.analyse_couts.pourcentage_ecart_cout > 0 ? '+' : ''}{selectedOrdre.analyse_couts.pourcentage_ecart_cout}%)
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Indicateur de performance */}
                  {selectedOrdre.analyse_couts.cout_reel_total > 0 && (
                    <div className={`mt-3 p-3 rounded-lg ${
                      selectedOrdre.analyse_couts.ecart_cout <= 0 
                        ? 'bg-green-100 border border-green-300' 
                        : selectedOrdre.analyse_couts.pourcentage_ecart_cout <= 10
                        ? 'bg-yellow-100 border border-yellow-300'
                        : 'bg-red-100 border border-red-300'
                    }`}>
                      <div className="flex items-center text-sm">
                        {selectedOrdre.analyse_couts.ecart_cout <= 0 ? (
                          <>
                            <span className="text-2xl mr-2">✅</span>
                            <span className="font-semibold text-green-800">
                              Excellent ! Fabrication dans le budget prévu.
                            </span>
                          </>
                        ) : selectedOrdre.analyse_couts.pourcentage_ecart_cout <= 10 ? (
                          <>
                            <span className="text-2xl mr-2">⚠️</span>
                            <span className="font-semibold text-yellow-800">
                              Attention : Léger dépassement du budget ({selectedOrdre.analyse_couts.pourcentage_ecart_cout}%)
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="text-2xl mr-2">❌</span>
                            <span className="font-semibold text-red-800">
                              Alerte : Dépassement important du budget ({selectedOrdre.analyse_couts.pourcentage_ecart_cout}%)
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Détails techniques */}
              {(selectedOrdre.metal || selectedOrdre.poids_metal || selectedOrdre.pierres_description) && (
                <div className="bg-purple-50 p-4 rounded-lg">
                  <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                    <Package className="h-5 w-5 mr-2 text-purple-600" />
                    Détails techniques
                  </h4>
                  <div className="grid grid-cols-2 gap-4">
                    {selectedOrdre.metal && (
                      <div>
                        <div className="text-sm text-gray-600">Métal</div>
                        <div className="font-semibold text-gray-800">{selectedOrdre.metal}</div>
                      </div>
                    )}
                    {selectedOrdre.poids_metal && (
                      <div>
                        <div className="text-sm text-gray-600">Poids métal</div>
                        <div className="font-semibold text-gray-800">{selectedOrdre.poids_metal} g</div>
                      </div>
                    )}
                    {selectedOrdre.pierres_description && (
                      <div className="col-span-2">
                        <div className="text-sm text-gray-600">Pierres</div>
                        <div className="text-gray-800">{selectedOrdre.pierres_description}</div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Composants du bijou (OR + Pierres unifiés, style fiche physique) */}
              {(selectedOrdre.matieres?.length > 0 || selectedOrdre.pierres?.length > 0) && (() => {
                // Construire une liste unifiée : matières (OR/métal/chaîne) + pierres
                const lignes = [];
                (selectedOrdre.matieres || []).forEach((m, i) => {
                  const qte = parseFloat(m.quantite_prevue || m.quantite_grammes || 0);
                  const prixU = parseFloat(m.prix_achat_unitaire || 0);
                  lignes.push({
                    key: `m${i}`,
                    type: 'matiere',
                    libelle: m.designation || m.type_matiere || '—',
                    reference: m.reference || '—',
                    qte: qte.toFixed(2),
                    unite: 'g',
                    poids: `${qte.toFixed(3)} g`,
                    prixU: prixU,
                    prixTotal: parseFloat(m.prix_total || qte * prixU),
                    info: m.type_matiere || '—',
                    emplacement: m.emplacement || '—',
                  });
                });
                (selectedOrdre.pierres || []).forEach((p, i) => {
                  const nb = parseFloat(p.nb_pierres || 1);
                  const pdsTotal = parseFloat(p.poids_total_carats || 0);
                  const prixCt = parseFloat(p.prix_achat_carat || p.prix_achat_unitaire || 0);
                  lignes.push({
                    key: `p${i}`,
                    type: 'pierre',
                    libelle: p.designation || p.type_matiere || '—',
                    reference: p.reference || '—',
                    qte: nb.toFixed(0),
                    unite: 'pc',
                    poids: `${pdsTotal.toFixed(4)} ct`,
                    prixU: prixCt,
                    prixTotal: parseFloat(p.prix_total || pdsTotal * prixCt),
                    info: p.taille_qualite || p.numero_certificat || '—',
                    emplacement: p.emplacement || '—',
                  });
                });
                const totalPrix = lignes.reduce((s, l) => s + (l.prixTotal || 0), 0);
                return (
                  <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                    <div className="bg-gray-700 text-white px-4 py-2 flex items-center gap-2">
                      <Package className="h-4 w-4" />
                      <span className="font-bold text-sm uppercase tracking-wider">Composants</span>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm border-collapse">
                        <thead>
                          <tr className="bg-gray-100 text-gray-600 text-xs font-semibold border-b border-gray-200">
                            <th className="text-left px-3 py-2">Libellé</th>
                            <th className="text-left px-3 py-2">Référence</th>
                            <th className="text-right px-3 py-2">Qté</th>
                            <th className="text-right px-3 py-2">Poids</th>
                            <th className="text-right px-3 py-2">Prix unit.</th>
                            <th className="text-right px-3 py-2">Total</th>
                            <th className="text-left px-3 py-2">Info</th>
                            <th className="text-left px-3 py-2">Empl.</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lignes.map((l) => (
                            <tr key={l.key} className={`border-b border-gray-100 hover:bg-gray-50 ${l.type === 'pierre' ? 'bg-blue-50/30' : ''}`}>
                              <td className="px-3 py-2 font-medium text-gray-800">{l.libelle}</td>
                              <td className="px-3 py-2 font-mono text-xs text-gray-500">{l.reference}</td>
                              <td className="px-3 py-2 text-right font-bold text-gray-700">{l.qte} <span className="text-gray-400 text-xs">{l.unite}</span></td>
                              <td className="px-3 py-2 text-right text-gray-600">{l.poids}</td>
                              <td className="px-3 py-2 text-right text-gray-500 text-xs">{l.prixU > 0 ? `${l.prixU.toLocaleString()} DH` : '—'}</td>
                              <td className="px-3 py-2 text-right font-semibold text-gray-800">{l.prixTotal > 0 ? `${l.prixTotal.toLocaleString(undefined, {maximumFractionDigits: 2})} DH` : '—'}</td>
                              <td className="px-3 py-2 text-xs text-gray-400">{l.info}</td>
                              <td className="px-3 py-2 text-xs text-gray-400">{l.emplacement}</td>
                            </tr>
                          ))}
                        </tbody>
                        {totalPrix > 0 && (
                          <tfoot>
                            <tr className="bg-gray-100 font-semibold text-gray-700 text-xs border-t border-gray-300">
                              <td colSpan={5} className="px-3 py-2">Total matières</td>
                              <td className="px-3 py-2 text-right font-bold text-gray-900">{totalPrix.toLocaleString(undefined, {maximumFractionDigits: 2})} DH</td>
                              <td colSpan={2}></td>
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    </div>
                  </div>
                );
              })()}

              {/* Étapes de fabrication */}
              <div className="bg-indigo-50 p-4 rounded-lg">
                <div className="flex justify-between items-center mb-4">
                  <h4 className="text-lg font-bold text-gray-800 flex items-center">
                    <Clock className="h-5 w-5 mr-2 text-indigo-600" />
                    Étapes de fabrication
                  </h4>
                  {selectedOrdre.etapes_devis && selectedOrdre.etapes_devis.length > 0 && (() => {
                    // Compter uniquement les étapes du devis
                    const etapesDevisOnly = selectedOrdre.etapes_devis.filter(e => e.in_devis);
                    const totalEtapes = etapesDevisOnly.length;
                    const etapesTerminees = etapesDevisOnly.filter(e => e.statut === 'terminee' || e.statut === 'validee').length;
                    const pourcentage = totalEtapes > 0 ? Math.round((etapesTerminees / totalEtapes) * 100) : 0;
                    return (
                      <div className="flex items-center space-x-3">
                        <div className="text-sm font-semibold text-gray-700">
                          {etapesTerminees}/{totalEtapes} étapes du devis
                        </div>
                        <div className="w-32 bg-gray-200 rounded-full h-3">
                          <div 
                            className={`h-3 rounded-full transition-all ${
                              pourcentage === 100 ? 'bg-green-500' : 
                              pourcentage > 50 ? 'bg-blue-500' : 'bg-orange-500'
                            }`}
                            style={{ width: `${pourcentage}%` }}
                          ></div>
                        </div>
                        <div className="text-sm font-bold text-indigo-700">{pourcentage}%</div>
                      </div>
                    );
                  })()}
                </div>
                {/* ══ FICHE CLIENT ══ or + diamants uniquement ══ */}
                {(() => {
                  const ordre = selectedOrdre.ordre || {};
                  const pierres = selectedOrdre.pierres || [];
                  const poidsOr = parseFloat(ordre.poids_or_reel || ordre.poids_metal_net || ordre.poids_metal || 0);
                  const metal = (ordre.metal || '').replace(/\s/g, '').toUpperCase();
                  // Titre : extraire le carat (18K, 14K, 9K...)
                  const titreMatch = metal.match(/(9|10|14|18|21|22|24)K?/);
                  const titre = titreMatch ? titreMatch[0].replace('K','') + 'K' : metal || null;
                  const couleur = ordre.couleur_or ? ordre.couleur_or.charAt(0).toUpperCase() + ordre.couleur_or.slice(1).toLowerCase() : null;

                  if (poidsOr <= 0 && pierres.length === 0) return null;
                  return (
                    <div className="mb-3 rounded-xl border-2 border-yellow-300 bg-gradient-to-r from-yellow-50 to-amber-50 p-3">
                      <div className="flex items-center gap-2 mb-2">
                        <Gem className="h-4 w-4 text-yellow-600" />
                        <span className="text-sm font-bold text-yellow-800 tracking-wide uppercase">Fiche bijou — client</span>
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        {/* OR */}
                        {poidsOr > 0 && (
                          <div className="bg-white rounded-lg p-2.5 border border-yellow-200 flex items-center gap-3">
                            <div className="text-2xl">🥇</div>
                            <div>
                              <div className="text-xs text-gray-500 uppercase tracking-wide">Or</div>
                              <div className="font-bold text-yellow-800 text-xl">{poidsOr.toFixed(2)} g</div>
                              {titre && <div className="text-sm text-gray-600">{titre}{couleur ? ` — ${couleur}` : ''}</div>}
                            </div>
                          </div>
                        )}
                        {/* DIAMANTS / PIERRES */}
                        {pierres.length > 0 ? (
                          <div className="bg-white rounded-lg p-2.5 border border-yellow-200">
                            <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                              {pierres.length > 1 ? `${pierres.length} pierres` : 'Pierre'}
                            </div>
                            <div className="space-y-1">
                              {pierres.map((p, i) => {
                                const type = p.type_matiere || p.designation || p.reference || 'Pierre';
                                const carats = parseFloat(p.poids_carats || p.poids || 0);
                                const certif = p.numero_certificat || p.certificat;
                                const qual = p.taille_qualite || p.qualite;
                                return (
                                  <div key={i} className="text-sm">
                                    <span className="font-bold text-indigo-700">
                                      💎 {carats > 0 ? `${carats.toFixed(3)} ct` : ''}
                                    </span>
                                    {' '}<span className="text-gray-700">{type}</span>
                                    {qual && <span className="text-xs text-gray-500 ml-1">({qual})</span>}
                                    {certif && (
                                      <div className="text-xs text-gray-400 font-mono mt-0.5">
                                        Cert. {certif}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ) : (
                          ordre.pierres_description && (
                            <div className="bg-white rounded-lg p-2.5 border border-yellow-200">
                              <div className="text-xs text-gray-500 uppercase tracking-wide mb-1">Pierres</div>
                              <div className="text-sm text-gray-700">💎 {ordre.pierres_description}</div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  );
                })()}

                {/* ── Analyse interne prod précédente (atelier uniquement) ── */}
                {selectedOrdre.comparaison_fiche_reelle && (() => {
                  const comp = selectedOrdre.comparaison_fiche_reelle;
                  const hasOubliees = comp.etapes_oubliees?.length > 0;
                  const hasInutiles = comp.etapes_non_necessaires?.length > 0;
                  return (
                    <div className="mb-3 rounded-xl border border-slate-200 bg-slate-50 p-3 text-sm">
                      <div className="flex items-center justify-between mb-2">
                        <span className="font-semibold text-slate-700">
                          🏭 Analyse prod précédente
                          <span className="font-mono text-xs text-slate-400 ml-2">{comp.of_reference_numero}</span>
                        </span>
                        {comp.temps_total_heures > 0 && (
                          <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded font-semibold">
                            ⏱ {comp.temps_total_heures}h réelles
                          </span>
                        )}
                      </div>
                      {/* Étapes avec temps réels */}
                      {comp.etapes_reference?.length > 0 && (
                        <div className="flex flex-wrap gap-1 mb-2">
                          {comp.etapes_reference.map((e, i) => (
                            <span key={i} className="px-2 py-0.5 bg-white border border-slate-200 rounded text-xs text-slate-600">
                              {e.nom}{e.duree_h > 0 ? ` (${e.duree_h}h)` : ''}
                            </span>
                          ))}
                        </div>
                      )}
                      {hasOubliees && (
                        <div className="mt-1">
                          <span className="text-xs font-semibold text-orange-700">🟠 Oubliées :</span>
                          <div className="flex flex-wrap gap-1 mt-0.5">
                            {comp.etapes_oubliees.map((e, i) => (
                              <span key={i} className="px-2 py-0.5 bg-orange-100 text-orange-800 border border-orange-300 rounded text-xs font-medium">{e}</span>
                            ))}
                          </div>
                        </div>
                      )}
                      {hasInutiles && (
                        <div className="mt-1">
                          <span className="text-xs font-semibold text-green-700">🟢 Jamais fait avant :</span>
                          <div className="flex flex-wrap gap-1 mt-0.5">
                            {comp.etapes_non_necessaires.map((e, i) => (
                              <span key={i} className="px-2 py-0.5 bg-green-50 text-green-700 border border-green-300 rounded text-xs line-through">{e}</span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {selectedOrdre.etapes_devis && selectedOrdre.etapes_devis.length > 0 ? (
                  <div className="space-y-3">
                    {/* Étapes actives (non_requis masquées par défaut) */}
                    {(() => {
                      const visibles = selectedOrdre.etapes_devis;
                      return [
                        ...visibles.filter(e => e.statut === 'en_cours'),
                        ...visibles.filter(e => e.statut === 'pause'),
                        ...visibles.filter(e => e.statut === 'en_cours_externe'),
                        ...visibles.filter(e => e.statut === 'en_attente'),
                        ...visibles.filter(e => e.statut === 'terminee'),
                      ];
                    })().map((etape, idx) => {
                      const comp = selectedOrdre.comparaison_fiche_reelle;
                      const etapesOubliees = new Set((comp?.etapes_oubliees || []).map(n => n.trim().toLowerCase()));
                      const etapesInutiles = new Set((comp?.etapes_non_necessaires || []).map(n => n.trim().toLowerCase()));
                      const estTerminee = etape.statut === 'terminee';
                      const estEnCours = etape.statut === 'en_cours';
                      const estEnPause = etape.statut === 'pause';
                      const estNonRequis = etape.statut === 'non_requis';
                      const horsDevis = !etape.in_devis && !estNonRequis;
                      const estInutile = etapesInutiles.has((etape.nom_etape||'').trim().toLowerCase());
                      return (
                      <div key={idx} className={`flex items-start space-x-3 p-3 rounded-lg border-l-4 ${
                        estNonRequis
                          ? 'border-gray-200 bg-gray-50 opacity-60'
                          : estTerminee
                          ? 'border-green-500 bg-green-50'
                          : estEnCours
                          ? 'border-orange-500 bg-orange-50'
                          : estEnPause
                          ? 'border-yellow-400 bg-yellow-50'
                          : estInutile
                          ? 'border-green-300 bg-green-50 opacity-70'
                          : horsDevis
                          ? 'border-yellow-400 bg-yellow-50'
                          : 'border-gray-300 bg-white'
                      }`}>
                        <div className="flex-shrink-0 mt-1">
                          {etape.statut === 'terminee' ? (
                            <CheckCircle className="h-6 w-6 text-green-500" />
                          ) : etape.statut === 'en_cours' ? (
                            <Clock className="h-6 w-6 text-orange-500 animate-pulse" />
                          ) : etape.ouvrier_affecte_id ? (
                            <div className="h-6 w-6 rounded-full border-2 border-green-400 bg-green-100 flex items-center justify-center">
                              <div className="h-2 w-2 rounded-full bg-green-500" />
                            </div>
                          ) : (
                            <div className="h-6 w-6 rounded-full border-2 border-gray-300" />
                          )}
                        </div>
                        <div className="flex-1">
                          <div className="flex justify-between items-start">
                            <div className="flex-1">
                              <div className="flex items-center space-x-2 flex-wrap gap-1">
                                <div className={`font-semibold ${estNonRequis ? 'text-gray-400' : estTerminee ? 'text-green-800' : estEnCours ? 'text-orange-800' : estInutile ? 'text-green-700 line-through' : 'text-gray-800'}`}>
                                  <span className="text-gray-400 font-normal mr-1">{idx + 1}.</span>
                                  {etape.nom_etape}
                                </div>
                                {!estNonRequis && (
                                  <span className={`px-1.5 py-0.5 text-xs font-semibold rounded ${
                                    etape.type_ressource === 'interne'
                                      ? 'bg-blue-100 text-blue-700'
                                      : 'bg-orange-100 text-orange-700'
                                  }`}>
                                    {etape.type_ressource === 'interne' ? '🏭' : '🔗'}
                                  </span>
                                )}
                                {estNonRequis && (
                                  <span className="px-2 py-0.5 bg-gray-100 text-gray-400 text-xs rounded border border-gray-200">non demandé</span>
                                )}
                                {horsDevis && !estNonRequis && (
                                  <span className="px-2 py-0.5 bg-orange-100 text-orange-700 text-xs font-semibold rounded border border-orange-300">(+ hors devis)</span>
                                )}
                                {estInutile && (
                                  <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-semibold rounded border border-green-300">non fait dernière prod</span>
                                )}
                                {!estInutile && !horsDevis && !estNonRequis && <span className="px-2 py-0.5 bg-green-100 text-green-700 text-xs font-semibold rounded">Production</span>}
                              </div>

                              {/* Code-barre — seulement pour les étapes actives */}
                              {!estNonRequis && selectedOrdre.ordre?.code_barre && (
                                <div className="mt-2 bg-white p-2 rounded border inline-block">
                                  <Barcode
                                    value={selectedOrdre.ordre.code_barre}
                                    height={30}
                                    width={1.5}
                                    displayValue={true}
                                  />
                                </div>
                              )}

                              {/* Étape NON REQUISE : bouton pour l'activer si besoin */}
                              {estNonRequis ? (
                                <div className="mt-2">
                                  <button
                                    onClick={() => {
                                      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
                                      if (!ordreId) return;
                                      api.post(`${API_URL}/atelier/ordres/${ordreId}/ajouter-etape`, {
                                        nom_etape: etape.nom_etape,
                                        cout_fabrication_id: etape.cout_fabrication_id,
                                      }).then(() => {
                                        loadOrdreDetails(ordreId);
                                        loadData();
                                      }).catch(err => {
                                        console.error('Erreur ajout étape:', err);
                                        alert('Erreur lors de l\'ajout de l\'étape');
                                      });
                                    }}
                                    className="text-xs px-3 py-1 bg-gray-100 hover:bg-blue-50 hover:text-blue-700 border border-gray-200 hover:border-blue-300 text-gray-500 rounded-full transition-colors flex items-center gap-1"
                                  >
                                    <span className="text-base leading-none">+</span> Ajouter cette étape
                                  </button>
                                </div>
                              ) : etape.statut === 'en_attente' ? (
                                /* V2.Z 13/05/2026 - Affichage ouvrier deja affecte + bouton Changer */
                                <div className="mt-2">
                                  {etape.ouvrier_affecte_id && reassigningEtapeId !== etape.id ? (
                                    <div className="flex items-center gap-2 bg-green-50 border border-green-200 px-2 py-1 rounded text-sm">
                                      <User className="h-3 w-3 text-green-700" />
                                      <span className="text-green-900 font-medium">Affecte a : {etape.ouvrier_nom || `#${etape.ouvrier_affecte_id}`}</span>
                                      <button type="button"
                                              onClick={() => setReassigningEtapeId(etape.id)}
                                              className="ml-auto text-xs text-blue-600 hover:underline font-semibold">
                                        Changer
                                      </button>
                                    </div>
                                  ) : (
                                    <select
                                      value={etape.ouvrier_affecte_id || ''}
                                      onChange={(e) => {
                                        const newOuvrierId = e.target.value;
                                        if (!newOuvrierId) return;
                                        // Patch 47 + V2.Z : POST /etapes/<id>/affecter (BE autorise reassign si en_attente)
                                        api.post(`${API_URL}/atelier/etapes/${etape.id}/affecter`, {
                                          ouvrier_id: parseInt(newOuvrierId)
                                        }).then((res) => {
                                          const d = res.data || {};
                                          const msg = `Affectation reussie : ${d.ouvrier_nom || ''} sur etape #${d.numero_etape || ''} - ${d.nom_etape || ''}`;
                                          if (window.toast) window.toast.success(msg); else console.log(msg);
                                          setReassigningEtapeId(null);
                                          const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
                                          if (ordreId) loadOrdreDetails(ordreId);
                                          loadData();
                                        }).catch(err => {
                                          const code = err?.response?.status;
                                          const data = err?.response?.data || {};
                                          let msg = data.error || data.message || 'Erreur lors de l\'assignation';
                                          if (code === 409) msg = data.message || `Etape verrouillee (statut: ${data.statut || '?'})`;
                                          else if (code === 404) msg = 'Etape introuvable';
                                          else if (code === 422) msg = "Cet OF n'a pas d'etapes definies. Creez les etapes avant d'affecter.";
                                          else if (code === 400) msg = data.error || 'Donnees invalides';
                                          else if (code >= 500) msg = 'Erreur serveur, reessayez';
                                          console.error('Erreur assignation:', code, data);
                                          if (window.toast) window.toast.error(msg); else alert(msg);
                                        });
                                      }}
                                      className="text-sm px-2 py-1 border border-gray-300 rounded"
                                    >
                                      <option value="">{etape.ouvrier_affecte_id ? 'Choisir nouveau ouvrier...' : 'Assigner un ouvrier...'}</option>
                                      {ouvriersDisponibles.map(ouv => (
                                        <option key={ouv.id} value={ouv.id}>
                                          {ouv.prenom} {ouv.nom} - {ouv.specialite}
                                        </option>
                                      ))}
                                    </select>
                                  )}
                                  {reassigningEtapeId === etape.id && (
                                    <button type="button"
                                            onClick={() => setReassigningEtapeId(null)}
                                            className="ml-2 text-xs text-gray-500 hover:underline">
                                      Annuler
                                    </button>
                                  )}
                                </div>
                              ) : etape.ouvrier_nom ? (
                                <div className="text-sm text-gray-600 flex items-center mt-1">
                                  <User className="h-3 w-3 mr-1" />
                                  {etape.ouvrier_nom}
                                </div>
                              ) : null}
                              
                              {etape.description && (
                                <div className="text-sm text-gray-500 mt-1">{etape.description}</div>
                              )}
                            </div>
                            <div className="flex items-center space-x-2">
                              <span className={`px-2 py-1 rounded text-xs font-semibold ${
                                etape.statut === 'terminee' ? 'bg-green-100 text-green-800' :
                                etape.statut === 'en_cours' ? 'bg-blue-100 text-blue-800' :
                                etape.statut === 'pause' ? 'bg-yellow-100 text-yellow-800' :
                                etape.statut === 'en_cours_externe' ? 'bg-orange-100 text-orange-800' :
                                etape.ouvrier_affecte_id ? 'bg-gray-100 text-gray-700' :
                                'bg-gray-100 text-gray-500'
                              }`}>
                                {etape.statut === 'terminee' ? '✅ Terminé' :
                                 etape.statut === 'en_cours' ? '🔵 En cours' :
                                 etape.statut === 'pause' ? '⏸️ En pause' :
                                 etape.statut === 'en_cours_externe' ? '📤 Chez prestataire' :
                                 etape.ouvrier_affecte_id ? '⬛ Assigné' : '⬛ En attente'}
                              </span>

                              {/* ── ÉTAPE EXTERNE ── */}
                              {etape.type_ressource === 'externe' && etape.statut === 'en_attente' && (
                                <div className="flex items-center gap-2 flex-wrap">
                                  <input
                                    type="text"
                                    placeholder="Nom prestataire externe..."
                                    value={saisieExterne[etape.id] || ''}
                                    onChange={e => setSaisieExterne(prev => ({ ...prev, [etape.id]: e.target.value }))}
                                    className="text-xs px-2 py-1 border border-orange-300 rounded focus:border-orange-500 outline-none w-44"
                                  />
                                  <button
                                    onClick={() => envoyerExterne(etape.id)}
                                    className="px-3 py-1 bg-orange-500 text-white rounded text-xs hover:bg-orange-600 transition-colors flex items-center space-x-1"
                                  >
                                    <span>🔗</span>
                                    <span>Envoyer</span>
                                  </button>
                                </div>
                              )}
                              {etape.type_ressource === 'externe' && etape.statut === 'en_cours_externe' && etape.prestataire_nom && (
                                <span className="text-xs text-orange-700 font-medium">👤 {etape.prestataire_nom}</span>
                              )}
                              {etape.type_ressource === 'externe' && etape.statut === 'en_cours_externe' && (
                                <button
                                  onClick={() => ouvrirModalReception(etape)}
                                  className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 transition-colors flex items-center space-x-1"
                                >
                                  <CheckCircle className="h-3 w-3" />
                                  <span>Réceptionner</span>
                                </button>
                              )}

                              {/* ── ÉTAPE INTERNE ── */}
                              {etape.type_ressource !== 'externe' && etape.statut === 'en_attente' && etape.ouvrier_affecte_id && (
                                <button
                                  onClick={() => demarrerEtape(etape.id)}
                                  className="px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 transition-colors flex items-center space-x-1"
                                >
                                  <Play className="h-3 w-3" />
                                  <span>Démarrer</span>
                                </button>
                              )}
                              {etape.statut === 'en_cours' && (
                                <>
                                  <button
                                    onClick={() => pauserEtape(etape.id)}
                                    className="px-3 py-1 bg-yellow-500 text-white rounded text-xs hover:bg-yellow-600 transition-colors flex items-center space-x-1"
                                  >
                                    <span>⏸</span>
                                    <span>Pause</span>
                                  </button>
                                  <button
                                    onClick={() => ouvrirModalTerminer(etape)}
                                    className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 transition-colors flex items-center space-x-1"
                                  >
                                    <CheckCircle className="h-3 w-3" />
                                    <span>Terminer</span>
                                  </button>
                                </>
                              )}
                              {etape.statut === 'pause' && (
                                <>
                                  <button
                                    onClick={() => reprendreEtape(etape.id)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700 transition-colors flex items-center space-x-1"
                                  >
                                    <Play className="h-3 w-3" />
                                    <span>Reprendre</span>
                                  </button>
                                  <button
                                    onClick={() => ouvrirModalTerminer(etape)}
                                    className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 transition-colors flex items-center space-x-1"
                                  >
                                    <CheckCircle className="h-3 w-3" />
                                    <span>Terminer</span>
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                          {(etape.statut === 'en_cours' || etape.statut === 'pause') && etape.date_debut && (
                            <div className={`mt-2 rounded px-3 py-1.5 flex items-center gap-2 border ${
                              etape.statut === 'pause'
                                ? 'bg-yellow-50 border-yellow-200'
                                : 'bg-blue-50 border-blue-200'
                            }`}>
                              <Clock className={`h-4 w-4 flex-shrink-0 ${etape.statut === 'pause' ? 'text-yellow-600' : 'text-blue-600'}`} />
                              <span className={`font-mono font-bold text-sm tabular-nums ${etape.statut === 'pause' ? 'text-yellow-700' : 'text-blue-700'}`}>
                                {etape.statut === 'pause' ? '⏸ ' : '⏱ '}{computeTemps(etape)}
                              </span>
                              {etape.temps_pause_minutes > 0 && (
                                <span className="text-xs text-gray-500">({etape.temps_pause_minutes} min pause déduits)</span>
                              )}
                            </div>
                          )}
                          {etape.date_debut && (
                            <div className="text-xs text-gray-500 mt-1">
                              <Clock className="inline h-3 w-3 mr-1" />
                              Début: {new Date(etape.date_debut).toLocaleDateString('fr-FR')} {new Date(etape.date_debut).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}
                              {etape.date_fin && ` • Fin: ${new Date(etape.date_fin).toLocaleDateString('fr-FR')} ${new Date(etape.date_fin).toLocaleTimeString('fr-FR', {hour: '2-digit', minute: '2-digit'})}`}
                            </div>
                          )}
                          {/* §74 Or donne par etape - inline (§80: fix passer of) */}
                          {(() => {
                            const allEtapes = selectedOrdre?.etapes || [];
                            const ofObj = selectedOrdre?.ordre || selectedOrdre || ordre || {};
                            const suggested = suggestOrDonne(etape, allEtapes, ofObj);
                            const localVal = poidsOrDonneLocal[etape.id];
                            const displayVal = localVal !== undefined ? localVal : (etape.poids_or_donne ?? suggested ?? '');
                            const recu = etape.poids_or_recu ?? etape.poids_bijou_etape;
                            if (etape.statut === 'terminee' || etape.statut === 'validee') {
                              const donne = etape.poids_or_donne;
                              const perte = (donne != null && recu != null) ? donne - recu : null;
                              const perteColor = perte == null
                                ? 'text-gray-500'
                                : perte > 0 ? 'text-red-600' : perte < 0 ? 'text-green-600' : 'text-gray-500';
                              return (
                                <div className="mt-2 bg-amber-50 border border-amber-300 rounded overflow-hidden">
                                  <div className="px-2 py-1 bg-amber-100 text-amber-900 text-xs font-semibold flex items-center gap-1">
                                    <span>⚖️</span> Suivi or
                                  </div>
                                  <table className="w-full text-xs">
                                    <thead>
                                      <tr className="bg-white text-amber-800 border-b border-amber-200">
                                        <th className="px-2 py-1 text-center font-semibold">Donne</th>
                                        <th className="px-2 py-1 text-center font-semibold">Recu</th>
                                        <th className="px-2 py-1 text-center font-semibold">Perte</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td className="px-2 py-1 text-center font-mono font-bold">{donne != null ? `${parseFloat(donne).toFixed(3)}g` : '-'}</td>
                                        <td className="px-2 py-1 text-center font-mono font-bold">{recu != null ? `${parseFloat(recu).toFixed(3)}g` : '-'}</td>
                                        <td className={`px-2 py-1 text-center font-mono font-bold ${perteColor}`}>
                                          {perte != null
                                            ? `${perte > 0 ? '-' : perte < 0 ? '+' : ''}${Math.abs(perte).toFixed(3)}g`
                                            : '-'}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              );
                            }
                            if (etape.statut === 'en_cours' || etape.statut === 'pause') {
                              const donneVal = etape.poids_or_donne ?? suggested;
                              const isSuggestion = etape.poids_or_donne == null && suggested != null;
                              return (
                                <div className="mt-2 px-2 py-1.5 bg-amber-50 border border-amber-300 rounded text-xs flex items-center gap-2">
                                  <span className="font-semibold text-amber-900">⚖️ Or donné:</span>
                                  <strong className="font-mono">{donneVal != null ? `${parseFloat(donneVal).toFixed(3)}g` : '-'}</strong>
                                  {isSuggestion && (
                                    <span className="text-[10px] text-gray-500 italic">
                                      ({etape.numero_etape > 1 ? `← etape ${etape.numero_etape - 1}` : 'depuis devis/bijou'})
                                    </span>
                                  )}
                                </div>
                              );
                            }
                            // en_attente : input editable
                            return (
                              <div className="mt-2 px-2 py-1.5 bg-amber-50 border border-amber-300 rounded text-xs flex items-center gap-2">
                                <span className="font-semibold text-amber-900 whitespace-nowrap">⚖️ Or donné (g):</span>
                                <input type="number" step="0.001"
                                       value={displayVal}
                                       onChange={e => setPoidsOrDonneLocal({ ...poidsOrDonneLocal, [etape.id]: e.target.value })}
                                       onBlur={() => {
                                         const v = poidsOrDonneLocal[etape.id];
                                         if (v !== undefined && v !== '' && parseFloat(v) !== etape.poids_or_donne) {
                                           savePoidsOrEtape(etape.id, 'poids_or_donne', v);
                                         }
                                       }}
                                       placeholder={suggested ? suggested.toFixed(3) : '0.000'}
                                       className="w-24 px-2 py-0.5 border border-amber-400 rounded text-xs font-mono text-center focus:ring-1 focus:ring-amber-500 outline-none" />
                                {!etape.poids_or_donne && suggested != null && (
                                  <span className="text-[10px] text-gray-500 italic">
                                    {etape.numero_etape > 1 ? `← etape ${etape.numero_etape - 1}` : 'depuis devis/bijou'}
                                  </span>
                                )}
                              </div>
                            );
                          })()}

                          {/* §84 - Avec pierres : case + section editable inline ou lecture */}
                          {(etape.statut === 'en_attente' || etape.statut === 'en_cours' || etape.statut === 'pause' || etape.statut === 'terminee' || etape.statut === 'validee') && (
                            <div className="mt-2 p-2 bg-purple-50 border border-purple-200 rounded text-xs">
                              <label className="flex items-center gap-2 cursor-pointer">
                                <input type="checkbox"
                                       checked={!!etape.avec_pierres}
                                       disabled={etape.statut === 'terminee' || etape.statut === 'validee'}
                                       onChange={e => saveEtapeAvecPierres(resolveEtapeProductionId(etape), e.target.checked, undefined)}
                                       className="w-4 h-4 accent-purple-600" />
                                <span className="font-semibold text-purple-900">💎 Avec pierres</span>
                                {(() => {
                                  let pierresRemises = [];
                                  try {
                                    if (etape.pierres_remises_json) {
                                      pierresRemises = typeof etape.pierres_remises_json === 'string'
                                        ? JSON.parse(etape.pierres_remises_json)
                                        : etape.pierres_remises_json;
                                    }
                                  } catch { pierresRemises = []; }
                                  if (etape.avec_pierres && pierresRemises.length > 0) {
                                    return (
                                      <span className="text-xs text-green-700 ml-2">
                                        ✓ {pierresRemises.length} pierre(s) affectee(s)
                                      </span>
                                    );
                                  }
                                  return null;
                                })()}
                              </label>

                              {/* Editable section (en_attente uniquement) - §104 UX enrichie */}
                              {etape.avec_pierres && etape.statut === 'en_attente' && (() => {
                                const localList = pierresLocalState[etape.id] !== undefined ? pierresLocalState[etape.id] : initPierresEtape(etape);
                                return (
                                  <div className="mt-2 space-y-1.5">
                                    {localList.length === 0 && (
                                      <div className="text-gray-500 italic text-[11px]">Aucune pierre. + Ajouter depuis stock ou manuelle ci-dessous.</div>
                                    )}
                                    {/* §104 - header colonnes */}
                                    {localList.length > 0 && (
                                      <div className="grid grid-cols-12 gap-1 text-[10px] font-semibold text-purple-700 px-1.5">
                                        <div className="col-span-1">✓</div>
                                        <div className="col-span-5">Pierre / Reference</div>
                                        <div className="col-span-2 text-center">Qte prevue</div>
                                        <div className="col-span-2 text-center">Qte remise</div>
                                        <div className="col-span-1 text-center">ct/u</div>
                                        <div className="col-span-1"></div>
                                      </div>
                                    )}
                                    {localList.map((p, idx) => {
                                      const sourceBadge = p.source === 'manuel'
                                        ? { label: '✏️ manuel', cls: 'bg-orange-50 border border-orange-200' }
                                        : p.source === 'stock'
                                          ? { label: '📦 stock', cls: 'bg-blue-50 border border-blue-200' }
                                          : { label: '📋 devis', cls: 'bg-white border border-purple-100' };
                                      const qteRemise = p.qte_remise != null ? p.qte_remise : (p.quantite || 1);
                                      const qtePrevue = p.qte_prevue != null ? p.qte_prevue : (p.source === 'devis' ? p.quantite : null);
                                      return (
                                      <div key={idx} className={`grid grid-cols-12 gap-1 items-center p-1 rounded ${sourceBadge.cls}`}>
                                        <input type="checkbox" checked={p.selected !== false}
                                               onChange={e => togglePierreEtape(etape.id, idx, e.target.checked)}
                                               className="col-span-1 w-4 h-4 accent-purple-600 justify-self-center" />
                                        <div className="col-span-5">
                                          <input type="text" value={p.type_pierre || ''}
                                                 onChange={e => updatePierreEtape(etape.id, idx, 'type_pierre', e.target.value)}
                                                 readOnly={p.source !== 'manuel'}
                                                 className={`w-full px-1 py-0.5 text-[11px] border rounded ${p.source !== 'manuel' ? 'bg-transparent cursor-default font-medium' : 'bg-white'}`} />
                                          {(p.reference || p.taille_qualite || p.certificat) && (
                                            <div className="text-[9px] text-gray-500 px-1 truncate">
                                              {p.reference && <span>{p.reference}</span>}
                                              {p.taille_qualite && <span> · {p.taille_qualite}</span>}
                                              {p.certificat && <span> · {p.certificat}</span>}
                                              <span className="ml-1 italic">[{sourceBadge.label}]</span>
                                            </div>
                                          )}
                                        </div>
                                        <div className="col-span-2 text-center text-[11px] text-gray-700 font-mono">
                                          {qtePrevue != null ? qtePrevue : '—'}
                                        </div>
                                        <input type="number" min="0" max={qtePrevue || undefined} value={qteRemise}
                                               onChange={e => {
                                                 const v = parseInt(e.target.value) || 0;
                                                 updatePierreEtape(etape.id, idx, 'qte_remise', v);
                                                 updatePierreEtape(etape.id, idx, 'quantite', v);  // sync legacy
                                               }}
                                               className="col-span-2 px-1 py-0.5 text-[11px] border rounded text-center font-semibold text-purple-900" />
                                        <input type="number" step="0.001" value={p.poids_carats || ''}
                                               onChange={e => updatePierreEtape(etape.id, idx, 'poids_carats', parseFloat(e.target.value) || null)}
                                               placeholder="ct"
                                               className="col-span-1 px-1 py-0.5 text-[10px] border rounded text-center" />
                                        <button type="button" onClick={() => removePierreEtape(etape.id, idx)}
                                                className="col-span-1 text-red-500 hover:text-red-700 text-sm justify-self-center">✕</button>
                                      </div>
                                      );
                                    })}
                                    <div className="flex justify-between items-center gap-2 flex-wrap">
                                      <div className="flex gap-1.5">
                                        <button type="button" onClick={() => ouvrirStockPicker(etape.id)}
                                                className="text-[11px] px-2 py-0.5 bg-blue-100 hover:bg-blue-200 text-blue-800 rounded border border-blue-300">+ Depuis stock</button>
                                        <button type="button" onClick={() => ajouterPierreManuelleEtape(etape.id)}
                                                className="text-[11px] px-2 py-0.5 bg-orange-100 hover:bg-orange-200 text-orange-800 rounded">+ Manuelle</button>
                                      </div>
                                      <button type="button" onClick={() => savePierresEtape(etape)}
                                              className="text-[11px] px-3 py-0.5 bg-purple-600 hover:bg-purple-700 text-white rounded font-semibold">
                                        💾 Sauvegarder pierres
                                      </button>
                                    </div>
                                  </div>
                                );
                              })()}

                              {/* Lecture seule (en_cours/terminee/etc) */}
                              {etape.avec_pierres && etape.statut !== 'en_attente' && (() => {
                                let pierresRemises = [];
                                try {
                                  if (etape.pierres_remises_json) {
                                    pierresRemises = typeof etape.pierres_remises_json === 'string'
                                      ? JSON.parse(etape.pierres_remises_json)
                                      : etape.pierres_remises_json;
                                  }
                                } catch { pierresRemises = []; }
                                const visibles = pierresRemises.filter(p => p.selected !== false);
                                if (visibles.length === 0) return null;
                                return (
                                  <div className="mt-1.5 space-y-0.5">
                                    {visibles.map((p, i) => (
                                      <div key={i} className="flex items-center gap-2 text-[11px]">
                                        <span>•</span>
                                        <span className="font-semibold">{p.type_pierre}</span>
                                        {p.quantite != null && <span className="text-gray-600">x{p.quantite}</span>}
                                        {p.poids_carats != null && <span className="font-mono">{parseFloat(p.poids_carats).toFixed(3)} ct</span>}
                                      </div>
                                    ))}
                                  </div>
                                );
                              })()}
                            </div>
                          )}

                          {/* §81 - Carte terminee avec_pierres : afficher poids total bijou */}
                          {(etape.statut === 'terminee' || etape.statut === 'validee') && etape.avec_pierres && etape.poids_total_bijou != null && (
                            <div className="mt-2 px-2 py-1.5 bg-blue-50 border border-blue-200 rounded text-xs flex items-center gap-2">
                              <span className="font-semibold text-blue-900">📏 Poids total bijou :</span>
                              <strong className="font-mono">{parseFloat(etape.poids_total_bijou).toFixed(3)}g</strong>
                            </div>
                          )}

                          <div className="text-xs mt-1 flex flex-wrap items-center gap-x-2 gap-y-1">
                            {etape.duree_estimee_heures > 0 && (
                              <span className="text-gray-500">
                                ⏱️ Estimé: {Math.round(etape.duree_estimee_heures * 60)} min
                              </span>
                            )}
                            {/* Temps réel — visible uniquement pour étapes terminées avec id réel */}
                            {etape.id && etape.statut === 'terminee' && (
                              <span className="flex items-center gap-1">
                                <span className="text-gray-400 text-xs">Temps ouvrier :</span>
                                {editingTempsEtapeId === etape.id ? (
                                  <>
                                    <input
                                      type="number" min="0"
                                      autoFocus
                                      value={editingTempsValue}
                                      onChange={e => setEditingTempsValue(e.target.value)}
                                      onKeyDown={e => { if (e.key === 'Enter') saveTempsEtape(etape.id); if (e.key === 'Escape') setEditingTempsEtapeId(null); }}
                                      className="w-16 border border-blue-400 rounded px-1 py-0.5 text-xs font-mono text-center focus:outline-none focus:ring-1 focus:ring-blue-400"
                                    />
                                    <span className="text-gray-400 text-xs">min</span>
                                    <button onClick={() => saveTempsEtape(etape.id)} className="text-green-600 hover:text-green-800 font-bold text-xs">✓</button>
                                    <button onClick={() => setEditingTempsEtapeId(null)} className="text-red-400 hover:text-red-600 text-xs">✕</button>
                                  </>
                                ) : (
                                  <button
                                    onClick={() => {
                                      const mins = etape.duree_reelle_heures ? Math.round(parseFloat(etape.duree_reelle_heures) * 60) : '';
                                      setEditingTempsValue(String(mins));
                                      setEditingTempsEtapeId(etape.id);
                                    }}
                                    className="font-semibold text-green-700 underline-offset-2 hover:underline cursor-pointer"
                                    title="Cliquer pour corriger le temps"
                                  >
                                    {etape.duree_reelle_heures
                                      ? `${Math.round(parseFloat(etape.duree_reelle_heures) * 60)} min`
                                      : '— corriger'}
                                  </button>
                                )}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      );
                    })}

                    {/* Étapes optionnelles (non_requis) — masquées par défaut */}
                    {(() => {
                      const nonRequis = selectedOrdre.etapes_devis.filter(e => e.statut === 'non_requis');
                      if (nonRequis.length === 0) return null;
                      return (
                        <div className="mt-2">
                          <button
                            onClick={() => setAfficherNonRequis(v => !v)}
                            className="text-xs text-gray-400 hover:text-gray-600 flex items-center gap-1 px-2 py-1 rounded border border-gray-200 hover:border-gray-300 transition-colors"
                          >
                            {afficherNonRequis ? '▲ Masquer' : '▼ Voir'} {nonRequis.length} étape{nonRequis.length > 1 ? 's' : ''} non demandée{nonRequis.length > 1 ? 's' : ''}
                          </button>
                          {afficherNonRequis && (
                            <div className="mt-2 space-y-2">
                              {nonRequis.map((etape, idx) => (
                                <div key={idx} className="flex items-center justify-between p-3 rounded-lg border border-dashed border-gray-200 bg-gray-50 opacity-70">
                                  <div className="flex items-center gap-2 text-sm text-gray-500">
                                    <div className="h-5 w-5 rounded-full border-2 border-gray-300" />
                                    <span className="font-medium">{etape.nom_etape}</span>
                                    <span className="text-xs bg-gray-200 text-gray-500 px-1.5 py-0.5 rounded">non demandé</span>
                                  </div>
                                  <button
                                    onClick={() => {
                                      const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
                                      if (!ordreId) return;
                                      api.post(`${API_URL}/atelier/ordres/${ordreId}/ajouter-etape`, {
                                        nom_etape: etape.nom_etape,
                                        cout_fabrication_id: etape.cout_fabrication_id,
                                      }).then(() => { loadOrdreDetails(ordreId); loadData(); })
                                        .catch(() => alert('Erreur lors de l\'ajout de l\'étape'));
                                    }}
                                    className="text-xs px-3 py-1 bg-white hover:bg-blue-50 hover:text-blue-700 border border-gray-200 hover:border-blue-300 text-gray-500 rounded-full transition-colors"
                                  >
                                    + Ajouter
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    })()}

                    {/* [Patch 48 / Mission A] Bouton + Etape ad-hoc (admin/chef d'atelier) */}
                    {(isAdmin() || isAtelier()) && (
                      <div className="mt-3 pt-3 border-t border-dashed border-gray-200">
                        <button
                          onClick={() => {
                            setAdhocForm({ nom_etape: '', type_ressource: 'interne', duree_estimee_heures: 1 });
                            setShowAdhocModal(true);
                          }}
                          className="text-sm px-4 py-2 bg-purple-50 hover:bg-purple-100 border border-purple-200 hover:border-purple-300 text-purple-700 rounded-lg transition-colors flex items-center gap-2"
                        >
                          <span className="text-lg leading-none">+</span> Etape ad-hoc (hors devis)
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    <Clock className="h-12 w-12 mx-auto mb-2 text-gray-400" />
                    <p>Aucune étape de fabrication définie</p>
                    <p className="text-sm mt-1">Les étapes seront ajoutées lors du démarrage de la production</p>
                    {(isAdmin() || isAtelier()) && (
                      <button
                        onClick={() => {
                          setAdhocForm({ nom_etape: '', type_ressource: 'interne', duree_estimee_heures: 1 });
                          setShowAdhocModal(true);
                        }}
                        className="mt-3 text-sm px-4 py-2 bg-purple-50 hover:bg-purple-100 border border-purple-200 text-purple-700 rounded-lg inline-flex items-center gap-2"
                      >
                        <span className="text-lg leading-none">+</span> Etape ad-hoc
                      </button>
                    )}
                  </div>
                )}
              </div>

              {/* Bouton Contrôle Final */}
              {selectedOrdre.etapes_devis && selectedOrdre.etapes_devis.length > 0 && (() => {
                // Vérifier toutes les étapes
                const etapesDevisOnly = selectedOrdre.etapes_devis;
                return etapesDevisOnly.length > 0 &&
                       etapesDevisOnly.every(e => e.statut === 'terminee' || e.statut === 'validee') &&
                       selectedOrdre.ordre?.statut !== 'terminee';
              })() && (
                <div className="bg-gradient-to-r from-green-50 to-emerald-50 border-4 border-green-400 p-8 rounded-xl shadow-xl">
                  <div className="text-center mb-6">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-green-500 rounded-full mb-4">
                      <CheckCircle className="h-10 w-10 text-white" />
                    </div>
                    <h4 className="text-2xl font-bold text-green-800 mb-2">
                      ✅ Toutes les étapes du devis sont terminées !
                    </h4>
                    <p className="text-green-700 text-lg">
                      Le bijou est prêt pour la validation finale
                    </p>
                  </div>
                  
                  <button
                    onClick={() => {
                      // Hotfix : modal partage remplace confirm() + alert()
                      const ordreId = selectedOrdre.ordre?.id || selectedOrdre.id;
                      setControleFinalOfId(ordreId);
                      setShowControleFinalModal(true);
                    }}
                    className="w-full px-8 py-5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-bold text-2xl hover:from-green-700 hover:to-emerald-700 transition-all shadow-2xl hover:shadow-3xl hover:scale-105 flex items-center justify-center space-x-3 animate-pulse"
                  >
                    <CheckCircle className="h-8 w-8" />
                    <span>🎯 FINALISER LE BIJOU</span>
                  </button>
                  
                  <p className="text-center text-sm text-gray-600 mt-4">
                    Cliquez pour effectuer le contrôle qualité final et ajouter au stock
                  </p>
                </div>
              )}

              {/* ── POIDS & MATIERES ─────────────────────────────────── */}
              {(() => {
                const o = selectedOrdre?.ordre || {};
                const hasPoids = o.poids_brut || o.poids_metal_net || o.poids_metal_travaille || o.poids_chaine || o.poids_mousqueton;
                if (!hasPoids) return null;
                const fmt = v => v != null ? `${parseFloat(v).toFixed(3)} g` : '—';
                return (
                  <div className="bg-gray-50 border border-gray-200 p-4 rounded-lg">
                    <h4 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
                      <span className="mr-2 text-gray-500">⚖</span>
                      Poids &amp; Matières
                    </h4>

                    {/* Or */}
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Or {o.metal} {o.couleur_or}</p>
                    <div className="grid grid-cols-3 gap-2 mb-3">
                      {[
                        { label: 'Poids brut', val: o.poids_brut, color: 'text-gray-700' },
                        { label: 'Poids net', val: o.poids_metal_net, color: 'text-gray-700' },
                        { label: 'Or travaillé', val: o.poids_metal_travaille, color: 'text-yellow-700 font-semibold' },
                      ].map(({ label, val, color }) => (
                        <div key={label} className="bg-white rounded-lg border border-gray-200 px-3 py-2 text-center">
                          <p className="text-xs text-gray-500 mb-0.5">{label}</p>
                          <p className={`text-sm ${color}`}>{fmt(val)}</p>
                        </div>
                      ))}
                    </div>

                    {/* Éléments achetés (chaine + mousqueton) */}
                    {(o.poids_chaine || o.poids_mousqueton) && (
                      <>
                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">Éléments achetés</p>
                        <div className="grid grid-cols-2 gap-2 mb-3">
                          {o.poids_chaine && (
                            <div className="bg-white rounded-lg border border-gray-200 px-3 py-2 text-center">
                              <p className="text-xs text-gray-500 mb-0.5">Chaîne</p>
                              <p className="text-sm text-blue-700 font-medium">{fmt(o.poids_chaine)}</p>
                              <p className="text-xs text-gray-400">acheté</p>
                            </div>
                          )}
                          {o.poids_mousqueton && (
                            <div className="bg-white rounded-lg border border-gray-200 px-3 py-2 text-center">
                              <p className="text-xs text-gray-500 mb-0.5">Mousqueton</p>
                              <p className="text-sm text-blue-700 font-medium">{fmt(o.poids_mousqueton)}</p>
                              <p className="text-xs text-gray-400">acheté</p>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    {/* Flags */}
                    <div className="flex flex-wrap gap-2 mt-1">
                      {o.fonte2      && <span className="px-2 py-0.5 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">Fonte 2</span>}
                      {o.gravure_beldi && <span className="px-2 py-0.5 bg-purple-100 text-purple-700 rounded-full text-xs font-medium">Gravure Beldi</span>}
                      {o.rhodiage    && <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">Rhodiage</span>}
                      {o.garantie    && <span className="px-2 py-0.5 bg-green-100 text-green-700 rounded-full text-xs font-medium">Garantie</span>}
                      {o.ecrin       && <span className="px-2 py-0.5 bg-pink-100 text-pink-700 rounded-full text-xs font-medium">Ecrin</span>}
                    </div>

                    {o.consigne && (
                      <div className="mt-3 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2">
                        <p className="text-xs font-semibold text-yellow-700 mb-0.5">Consigne fabrication</p>
                        <p className="text-sm text-gray-700">{o.consigne}</p>
                      </div>
                    )}
                  </div>
                );
              })()}

              {/* ── FONTE ─────────────────────────────────────────────── */}
              <div className="bg-orange-50 border border-orange-200 p-4 rounded-lg">
                <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                  <Flame className="h-5 w-5 mr-2 text-orange-500" />
                  Fonte
                </h4>
                <div className="grid grid-cols-2 gap-3">
                  {[
                    { key: 'numero_fonte', label: 'N° Fonte', type: 'text', placeholder: 'ex: F-2026-042' },
                    { key: 'date_fonte',   label: 'Date',     type: 'date', placeholder: '' },
                    { key: 'lieu_fonte',   label: 'Lieu',     type: 'text', placeholder: 'ex: Atelier Central' },
                    { key: 'operateur',    label: 'Opérateur',type: 'text', placeholder: '' },
                    { key: 'poids_avant',  label: 'Poids avant (g)', type: 'number', placeholder: '0.000' },
                    { key: 'poids_apres',  label: 'Poids après (g)', type: 'number', placeholder: '0.000' },
                  ].map(f => (
                    <div key={f.key}>
                      <label className="block text-xs font-medium text-gray-600 mb-1">{f.label}</label>
                      <input
                        type={f.type}
                        placeholder={f.placeholder}
                        value={fonte[f.key] || ''}
                        onChange={e => setFonte(prev => ({ ...prev, [f.key]: e.target.value }))}
                        className="w-full px-3 py-1.5 border border-orange-200 rounded-lg text-sm focus:ring-2 focus:ring-orange-400 bg-white"
                      />
                    </div>
                  ))}
                  <div className="col-span-2">
                    <label className="block text-xs font-medium text-gray-600 mb-1">Notes fonte</label>
                    <textarea
                      rows={2}
                      value={fonte.notes || ''}
                      onChange={e => setFonte(prev => ({ ...prev, notes: e.target.value }))}
                      className="w-full px-3 py-1.5 border border-orange-200 rounded-lg text-sm focus:ring-2 focus:ring-orange-400 bg-white"
                    />
                  </div>
                </div>
                <button
                  onClick={saveFonte}
                  disabled={savingFonte}
                  className="mt-3 flex items-center space-x-2 px-4 py-1.5 bg-orange-500 hover:bg-orange-600 text-white rounded-lg text-sm font-medium transition-colors"
                >
                  <Save className="h-4 w-4" />
                  <span>{savingFonte ? 'Sauvegarde...' : 'Sauvegarder la fonte'}</span>
                </button>
              </div>

              {/* ── PIERRES ───────────────────────────────────────────── */}
              <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
                <div className="flex items-center justify-between mb-4">
                  <h4 className="text-lg font-bold text-gray-800 flex items-center">
                    <Gem className="h-5 w-5 mr-2 text-blue-500" />
                    Pierres précieuses
                    {pierresOF.length > 0 && (
                      <span className="ml-2 bg-blue-200 text-blue-800 text-xs font-bold px-2 py-0.5 rounded-full">{pierresOF.length}</span>
                    )}
                  </h4>
                  <button
                    onClick={() => setAjoutPierreOpen(!ajoutPierreOpen)}
                    className="flex items-center space-x-1 px-3 py-1.5 bg-blue-500 hover:bg-blue-600 text-white rounded-lg text-sm font-medium transition-colors"
                  >
                    <Plus className="h-4 w-4" />
                    <span>Ajouter</span>
                  </button>
                </div>

                {/* Formulaire ajout avec recherche stock */}
                {ajoutPierreOpen && (
                  <div className="mb-4 p-3 bg-white rounded-lg border border-blue-200 space-y-3">
                    {/* Ligne 1: Recherche référence + résultats */}
                    <div className="relative">
                      <label className="block text-xs font-medium text-gray-600 mb-1">Rechercher une pierre (réf, type, certificat...)</label>
                      <input type="text" placeholder="Tapez une référence, DIAMANT, SAPHIR..."
                        value={nouvellePierre.reference_pierre}
                        onChange={e => {
                          setNouvellePierre(p => ({ ...p, reference_pierre: e.target.value, stock_id: null, stock_disponible: null }));
                          searchPierresStock(e.target.value);
                        }}
                        onFocus={() => { if (nouvellePierre.reference_pierre) searchPierresStock(nouvellePierre.reference_pierre); }}
                        className="w-full px-3 py-2 border-2 border-blue-300 rounded-lg text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200" />
                      {/* Dropdown suggestions */}
                      {showPierreSuggestions && pierreSuggestions.length > 0 && (
                        <div className="absolute z-50 w-full mt-1 bg-white border-2 border-blue-400 rounded-lg shadow-xl max-h-60 overflow-y-auto">
                          {pierreSuggestions.map((pierre, i) => (
                            <div key={i} onClick={() => selectPierreFromStock(pierre)}
                              className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b last:border-b-0">
                              <div className="flex justify-between items-center">
                                <span className="font-bold text-blue-700">{pierre.reference}</span>
                                <span className="bg-green-100 text-green-700 px-2 py-0.5 rounded-full text-xs font-semibold">
                                  {parseFloat(pierre.prix_achat_carat || pierre.prix_achat_unitaire || 0).toFixed(2)} DH/ct
                                </span>
                              </div>
                              <div className="text-xs text-gray-600 mt-1">{pierre.designation} - {pierre.type_matiere}</div>
                              <div className="flex gap-3 mt-1">
                                <span className="bg-purple-50 text-purple-700 px-2 py-0.5 rounded text-xs font-semibold">
                                  Stock: {parseFloat(pierre.quantite_disponible || 0).toFixed(4)} ct
                                </span>
                                {pierre.numero_certificat && (
                                  <span className="bg-yellow-50 text-yellow-700 px-2 py-0.5 rounded text-xs">Cert: {pierre.numero_certificat}</span>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Pierre sélectionnée : afficher infos + champs */}
                    {nouvellePierre.stock_id && (
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-2">
                        <div className="flex items-center justify-between mb-2">
                          <span className="text-sm font-bold text-blue-800">{nouvellePierre.reference_pierre} - {nouvellePierre.designation || nouvellePierre.type_pierre}</span>
                          <div className="flex gap-2">
                            <span className="bg-purple-100 text-purple-700 px-2 py-0.5 rounded text-xs font-bold">
                              Stock: {nouvellePierre.stock_disponible?.toFixed(4)} ct
                            </span>
                            {nouvellePierre.nb_pierres_dispo > 0 && (
                              <span className="bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs font-bold">
                                = {nouvellePierre.nb_pierres_dispo} pierres dispo
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="grid grid-cols-5 gap-2">
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">Nb pierres</label>
                            <input type="text" inputMode="decimal" onFocus={e => e.target.select()} min="1"
                              value={nouvellePierre.quantite}
                              onChange={e => setNouvellePierre(p => ({ ...p, quantite: parseInt(e.target.value) || 1 }))}
                              className="w-full px-2 py-1.5 border border-gray-200 rounded text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">Carats/pierre</label>
                            <input type="text" inputMode="decimal" onFocus={e => e.target.select()} step="0.0001" placeholder="0.0000"
                              value={nouvellePierre.poids_carats}
                              onChange={e => setNouvellePierre(p => ({ ...p, poids_carats: e.target.value }))}
                              className={`w-full px-2 py-1.5 border rounded text-sm ${
                                nouvellePierre.stock_disponible !== null && (parseFloat(nouvellePierre.poids_carats || 0) * (nouvellePierre.quantite || 1)) > nouvellePierre.stock_disponible
                                  ? 'border-red-500 bg-red-50' : 'border-gray-200'
                              }`} />
                            {/* Total carats */}
                            {nouvellePierre.poids_carats > 0 && (
                              <p className="text-xs text-purple-700 font-semibold mt-0.5">
                                Total: {(parseFloat(nouvellePierre.poids_carats || 0) * (nouvellePierre.quantite || 1)).toFixed(4)} ct
                              </p>
                            )}
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">Prix/ct (DH)</label>
                            <div className="bg-green-50 border border-green-300 rounded px-2 py-1.5 text-sm font-bold text-green-700">
                              {parseFloat(nouvellePierre.prix_achat_carat || 0).toFixed(2)}
                            </div>
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">Sertisseur</label>
                            <input type="text"
                              value={nouvellePierre.sertisseur}
                              onChange={e => setNouvellePierre(p => ({ ...p, sertisseur: e.target.value }))}
                              className="w-full px-2 py-1.5 border border-gray-200 rounded text-sm" />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">Observation</label>
                            <input type="text"
                              value={nouvellePierre.observation}
                              onChange={e => setNouvellePierre(p => ({ ...p, observation: e.target.value }))}
                              className="w-full px-2 py-1.5 border border-gray-200 rounded text-sm" />
                          </div>
                        </div>
                        {/* Alerte stock insuffisant */}
                        {nouvellePierre.stock_disponible !== null && (parseFloat(nouvellePierre.poids_carats || 0) * (nouvellePierre.quantite || 1)) > nouvellePierre.stock_disponible && (
                          <div className="mt-2 bg-red-100 text-red-700 text-xs font-semibold px-3 py-1.5 rounded">
                            Stock insuffisant ! Dispo: {nouvellePierre.stock_disponible?.toFixed(4)} ct, Demandé: {(parseFloat(nouvellePierre.poids_carats || 0) * (nouvellePierre.quantite || 1)).toFixed(4)} ct
                          </div>
                        )}
                        {/* Alerte stock OK */}
                        {nouvellePierre.stock_disponible !== null && nouvellePierre.poids_carats > 0 && (parseFloat(nouvellePierre.poids_carats || 0) * (nouvellePierre.quantite || 1)) <= nouvellePierre.stock_disponible && (
                          <div className="mt-2 bg-green-100 text-green-700 text-xs font-semibold px-3 py-1.5 rounded">
                            Stock OK - Restant après: {(nouvellePierre.stock_disponible - (parseFloat(nouvellePierre.poids_carats || 0) * (nouvellePierre.quantite || 1))).toFixed(4)} ct
                          </div>
                        )}
                      </div>
                    )}

                    <div className="flex space-x-2">
                      <button onClick={addPierre} disabled={!nouvellePierre.type_pierre}
                        className="px-4 py-1.5 bg-blue-500 text-white rounded text-sm font-medium hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed">Confirmer</button>
                      <button onClick={() => { setAjoutPierreOpen(false); setShowPierreSuggestions(false); }} className="px-4 py-1.5 bg-gray-200 text-gray-700 rounded text-sm hover:bg-gray-300">Annuler</button>
                    </div>
                  </div>
                )}

                {/* Liste des pierres */}
                {pierresOF.length === 0 ? (
                  <p className="text-sm text-gray-400 italic text-center py-4">Aucune pierre enregistrée</p>
                ) : (
                  <div className="space-y-2">
                    <div className="grid grid-cols-7 text-xs font-semibold text-gray-500 px-2 pb-1 border-b border-blue-100">
                      <span>Réf.</span><span>Type</span><span>Qté</span><span>Pds/pce (ct)</span><span>Total (ct)</span><span>Prix/ct</span><span></span>
                    </div>
                    {pierresOF.map(p => {
                      const qte = parseInt(p.quantite) || 1;
                      const pdsUnit = parseFloat(p.poids_carats) || 0;
                      const pdsTotal = pdsUnit * qte;
                      const prixCt = parseFloat(p.prix_achat_carat) || 0;
                      return (
                        <div key={p.id} className="grid grid-cols-7 items-center bg-white rounded-lg px-3 py-2 border border-blue-100 text-sm">
                          <span className="font-mono text-xs text-gray-500">{p.reference_pierre || '—'}</span>
                          <span className="font-semibold text-blue-700">{p.type_pierre}</span>
                          <span className="font-bold">{qte}</span>
                          <span>{pdsUnit ? `${pdsUnit.toFixed(4)} ct` : '—'}</span>
                          <span className="font-semibold text-blue-800">{pdsTotal ? `${pdsTotal.toFixed(4)} ct` : '—'}</span>
                          <span className="text-green-700">{prixCt ? `${prixCt.toFixed(2)} DH` : '—'}</span>
                          <button onClick={() => deletePierre(p.id)} className="justify-self-end p-1 text-red-400 hover:text-red-600 hover:bg-red-50 rounded">
                            <Trash2 className="h-4 w-4" />
                          </button>
                        </div>
                      );
                    })}
                    {/* Totaux */}
                    <div className="bg-blue-100 rounded-lg px-3 py-2 flex justify-between text-xs font-semibold text-blue-800 mt-1">
                      <span>{pierresOF.reduce((t, p) => t + (parseInt(p.quantite) || 1), 0)} pierres au total</span>
                      <span>{pierresOF.reduce((t, p) => t + (parseFloat(p.poids_carats) || 0) * (parseInt(p.quantite) || 1), 0).toFixed(4)} ct total</span>
                    </div>
                  </div>
                )}
              </div>

              {/* ── CHECKLIST QUALITÉ — générée depuis les étapes du devis ─── */}
              {selectedOrdre.etapes_devis && selectedOrdre.etapes_devis.length > 0 && (() => {
                // Checklist = toutes les étapes de production
                const etapesDevis = selectedOrdre.etapes_devis;
                // Enrichir avec l'état coché depuis of_checklist (par numero_etape ou id)
                const checkMap = {};
                checklist.forEach(c => { checkMap[c.numero_etape] = c; });
                const items = etapesDevis.map((e, i) => ({
                  id: e.id,
                  numero: e.numero_etape || (i + 1),
                  libelle: e.nom_etape,
                  statut: e.statut,
                  // Coché si terminée OU si la checklist l'a manuellement coché
                  checked: e.statut === 'terminee' || !!(checkMap[e.numero_etape || (i+1)]?.checked),
                  date_check: checkMap[e.numero_etape || (i+1)]?.date_check || e.date_fin,
                }));
                const nbChecked = items.filter(i => i.checked).length;
                const pct = items.length > 0 ? Math.round((nbChecked / items.length) * 100) : 0;
                return (
                  <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
                    <h4 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
                      <CheckCircle className="h-5 w-5 mr-2 text-green-500" />
                      Checklist qualité
                      <span className="ml-2 text-sm font-normal text-green-700">
                        {nbChecked}/{items.length} validés
                      </span>
                    </h4>
                    <div className="space-y-2">
                      {items.map((item, idx) => (
                        <label
                          key={idx}
                          className={`flex items-center space-x-3 p-3 rounded-lg cursor-pointer transition-colors ${
                            item.checked ? 'bg-green-100 border border-green-300' : 'bg-white border border-green-100 hover:bg-green-50'
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={item.checked}
                            onChange={() => {
                              // Seulement les étapes non-terminée (les terminées sont auto-cochées)
                              if (item.statut !== 'terminee') {
                                toggleChecklist(item.numero, item.checked);
                              }
                            }}
                            disabled={item.statut === 'terminee'}
                            className="w-5 h-5 rounded accent-green-600 cursor-pointer disabled:opacity-60"
                          />
                          <span className="text-gray-500 text-sm font-mono w-5">{item.numero}.</span>
                          <span className={`flex-1 text-sm font-medium ${item.checked ? 'text-green-800 line-through' : 'text-gray-700'}`}>
                            {item.libelle}
                          </span>
                          {item.statut === 'terminee' && (
                            <span className="text-xs bg-green-200 text-green-800 px-1.5 py-0.5 rounded">✓ Fait</span>
                          )}
                          {item.checked && item.date_check && (
                            <span className="text-xs text-green-600 flex-shrink-0">
                              {new Date(item.date_check).toLocaleDateString('fr-FR')}
                            </span>
                          )}
                        </label>
                      ))}
                      <div className="mt-3 flex items-center space-x-3">
                        <div className="flex-1 bg-gray-200 rounded-full h-2">
                          <div
                            className="h-2 rounded-full bg-green-500 transition-all"
                            style={{ width: `${pct}%` }}
                          />
                        </div>
                        <span className="text-sm font-bold text-green-700">{pct}%</span>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {/* Notes */}
              {selectedOrdre.notes && (
                <div className="bg-yellow-50 p-4 rounded-lg">
                  <h4 className="text-lg font-bold text-gray-800 mb-2 flex items-center">
                    <AlertCircle className="h-5 w-5 mr-2 text-yellow-600" />
                    Notes
                  </h4>
                  <div className="text-gray-700">{selectedOrdre.notes}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Terminer Étape */}
      {showTerminerModal && etapeATerminer && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-4 flex justify-between items-center sticky top-0">
              <div className="flex items-center space-x-3">
                <CheckCircle className="h-6 w-6" />
                <h3 className="text-xl font-bold">Terminer l'étape : {etapeATerminer.nom_etape}</h3>
              </div>
              <button
                onClick={() => setShowTerminerModal(false)}
                className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <form onSubmit={handleTerminerEtape} className="p-6 space-y-4">

              {/* ===== TEMPS DE TRAVAIL — EN PREMIER, BIEN VISIBLE ===== */}
              <div className="bg-green-50 p-4 rounded-lg border-2 border-green-400 space-y-3">
                <div className="text-base font-bold text-green-800">⏱️ Temps de travail</div>

                {/* Ligne 1 : Compteur automatique (lecture seule) */}
                <div className="flex items-center justify-between bg-white rounded-lg px-4 py-3 border border-green-200">
                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-wide">Compteur automatique</div>
                    <div className="text-xl font-bold text-blue-700">
                      {tempsReel ? minutesToHHMM(tempsReel) : '--'}
                      <span className="text-sm font-normal text-gray-400 ml-2">({tempsReel || 0} min)</span>
                    </div>
                  </div>
                  <div className="text-3xl">🕐</div>
                </div>

                {/* Ligne 2 : Temps réel (override) */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    ✏️ Temps réel (remplace le compteur) <span className="font-normal text-gray-400">(compteur oublié, journée mal fermée...)</span>
                  </label>
                  <div className="flex items-center space-x-3">
                    <input
                      type="number" inputMode="numeric" onFocus={e => e.target.select()}
                      step="1" min="0"
                      value={tempsCorrection}
                      onChange={(e) => setTempsCorrection(e.target.value)}
                      placeholder="0 = garder le compteur"
                      className="w-40 px-4 py-2 border-2 border-orange-300 rounded-lg focus:border-orange-500 focus:ring-2 focus:ring-orange-200 text-xl font-bold text-center"
                      autoFocus
                    />
                    <span className="text-gray-500 font-medium">min</span>
                    <span className="text-orange-600 font-semibold">
                      {parseFloat(tempsCorrection) > 0 ? `= ${minutesToHHMM(tempsCorrection)} (écrase le compteur)` : ''}
                    </span>
                  </div>
                </div>

                {/* Ligne 3 : Total final */}
                {(() => {
                  const overrideMin = parseFloat(tempsCorrection) || 0;
                  const totalMin = overrideMin > 0 ? overrideMin : (parseFloat(tempsReel) || 0);
                  const estMin = etapeATerminer.duree_estimee_heures ? parseFloat(etapeATerminer.duree_estimee_heures) * 60 : null;
                  const diffMin = estMin !== null ? Math.round(totalMin - estMin) : null;
                  return (
                    <div className="bg-green-700 text-white rounded-lg px-4 py-3 flex items-center justify-between">
                      <div>
                        <div className="text-xs opacity-75 uppercase tracking-wide">Total final envoyé</div>
                        <div className="text-2xl font-bold">{minutesToHHMM(totalMin)} <span className="text-sm font-normal opacity-75">({totalMin} min)</span></div>
                      </div>
                      {diffMin !== null && (
                        <div className={`text-sm font-semibold px-3 py-1 rounded-lg ${diffMin > 0 ? 'bg-red-400' : 'bg-green-500'}`}>
                          vs estimé {minutesToHHMM(estMin)}<br/>
                          Écart : {diffMin > 0 ? '+' : ''}{minutesToHHMM(Math.abs(diffMin))} {diffMin > 0 ? '⚠️' : '✅'}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>

              {/* Récapitulatif du devis — compact */}
              {selectedOrdre && (
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-3 rounded-lg border border-purple-200">
                  <div className="grid grid-cols-3 gap-3 text-xs">
                    <div>
                      <div className="text-gray-500">Type</div>
                      <div className="font-semibold">{selectedOrdre.ordre?.type_bijou || 'N/A'}</div>
                    </div>
                    <div>
                      <div className="text-gray-500">Métal</div>
                      <div className="font-semibold">{selectedOrdre.ordre?.metal || selectedOrdre.ordre?.couleur_or || 'N/A'}</div>
                    </div>
                    <div>
                      <div className="text-gray-500">Poids métal</div>
                      <div className="font-semibold text-amber-600">{selectedOrdre.ordre?.poids_metal ? `${selectedOrdre.ordre.poids_metal}g` : 'N/A'}</div>
                    </div>
                  </div>
                  {isAdmin() && selectedOrdre.ordre?.prix_devis && (
                    <div className="mt-2 text-xs text-gray-500">Prix devis : <strong className="text-green-700">{parseFloat(selectedOrdre.ordre.prix_devis).toLocaleString()} DH</strong></div>
                  )}
                </div>
              )}

              {/* §81 - Si etape avec_pierres : section dediee poids total bijou (or+pierres) */}
              {etapeATerminer?.avec_pierres && (
                <div className="bg-purple-50 p-4 rounded-lg border-2 border-purple-300 space-y-2">
                  <div className="text-base font-bold text-purple-900 flex items-center gap-2">
                    💎 Sertissage : pesee finale (or + pierres)
                  </div>
                  <div className="text-xs text-purple-700">
                    Or constant (inchange). Pierres ajoutees au bijou.
                    Saisir poids total mesure du bijou final.
                  </div>
                  <input type="number" step="0.001" min="0"
                         value={poidsTotalBijou}
                         onChange={e => setPoidsTotalBijou(e.target.value.replace(',', '.'))}
                         placeholder="Poids total bijou (or+pierres+poincon) en g"
                         className="w-full px-3 py-2 border-2 border-purple-400 rounded-lg text-lg font-bold text-center focus:ring-2 focus:ring-purple-500 outline-none" />
                  {(() => {
                    const orRow = matieresSelectionnees.find(m => m.selected && m._is_or);
                    const orDonneVal = orRow ? parseFloat(orRow.quantite) : null;
                    const total = parseFloat(poidsTotalBijou);
                    if (orDonneVal != null && !isNaN(total) && total > 0) {
                      const pierresG = total - orDonneVal;
                      return (
                        <div className="text-xs grid grid-cols-2 gap-2 mt-2 bg-white p-2 rounded">
                          <div>Or constant : <strong className="font-mono">{orDonneVal.toFixed(3)} g</strong></div>
                          <div>Pierres+poincon : <strong className={`font-mono ${pierresG < 0 ? 'text-red-600' : 'text-green-600'}`}>{pierresG > 0 ? '+' : ''}{pierresG.toFixed(3)} g</strong></div>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              )}

              {/* §82 Suivi or : 2 inputs editables (Or donne + Or recu) prefill cascade */}
              <div className="bg-amber-50 p-4 rounded-lg border-2 border-amber-300 space-y-2">
                <div className="text-base font-bold text-amber-900 flex items-center gap-2">
                  ⚖️ Suivi or
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-amber-800 mb-1">Or donné (g) {etapeATerminer?.poids_or_donne != null
                      ? <span className="text-emerald-700 italic font-normal">(saisi au démarrage)</span>
                      : <span className="text-gray-500 italic font-normal">(prerempli)</span>}</label>
                    <input type="number" step="0.001" min="0"
                           value={orDonneModal}
                           onChange={e => setOrDonneModal(e.target.value.replace(',', '.'))}
                           placeholder="Or remis ouvrier"
                           className="w-full px-3 py-2 border-2 border-amber-400 rounded-lg text-lg font-bold text-center focus:ring-2 focus:ring-amber-500 outline-none" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-amber-800 mb-1">Or reçu (g) <span className="text-red-500">*</span></label>
                    <input type="number" step="0.001" min="0"
                           value={poidsBijouApres}
                           onChange={e => setPoidsBijouApres(e.target.value.replace(',', '.'))}
                           placeholder="Pesee retour"
                           className="w-full px-3 py-2 border-2 border-amber-400 rounded-lg text-lg font-bold text-center focus:ring-2 focus:ring-amber-500 outline-none" />
                  </div>
                </div>
                {(() => {
                  const donne = parseFloat(orDonneModal);
                  const recu = parseFloat(poidsBijouApres);
                  if (!isNaN(donne) && !isNaN(recu) && donne > 0) {
                    const perte = donne - recu;
                    return (
                      <div className={`text-sm font-mono font-semibold ${perte > 0 ? 'text-red-600' : perte < 0 ? 'text-green-600' : 'text-gray-500'}`}>
                        {perte > 0 ? '⬇' : perte < 0 ? '⬆' : '='} Difference : {perte > 0 ? '-' : perte < 0 ? '+' : ''}{Math.abs(perte).toFixed(3)} g
                      </div>
                    );
                  }
                  return null;
                })()}
              </div>


              {/* Sélection des matières utilisées */}
              {selectedOrdre?.matieres?.length > 0 && (
                <div className="border-t pt-4">
                  <h4 className="font-bold text-gray-800 mb-3 flex items-center">
                    🥇 Matières utilisées (décompter du stock)
                  </h4>
                  <div className="space-y-2">
                    {matieresSelectionnees.map((matiere, index) => matiere._is_or ? null : (
                      <div key={index} className="flex items-center space-x-3 p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                        <input
                          type="checkbox"
                          checked={matiere.selected}
                          onChange={(e) => {
                            const updated = [...matieresSelectionnees];
                            updated[index].selected = e.target.checked;
                            setMatieresSelectionnees(updated);
                          }}
                          className="w-5 h-5 text-green-600"
                        />
                        <div className="flex-1">
                          <div className="font-semibold text-gray-800">{matiere.reference}</div>
                        </div>
                        <input
                          type="text" inputMode="decimal" onFocus={e => e.target.select()}
                          step="0.01"
                          value={matiere.quantite}
                          onChange={(e) => {
                            const updated = [...matieresSelectionnees];
                            updated[index].quantite = e.target.value;
                            setMatieresSelectionnees(updated);
                          }}
                          className="w-24 px-2 py-1 border rounded text-right"
                          placeholder="0.00"
                        />
                        <span className="text-sm text-gray-600">g</span>
                      </div>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-2">
                    💡 Cochez les matières utilisées et ajustez les quantités. Le stock sera décompté automatiquement.
                  </p>
                </div>
              )}

              {/* §88 - Section Pierres utilisees enrichie */}
              <div className="border-t pt-4">
                <h4 className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                  💎 Pierres utilisees (decompter du stock)
                </h4>
                <p className="text-xs text-gray-600 mb-2">
                  Cocher les pierres utilisees et ajuster Qte/Carats. Stock decompte automatique.
                </p>

                {pierresSelectionnees.length === 0 ? (
                  <p className="text-sm text-gray-500 italic">Aucune pierre prevue au devis (ajout manuel possible ci-dessous)</p>
                ) : (
                  <div className="space-y-2">
                    {pierresSelectionnees.map((pierre, index) => {
                      const totalCt = (parseFloat(pierre.poids_unitaire_carats) || 0) * (parseInt(pierre.nb_pierres) || 1);
                      return (
                        <div key={index} className="flex items-center gap-2 p-2 bg-purple-50 rounded-lg border border-purple-200 text-sm">
                          <input
                            type="checkbox"
                            checked={pierre.selected}
                            onChange={(e) => {
                              const updated = [...pierresSelectionnees];
                              updated[index].selected = e.target.checked;
                              setPierresSelectionnees(updated);
                            }}
                            className="w-4 h-4"
                          />
                          <div className="flex-1 min-w-0">
                            <div className="font-semibold text-gray-800 truncate">{pierre.type_pierre}</div>
                            <div className="text-xs text-gray-500 font-mono truncate">{pierre.reference}{pierre.taille_qualite ? ` · ${pierre.taille_qualite}` : ''}</div>
                          </div>
                          <span className="text-xs text-gray-500">Qte</span>
                          <input
                            type="number" min="0"
                            value={pierre.nb_pierres}
                            onChange={e => {
                              const updated = [...pierresSelectionnees];
                              updated[index].nb_pierres = parseInt(e.target.value) || 0;
                              updated[index].quantite = (parseFloat(updated[index].poids_unitaire_carats) || 0) * updated[index].nb_pierres;
                              setPierresSelectionnees(updated);
                            }}
                            disabled={!pierre.selected}
                            className="w-14 px-1 py-1 border rounded text-center"
                          />
                          <span className="text-xs text-gray-500">×</span>
                          <input
                            type="number" step="0.001" min="0"
                            value={pierre.poids_unitaire_carats}
                            onChange={e => {
                              const updated = [...pierresSelectionnees];
                              updated[index].poids_unitaire_carats = parseFloat(e.target.value) || 0;
                              updated[index].quantite = updated[index].poids_unitaire_carats * (parseInt(updated[index].nb_pierres) || 1);
                              setPierresSelectionnees(updated);
                            }}
                            disabled={!pierre.selected}
                            className="w-20 px-1 py-1 border rounded text-center"
                          />
                          <span className="text-xs text-gray-500">ct/pce</span>
                          <span className="text-xs text-purple-700 font-mono w-20 text-right">= {totalCt.toFixed(3)} ct</span>
                          {pierre.manuelle && (
                            <button type="button"
                                    onClick={() => setPierresSelectionnees(pierresSelectionnees.filter((_, i) => i !== index))}
                                    className="text-red-500 text-sm">✕</button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Ajout pierre manuelle */}
                <details className="mt-3">
                  <summary className="cursor-pointer text-sm text-purple-700 font-semibold hover:underline">
                    + Pierre manuelle (hors devis)
                  </summary>
                  <div className="mt-2 grid grid-cols-12 gap-2 p-2 bg-orange-50 rounded border border-orange-200 text-sm">
                    <input type="text" placeholder="Type pierre (ex: DIAMANT)"
                           value={pierreManuelle.type_pierre}
                           onChange={e => setPierreManuelle({ ...pierreManuelle, type_pierre: e.target.value })}
                           className="col-span-5 px-2 py-1 border rounded" />
                    <input type="number" min="1" placeholder="Qte"
                           value={pierreManuelle.quantite}
                           onChange={e => setPierreManuelle({ ...pierreManuelle, quantite: parseInt(e.target.value) || 1 })}
                           className="col-span-2 px-2 py-1 border rounded text-center" />
                    <input type="number" step="0.001" min="0" placeholder="ct/pce"
                           value={pierreManuelle.poids_unitaire_carats}
                           onChange={e => setPierreManuelle({ ...pierreManuelle, poids_unitaire_carats: parseFloat(e.target.value) || 0 })}
                           className="col-span-3 px-2 py-1 border rounded text-center" />
                    <button type="button"
                            onClick={() => {
                              if (!pierreManuelle.type_pierre.trim()) return;
                              const totalCt = (pierreManuelle.poids_unitaire_carats || 0) * (pierreManuelle.quantite || 1);
                              setPierresSelectionnees([
                                ...pierresSelectionnees,
                                {
                                  pierre_id: null,
                                  reference: 'MANUEL',
                                  type_pierre: pierreManuelle.type_pierre.trim(),
                                  nb_pierres: pierreManuelle.quantite || 1,
                                  poids_unitaire_carats: pierreManuelle.poids_unitaire_carats || 0,
                                  quantite: totalCt,
                                  selected: true,
                                  manuelle: true
                                }
                              ]);
                              setPierreManuelle({ type_pierre: '', quantite: 1, poids_unitaire_carats: 0 });
                            }}
                            className="col-span-2 px-2 py-1 bg-orange-500 hover:bg-orange-600 text-white rounded text-sm">
                      Ajouter
                    </button>
                  </div>
                </details>

                {/* Recap total */}
                {pierresSelectionnees.filter(p => p.selected).length > 0 && (
                  <div className="mt-3 text-xs bg-purple-100 p-2 rounded font-mono">
                    Total selectionnees : {pierresSelectionnees
                      .filter(p => p.selected)
                      .reduce((sum, p) => sum + (parseFloat(p.poids_unitaire_carats) || 0) * (parseInt(p.nb_pierres) || 1), 0)
                      .toFixed(3)} ct
                  </div>
                )}
              </div>

              <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <p className="text-sm text-amber-800">
                  💡 <strong>Info :</strong> Saisissez le nombre d'heures réellement passées sur cette étape. 
                  Ce temps sera utilisé pour calculer le coût réel de fabrication.
                </p>
              </div>

              <div className="flex space-x-3 pt-4 border-t">
                <button
                  type="submit"
                  className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 font-semibold shadow-md transition-all flex items-center justify-center space-x-2"
                >
                  <Save className="h-5 w-5" />
                  <span>Terminer l'étape</span>
                </button>
                <button
                  type="button"
                  onClick={() => setShowTerminerModal(false)}
                  className="px-6 py-3 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 font-semibold transition-all"
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* "Proposer l'étape suivante" — modale non bloquante (18/06/2026) */}
      {showEnchainerModal && etapeSuivante && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl w-full max-w-md shadow-2xl">
            <div className="px-6 py-4 border-b">
              <h3 className="text-lg font-bold text-gray-900">Enchaîner sur l'étape suivante ?</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Étape #{etapeSuivante.numero_etape} — <span className="font-medium text-gray-700">{etapeSuivante.nom_etape}</span>
              </p>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Ouvrier</label>
                <select
                  value={enchainerOuvrierId}
                  onChange={(e) => setEnchainerOuvrierId(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Choisir un ouvrier…</option>
                  {ouvriersDisponibles.map(ouv => (
                    <option key={ouv.id} value={ouv.id}>
                      {ouv.prenom} {ouv.nom}{ouv.specialite ? ` - ${ouv.specialite}` : ''}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Poids or début (g) <span className="text-gray-400 font-normal">— optionnel</span></label>
                <input
                  type="text" inputMode="decimal" onFocus={e => e.target.select()}
                  value={enchainerPoids}
                  onChange={(e) => setEnchainerPoids(e.target.value.replace(',', '.'))}
                  placeholder="laisser vide si inconnu"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            <div className="px-6 py-4 border-t flex gap-3">
              <button
                type="button"
                disabled={enchainerBusy}
                onClick={lancerEtapeSuivante}
                className="flex-1 px-4 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold disabled:opacity-50 transition-all"
              >
                {enchainerBusy ? 'Lancement…' : 'Lancer'}
              </button>
              <button
                type="button"
                disabled={enchainerBusy}
                onClick={fermerEnchainer}
                className="px-4 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-semibold transition-all"
              >
                Plus tard
              </button>
            </div>
          </div>
        </div>
      )}
        </>
      )}

      {/* §95 Onglet Suivi Ouvriers Production retire - acces via /ouvriers */}

      {/* Onglet Suivi Fiche Chef */}
      {activeTab === 'suivi-fiche' && <SuiviFicheChef />}

      {/* §95 Onglet Gestion equipe retire - acces via /ouvriers "Liste des Ouvriers" */}

      {/* §95 Onglet Coffres Ouvriers retire - acces via /ouvriers "Coffres & Stock" */}

      {/* Modal Commande Production Client */}
      {showModalDevis && (
        <CommandeProductionClient
          onClose={() => setShowModalDevis(false)}
          onLancerProduction={() => {
            loadData();
          }}
        />
      )}

      {/* Modal Fiche de Fabrication */}
      {showFicheFabrication && selectedOrdre && (
        <FicheFabricationV2
          ordre={selectedOrdre}
          imagePrincipale={imagePrincipale}
          onClose={() => setShowFicheFabrication(false)}
        />
      )}

      {/* Modal Fiche Bijou Terminé */}
      {showFicheBijouTermine && selectedOrdre && (
        <FicheBijouTermine
          ordre={selectedOrdre}
          imagePrincipale={imagePrincipale}
          bijouLie={bijouLie}
          pierresOf={pierresOF}
          onClose={() => setShowFicheBijouTermine(false)}
        />
      )}

      {/* [Patch 48 / Mission A] Modal Etape ad-hoc */}
      {showAdhocModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="bg-gradient-to-r from-purple-500 to-purple-600 text-white px-6 py-4 rounded-t-lg flex justify-between items-center">
              <div>
                <h3 className="text-lg font-bold">+ Etape ad-hoc (hors devis)</h3>
                <p className="text-purple-100 text-sm">Numerotee a la suite, marquee in_devis=0</p>
              </div>
              <button onClick={() => setShowAdhocModal(false)} className="text-white hover:text-purple-200">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nom de l'etape <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  autoFocus
                  value={adhocForm.nom_etape}
                  onChange={(e) => setAdhocForm({ ...adhocForm, nom_etape: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-purple-500"
                  placeholder="Ex: Reprise polissage"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Type de ressource</label>
                <div className="flex gap-3">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      checked={adhocForm.type_ressource === 'interne'}
                      onChange={() => setAdhocForm({ ...adhocForm, type_ressource: 'interne' })}
                    />
                    <span className="text-sm">🏭 Interne</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      checked={adhocForm.type_ressource === 'externe'}
                      onChange={() => setAdhocForm({ ...adhocForm, type_ressource: 'externe' })}
                    />
                    <span className="text-sm">🔗 Externe</span>
                  </label>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Duree estimee (heures)</label>
                <input
                  type="number"
                  min="0.5"
                  step="0.5"
                  value={adhocForm.duree_estimee_heures}
                  onChange={(e) => setAdhocForm({ ...adhocForm, duree_estimee_heures: parseFloat(e.target.value) || 1 })}
                  className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-purple-500"
                />
              </div>
            </div>
            <div className="bg-gray-50 px-6 py-4 rounded-b-lg flex justify-end gap-2">
              <button
                onClick={() => setShowAdhocModal(false)}
                disabled={adhocSaving}
                className="px-4 py-2 text-gray-700 hover:bg-gray-200 rounded transition-colors"
              >
                Annuler
              </button>
              <button
                disabled={adhocSaving || !adhocForm.nom_etape.trim()}
                onClick={async () => {
                  const ordreId = selectedOrdre?.ordre?.id || selectedOrdre?.id;
                  if (!ordreId) return;
                  setAdhocSaving(true);
                  try {
                    const res = await api.post(`${API_URL}/atelier/ordres-fabrication/${ordreId}/etapes-adhoc`, {
                      nom_etape: adhocForm.nom_etape.trim(),
                      type_ressource: adhocForm.type_ressource,
                      duree_estimee_heures: adhocForm.duree_estimee_heures,
                    });
                    const d = res.data || {};
                    alert(`Etape #${d.numero_etape} "${d.nom_etape}" ajoutee`);
                    setShowAdhocModal(false);
                    loadOrdreDetails(ordreId);
                    loadData();
                  } catch (err) {
                    const code = err?.response?.status;
                    const data = err?.response?.data || {};
                    let msg = data.error || data.message || 'Erreur ajout etape';
                    if (code === 403) msg = 'Permission refusee (admin/chef_atelier requis)';
                    else if (code === 404) msg = 'OF introuvable';
                    else if (code === 400) msg = data.error || 'Donnees invalides';
                    else if (code === 409) msg = 'Conflit numero_etape, reessayez';
                    alert(msg);
                  } finally {
                    setAdhocSaving(false);
                  }
                }}
                className="px-4 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-300 text-white rounded transition-colors"
              >
                {adhocSaving ? 'Ajout...' : '+ Confirmer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal modification OF avant lancement */}
      {editOrdre && (
        <EditOrdreModal
          ordre={editOrdre}
          onClose={() => setEditOrdre(null)}
          onSaved={(updatedOrdre) => {
            setOrdres(prev => prev.map(o => o.id === updatedOrdre.id ? { ...o, ...updatedOrdre } : o));
            setEditOrdre(null);
          }}
        />
      )}

      {/* Modal Réception Externe */}
      {showModalReception && etapeReception && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-4 rounded-t-lg flex justify-between items-center">
              <div>
                <h3 className="text-lg font-bold">📥 Réception prestataire</h3>
                <p className="text-orange-100 text-sm">{etapeReception.nom_etape}</p>
              </div>
              <button onClick={() => setShowModalReception(false)} className="text-white hover:text-orange-200">✕</button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Prix réel facturé (MAD) <span className="text-gray-400 text-xs">optionnel</span>
                </label>
                <input
                  type="number" step="0.01" min="0"
                  value={formReception.prix_reel_externe}
                  onChange={e => setFormReception(f => ({ ...f, prix_reel_externe: e.target.value }))}
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-300 outline-none"
                  placeholder={`Estimé: ${etapeReception.prix_unitaire || 0} MAD`}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Poids or retourné (g) <span className="text-gray-400 text-xs">optionnel</span>
                </label>
                <input
                  type="number" step="0.001" min="0"
                  value={formReception.poids_or_recu_externe}
                  onChange={e => setFormReception(f => ({ ...f, poids_or_recu_externe: e.target.value }))}
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-orange-300 outline-none"
                  placeholder="Ex: 9.800 g"
                />
              </div>
              {etapeReception.date_envoi_externe && (
                <div className="bg-orange-50 rounded-lg px-3 py-2 text-xs text-orange-700">
                  📤 Envoyé le {new Date(etapeReception.date_envoi_externe).toLocaleDateString('fr-FR')}
                </div>
              )}
            </div>
            <div className="px-6 pb-6 flex gap-3">
              <button onClick={() => setShowModalReception(false)}
                className="flex-1 py-2 border border-gray-300 rounded-lg text-gray-700 text-sm hover:bg-gray-50">
                Annuler
              </button>
              <button onClick={validerReception}
                className="flex-1 py-2 bg-green-600 text-white rounded-lg text-sm font-semibold hover:bg-green-700 flex items-center justify-center gap-2">
                <CheckCircle className="h-4 w-4" />
                Valider la réception
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Hotfix : modal partage finalisation OF */}
      {showControleFinalModal && controleFinalOfId && (
        <ControleFinalModal
          ofId={controleFinalOfId}
          isAdmin={isAdmin?.()}
          onClose={() => { setShowControleFinalModal(false); setControleFinalOfId(null); }}
          onSuccess={() => { setShowDetailModal(false); loadData(); }}
        />
      )}

      {/* §84 - Modal §79 supprime, pierres maintenant editees inline dans carte etape */}

      {/* §104 - Modal picker stock pierres */}
      {stockPickerEtapeId !== null && (() => {
        const search = (stockPickerSearch || '').toLowerCase().trim();
        const filtered = stockPierresList.filter(s => {
          if (!search) return true;
          const text = [s.reference, s.designation, s.type_matiere, s.taille_qualite, s.numero_certificat]
            .filter(Boolean).join(' ').toLowerCase();
          return text.includes(search);
        });
        return (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
               onClick={() => setStockPickerEtapeId(null)}>
            <div className="bg-white rounded-lg shadow-xl max-w-3xl w-full max-h-[80vh] flex flex-col"
                 onClick={e => e.stopPropagation()}>
              <div className="flex items-center justify-between p-3 border-b border-gray-200">
                <h3 className="text-base font-bold text-purple-900">📦 Ajouter pierre depuis stock</h3>
                <button onClick={() => setStockPickerEtapeId(null)}
                        className="text-gray-400 hover:text-gray-600 text-xl leading-none">✕</button>
              </div>
              <div className="p-3 border-b border-gray-100">
                <input type="text" autoFocus value={stockPickerSearch}
                       onChange={e => setStockPickerSearch(e.target.value)}
                       placeholder="Rechercher reference, designation, type, qualite, certificat..."
                       className="w-full px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-purple-500" />
              </div>
              <div className="flex-1 overflow-auto p-2">
                {stockPickerLoading && <div className="text-center py-8 text-gray-500">Chargement stock pierres...</div>}
                {!stockPickerLoading && filtered.length === 0 && (
                  <div className="text-center py-8 text-gray-500 italic">
                    {stockPierresList.length === 0
                      ? 'Aucune pierre en stock disponible.'
                      : 'Aucun resultat pour cette recherche.'}
                  </div>
                )}
                {!stockPickerLoading && filtered.length > 0 && (
                  <table className="w-full text-xs">
                    <thead className="bg-purple-50 sticky top-0">
                      <tr>
                        <th className="px-2 py-1 text-left font-semibold text-purple-900">Reference</th>
                        <th className="px-2 py-1 text-left font-semibold text-purple-900">Designation</th>
                        <th className="px-2 py-1 text-left font-semibold text-purple-900">Type</th>
                        <th className="px-2 py-1 text-left font-semibold text-purple-900">Qualite</th>
                        <th className="px-2 py-1 text-right font-semibold text-purple-900">Dispo</th>
                        <th className="px-2 py-1 text-right font-semibold text-purple-900">Prix/ct</th>
                        <th className="px-2 py-1"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {filtered.map(s => (
                        <tr key={s.id} className="border-t border-gray-100 hover:bg-purple-50">
                          <td className="px-2 py-1 font-mono text-[11px]">{s.reference}</td>
                          <td className="px-2 py-1">{s.designation || '—'}</td>
                          <td className="px-2 py-1 text-gray-600">{s.type_matiere || '—'}</td>
                          <td className="px-2 py-1 text-gray-600 text-[10px]">{s.taille_qualite || '—'}</td>
                          <td className="px-2 py-1 text-right font-mono">{parseFloat(s.quantite_disponible || 0).toFixed(3)}</td>
                          <td className="px-2 py-1 text-right font-mono">{s.prix_achat_carat ? parseFloat(s.prix_achat_carat).toFixed(0) : '—'}</td>
                          <td className="px-2 py-1">
                            <button onClick={() => ajouterPierreStock(stockPickerEtapeId, s)}
                                    className="px-2 py-0.5 bg-purple-600 hover:bg-purple-700 text-white rounded text-[11px] font-semibold">
                              + Ajouter
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="p-2 border-t border-gray-200 bg-gray-50 text-[11px] text-gray-600">
                {filtered.length} pierre(s) affichee(s) sur {stockPierresList.length} en stock.
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}

export default Atelier;
